module.exports = {
	"adobe": [
		[
			"Vanguard Institutional 500 Index Trust",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			537299211,
			0.09174523974228109,
			49294644.926533476,
			0,
			0,
			0.09174523974228109,
			49294644.926533476
		],
		[
			"Vanguard Target Retirement 2045 Trust Plus",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			287324246,
			0.0758893350582794,
			21804845.975061495,
			0.004623421317086152,
			1328421.0438721057,
			0.08051275637536555,
			23133267.0189336
		],
		[
			"Vanguard Target Retirement 2040 Trust Plus",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			267359955,
			0.06823506026662908,
			18243322.64230824,
			0.007062568740663622,
			1888248.0606882328,
			0.0752976290072927,
			20131570.70299647
		],
		[
			"Vanguard Target Retirement 2035 Trust Plus",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			255641126,
			0.06116514924323183,
			15636327.624497833,
			0.00930723295448306,
			2379311.5124283563,
			0.0704723821977149,
			18015639.13692619
		],
		[
			"Vanguard Target Retirement 2050 Trust Plus",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			254252354,
			0.08024700579457168,
			20402990.12472149,
			0.003268008966211633,
			830898.9725524142,
			0.08351501476078331,
			21233889.097273905
		],
		[
			"Vanguard Extended Market Index Fund; Inst'l Plus Shares",
			"VEMPX",
			"FSUSA002PR",
			"F00000JXVS",
			194577445,
			0.06544225035826598,
			12733585.86976173,
			0,
			0,
			0.06544225035826598,
			12733585.86976173
		],
		[
			"Vanguard FTSE All-World ex-US Index Fund: Inst'l Plus Shares",
			"VFWSX",
			"FSUSA07YWA",
			"FOUSA06B5B",
			189852570,
			0.1030830690230197,
			19570585.57750768,
			0,
			0,
			0.1030830690230197,
			19570585.57750768
		],
		[
			"Vanguard Target Retirement 2030 Trust Plus",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			167843577,
			0.05426274087980579,
			9107652.52709073,
			0.011496230679006621,
			1929568.47918161,
			0.06575897155881241,
			11037221.00627234
		],
		[
			"Vanguard Institutional Total Bond Market Index Trust",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			147105269,
			0,
			0,
			0.04136148656372853,
			6084492.607197171,
			0.04136148656372853,
			6084492.607197171
		],
		[
			"Vanguard Target Retirement 2055 Trust Plus",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			142382413,
			0.08032666379393759,
			11437104.21922057,
			0.00326181821755119,
			464425.54858229734,
			0.08358848201148877,
			11901529.767802866
		],
		[
			"Vanguard U.S. Growth Fund Admiral Shares",
			"VWUAX",
			"FSUSA002RC",
			"FOUSA02TIF",
			141940372,
			0.011239168347091618,
			1595291.7361568094,
			0,
			0,
			0.011239168347091618,
			1595291.7361568094
		],
		[
			"Vanguard Wellington Fund Admiral Shares",
			"VWENX",
			"FSUSA002SA",
			"FOUSA02T18",
			132091332,
			0.0773361686721528,
			10215437.531681335,
			0.041343049707700606,
			5461058.504832384,
			0.1186792183798534,
			15676496.03651372
		],
		[
			"DFA US Small Cap Value Portfolio Inst'l Class",
			"DFSVX",
			"FSUSA000K8",
			"FOUSA00C2O",
			112968935,
			0.09200040093616921,
			10393187.313332038,
			0,
			0,
			0.09200040093616921,
			10393187.313332038
		],
		[
			"Vanguard Target Retirement 2025 Trust Plus",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			106017082,
			0.04647789761877514,
			4927451.083037289,
			0.012926504408448546,
			1370430.277843851,
			0.059404402027223684,
			6297881.3608811395
		],
		[
			"Vanguard Retirement Savings Trust III",
			"~",
			"~",
			"~",
			65543654,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Windsor II Fund Admiral Shares",
			"VWNAX",
			"FSUSA002SF",
			"FOUSA02T2O",
			63932461,
			0.07000661552520242,
			4475695.2168069985,
			0,
			0,
			0.07000661552520242,
			4475695.2168069985
		],
		[
			"Vanguard FTSE Social Index Fund Institutional Shares",
			"VFTNX",
			"FSUSA003PD",
			"FOUSA02SNF",
			59661949,
			0.003717931470108064,
			221819.03775508233,
			0,
			0,
			0.003717931470108064,
			221819.03775508233
		],
		[
			"Vanguard Explorer Fund Admiral Shares",
			"VEXRX",
			"FSUSA000PQ",
			"FOUSA02TY5",
			57734936,
			0.04493826310961819,
			2594507.744584967,
			0,
			0,
			0.04493826310961819,
			2594507.744584967
		],
		[
			"Vanguard Target Retirement 2060 Trust Plus",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			55489153,
			0.08036342163620322,
			4459298.19877479,
			0.0032255517799972596,
			178983.13622969028,
			0.08358897341620047,
			4638281.335004481
		],
		[
			"Dodge & Cox International Stock Fund",
			"DODFX",
			"FSUSA0096D",
			"FOUSA02TGA",
			53225430,
			0.10073749418465221,
			5361796.445100613,
			0,
			0,
			0.10073749418465221,
			5361796.445100613
		],
		[
			"PIMCO Total Return Fund; Institutional Class",
			"PTTRX",
			"FSUSA001ZG",
			"FOUSA00EH4",
			32122762,
			0,
			0,
			0.012424118201873642,
			399096.99205865496,
			0.012424118201873642,
			399096.99205865496
		],
		[
			"Vanguard Target Retirement 2020 Trust Plus",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			26957174,
			0.035230489202590476,
			949714.4275393527,
			0.014566823354659747,
			392680.3917988265,
			0.04979731255725022,
			1342394.8193381792
		],
		[
			"Vanguard Inflation-Protected Securities Fund: Inst'l Shares",
			"VIPIX",
			"FSUSA004EW",
			"FOUSA04BL6",
			25883915,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Vanguard Target Retirement 2015 Trust Plus",
			"~",
			"~",
			"FOUSA04B97",
			9178258,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement Income Trust Plus",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			7698865,
			0.02420873589822837,
			186379.78950111396,
			0.016543257559609954,
			127364.30661166648,
			0.04075199345783832,
			313744.09611278045
		],
		[
			"Vanguard Target Retirement 2065 Trust Plus",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			6189129,
			0.08019566005615357,
			496341.2853276817,
			0.0031660668875217067,
			19595.196389500332,
			0.08336172694367527,
			515936.48171718203
		],
		[
			"Vanguard Federal Money Market Fund",
			"~",
			"~",
			"~",
			2055964,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"airbnb": [
		[
			"Fidelity 500 Index Fund",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			94806989,
			0.09162563971314869,
			8686751.016402451,
			0,
			0,
			0.09162563971314869,
			8686751.016402451
		],
		[
			"Vanguard Institutional Target Retirement 2050 Fund",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			69430049,
			0.08024700579457168,
			5571553.544420396,
			0.003268008966211633,
			226898.02265651303,
			0.08351501476078331,
			5798451.567076909
		],
		[
			"Vanguard Institutional Target Retirement 2055 Fund",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			66383372,
			0.08032666379393759,
			5332354.80415189,
			0.00326181821755119,
			216530.49213207758,
			0.08358848201148877,
			5548885.296283968
		],
		[
			"Vanguard Institutional Target Retirement 2045 Fund",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			49625909,
			0.0758893350582794,
			3766077.235672683,
			0.004623421317086152,
			229441.48555037755,
			0.08051275637536555,
			3995518.7212230605
		],
		[
			"T. Rowe Price Blue Chip Growth Fund I",
			"TBCIX",
			"FSUSA0020C",
			"F00000WMWX",
			31028549,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Vanguard Institutional Target Retirement 2040 Fund",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			24747160,
			0.06823506026662908,
			1688623.9540279126,
			0.007062568740663622,
			174778.51863620116,
			0.0752976290072927,
			1863402.4726641136
		],
		[
			"Vanguard Institutional Target Retirement 2060 Fund",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			15490989,
			0.08036342163620322,
			1244908.880568786,
			0.0032255517799972596,
			49966.98714286797,
			0.08358897341620047,
			1294875.867711654
		],
		[
			"Fidelity Mid Cap Index Fund",
			"FSMDX",
			"FSUSA0BGZB",
			"F00000MJRP",
			15410250,
			0.10367535191096297,
			1597663.091785917,
			0,
			0,
			0.10367535191096297,
			1597663.091785917
		],
		[
			"Fidelity Small Cap Index Fund",
			"FSSNX",
			"FSUSA0BGZD",
			"F00000MJRV",
			14081025,
			0.086306010873582,
			1215277.09676118,
			0,
			0,
			0.086306010873582,
			1215277.09676118
		],
		[
			"Fidelity International Index Fund",
			"FSPSX",
			"FSUSA004DM",
			"F00000MJRM",
			13223632,
			0.09446078993825728,
			1249114.724572817,
			0,
			0,
			0.09446078993825728,
			1249114.724572817
		],
		[
			"Vanguard Institutional Target Retirement 2035 Fund",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			11218261,
			0.06116514924323183,
			686166.6083145272,
			0.00930723295448306,
			104410.9684711921,
			0.0704723821977149,
			790577.5767857193
		],
		[
			"T. Rowe Price Mid-Cap Growth Fund I",
			"RPTIX",
			"FSUSA00216",
			"F00000VWMV",
			8363880,
			0.0379752064710997,
			317620.06989950134,
			0,
			0,
			0.0379752064710997,
			317620.06989950134
		],
		[
			"Fidelity U.S. Bond Index Fund",
			"FXNAX",
			"FSUSA000VD",
			"F00000LZX3",
			7569344,
			0,
			0,
			0.03886106613218048,
			294152.77776122355,
			0.03886106613218048,
			294152.77776122355
		],
		[
			"Metropolitan West Total Return Bond Fund I",
			"MWTIX",
			"FSUSA003M1",
			"FOUSA00H9T",
			5311913,
			0,
			0,
			0.01732500428117021,
			92028.91546620369,
			0.01732500428117021,
			92028.91546620369
		],
		[
			"Vanguard Institutional Target Retirement 2030 Fund",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			5204251,
			0.05426274087980579,
			282396.9234864701,
			0.011496230679006621,
			59829.27000745089,
			0.06575897155881241,
			342226.193493921
		],
		[
			"Fidelity Real Estate Index Fund",
			"FSRNX",
			"FSUSA0BGZC",
			"F00000MJRT",
			4454035,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity Government Money Market Fund K6",
			"~",
			"~",
			"~",
			3574059,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"JPMorgan Value Advantage Fund R6",
			"JVAYX",
			"FSUSA069IM",
			"F00000XEEK",
			3447921,
			0.1434763269410235,
			494695.0406628207,
			0,
			0,
			0.1434763269410235,
			494695.0406628207
		],
		[
			"Fidelity Emerging Markets Index Fund",
			"FKEMX",
			"FSUSA000T0",
			"FOUSA06TXM",
			3263274,
			0.048450068480840824,
			158105.84877174735,
			0,
			0,
			0.048450068480840824,
			158105.84877174735
		],
		[
			"Vanguard Institutional Target Retirement 2065 Fund",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			2818904,
			0.08019566005615357,
			226063.8669149315,
			0.0031660668875217067,
			8924.838613502488,
			0.08336172694367527,
			234988.705528434
		],
		[
			"Vanguard Institutional Target Retirement 2020 Fund",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			2517172,
			0.035230489202590476,
			88681.20096706308,
			0.014566823354659747,
			36667.199877295585,
			0.04979731255725022,
			125348.40084435866
		],
		[
			"American Funds EuroPacific Growth Fund R6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			2451343,
			0.10771126450519944,
			264037.2542659691,
			0,
			0,
			0.10771126450519944,
			264037.2542659691
		],
		[
			"Vanguard Institutional Target Retirement 2025 Fund",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			2335483,
			0.04647789761877514,
			108548.33976438982,
			0.012926504408448546,
			30189.631295356634,
			0.059404402027223684,
			138737.97105974646
		],
		[
			"Vanguard Institutional Target Retirement Income Fund",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			2015937,
			0.02420873589822837,
			48803.2864204668,
			0.016543257559609954,
			33350.165014947415,
			0.04075199345783832,
			82153.45143541422
		],
		[
			"Undiscovered Managers Behavioral Value Fund R6",
			"UBVFX",
			"FSUSA003MN",
			"F00000PJJE",
			1698348,
			0.10853011557329717,
			184321.9047236781,
			0,
			0,
			0.10853011557329717,
			184321.9047236781
		],
		[
			"Invesco Oppenheimer Developing Markets Fund Class R6",
			"ODVIX",
			"FSUSA003HS",
			"F00000NB29",
			1566325,
			0.032453357367792326,
			50832.50497910732,
			0,
			0,
			0.032453357367792326,
			50832.50497910732
		],
		[
			"Vanguard Institutional Target Retirement 2015 Fund",
			"~",
			"~",
			"FOUSA04B97",
			227127,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"amazon-com": [
		[
			"AMAZON.COM STOCK",
			"~",
			"~",
			"~",
			2351265000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"VANGUARD TARGET 2050",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			1916414000,
			0.08024700579457168,
			153786485.3627983,
			0.003268008966211633,
			6262858.134973501,
			0.08351501476078331,
			160049343.4977718
		],
		[
			"VANG INST 500 IDX TR",
			"VFFSX",
			"FSUSA002QH",
			"F00000WTNP",
			1870382000,
			0.09174523974228109,
			171598644.9996472,
			0,
			0,
			0.09174523974228109,
			171598644.9996472
		],
		[
			"VANGUARD TARGET 2055",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			1730609000,
			0.08032666379393759,
			139014047.30176255,
			0.00326181821755119,
			5644931.963658047,
			0.08358848201148877,
			144658979.2654206
		],
		[
			"VANGUARD TARGET 2045",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			1643382000,
			0.0758893350582794,
			124715167.2267453,
			0.004623421317086152,
			7598047.370915676,
			0.08051275637536555,
			132313214.59766099
		],
		[
			"VANGUARD TARGET 2040",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			1191286000,
			0.06823506026662908,
			81287472.00479148,
			0.007062568740663622,
			8413539.264790203,
			0.0752976290072927,
			89701011.26958169
		],
		[
			"SSGA LG CAP GROWTH",
			"VRGWX",
			"FSUSA0AXVO",
			"F00000J3K7",
			923676000,
			0.014257426913167677,
			13169243.061447067,
			0,
			0,
			0.014257426913167677,
			13169243.061447067
		],
		[
			"VANGUARD TARGET 2035",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			921635000,
			0.06116514924323183,
			56371942.32278597,
			0.00930723295448306,
			8577871.644004995,
			0.0704723821977149,
			64949813.96679097
		],
		[
			"VANGUARD TARGET 2060",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			907053000,
			0.08036342163620322,
			72893882.68538304,
			0.0032255517799972596,
			2925746.4187018545,
			0.08358897341620047,
			75819629.1040849
		],
		[
			"VANGUARD TARGET 2030",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			563059000,
			0.05426274087980579,
			30553124.617042568,
			0.011496230679006621,
			6473056.149890789,
			0.06575897155881241,
			37026180.76693336
		],
		[
			"VANG FTSE SOC IDX IS",
			"VFTNX",
			"FSUSA003PD",
			"FOUSA02SNF",
			433429000,
			0.003717931470108064,
			1611459.319157468,
			0,
			0,
			0.003717931470108064,
			1611459.319157468
		],
		[
			"VANG EXPLORER ADM",
			"VEXRX",
			"FSUSA000PQ",
			"FOUSA02TY5",
			428266000,
			0.04493826310961819,
			19245530.18890374,
			0,
			0,
			0.04493826310961819,
			19245530.18890374
		],
		[
			"VG IS TL INTL STK MK",
			"VTSNX",
			"FSUSA004JJ",
			"F00000JTBU",
			356098000,
			0.09782558128881824,
			34835493.845785595,
			0,
			0,
			0.09782558128881824,
			34835493.845785595
		],
		[
			"VANGUARD TARGET 2025",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			322090000,
			0.04647789761877514,
			14970066.044031285,
			0.012926504408448546,
			4163497.804917192,
			0.059404402027223684,
			19133563.84894848
		],
		[
			"VANG RET SVNG TR II",
			"~",
			"~",
			"~",
			275590000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"VANGUARD TARGET 2065",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			261901000,
			0.08019566005615357,
			21003323.564366676,
			0.0031660668875217067,
			829196.0839088225,
			0.08336172694367527,
			21832519.6482755
		],
		[
			"VG IS TOT BD MKT IDX",
			"VBTIX",
			"FSUSA002PJ",
			"FOUSA00DIL",
			233047000,
			0,
			0,
			0.04136148656372853,
			9639170.359217243,
			0.04136148656372853,
			9639170.359217243
		],
		[
			"SSGA LG CAP VALUE",
			"VRVIX",
			"FSUSA0AXVN",
			"F00000J3KB",
			206409000,
			0.168348713667367,
			34748689.63936756,
			0,
			0,
			0.168348713667367,
			34748689.63936756
		],
		[
			"ABF SM CAP VALUE R6",
			"AASRX",
			"FSUSA004F4",
			"F00000YDJB",
			191251000,
			0.09657446583105811,
			18469963.164655693,
			0,
			0,
			0.09657446583105811,
			18469963.164655693
		],
		[
			"PIMCO TOTAL RTN II",
			"PMBIX",
			"FSUSA001YE",
			"FOUSA00EFI",
			163148000,
			0,
			0,
			0.04834658568411771,
			7887648.761192436,
			0.04834658568411771,
			7887648.761192436
		],
		[
			"VANGUARD TARGET 2020",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			105097000,
			0.035230489202590476,
			3702618.723724651,
			0.014566823354659747,
			1530929.4341046754,
			0.04979731255725022,
			5233548.157829327
		],
		[
			"AF EUROPAC GROWTH R6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			104664000,
			0.10771126450519944,
			11273491.788172195,
			0,
			0,
			0.10771126450519944,
			11273491.788172195
		],
		[
			"SSGA SM/MID CAP",
			"SSMHX",
			"FS0000BWAK",
			"F00000VV1D",
			85890000,
			0.06754252933228752,
			5801227.844350175,
			0,
			0,
			0.06754252933228752,
			5801227.844350175
		],
		[
			"VANGUARD TARGET INC",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			68573000,
			0.02420873589822837,
			1660065.646749214,
			0.016543257559609954,
			1134420.8006351334,
			0.04075199345783832,
			2794486.447384347
		],
		[
			"HARRIS OAKMRK INTL 3",
			"OANIX",
			"FSUSA001UU",
			"F00000XOSV",
			60513000,
			0.01617592636046206,
			978853.8318506406,
			0,
			0,
			0.01617592636046206,
			978853.8318506406
		],
		[
			"VANGUARD TARGET 2015",
			"~",
			"~",
			"FOUSA04B97",
			38172000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"VANG VMMR-FED MMKT",
			"~",
			"~",
			"~",
			16625000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"apple": [
		[
			"Vanguard Institutional 500 Index Trust Fund",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			2527199264,
			0.09174523974228109,
			231858502.3521963,
			0,
			0,
			0.09174523974228109,
			231858502.3521963
		],
		[
			"Fidelity Contrafund Commingled Pool Class 3 Fund",
			"FCNTX",
			"FSUSA000RQ",
			"FOUSA00CEO",
			1601047892,
			0.1466416548994518,
			234780312.4561588,
			0,
			0,
			0.1466416548994518,
			234780312.4561588
		],
		[
			"BlackRock Global LifePath Index 2050 Account A Fund",
			"LIPKX",
			"FSUSA0BDPU",
			"F00000MAPG",
			1398248495,
			0.08471012883200901,
			118445810.15061271,
			0.004415330955539908,
			6173729.863510588,
			0.08912545978754892,
			124619540.0141233
		],
		[
			"BlackRock Global LifePath Index 2045 Account A Fund",
			"LIHKX",
			"FSUSA0BDPV",
			"F00000MAPH",
			1390150797,
			0.07866477829716315,
			109355904.24562965,
			0.008302856189532203,
			11542222.149254575,
			0.08696763448669535,
			120898126.39488423
		],
		[
			"BlackRock Global LifePath Index 2040 Account A Fund",
			"LIKKX",
			"FSUSA0BDPW",
			"F00000MAPI",
			1027465327,
			0.06965019365638501,
			71563159.00077096,
			0.010014212303853631,
			10289255.919426395,
			0.07966440596023865,
			81852414.92019735
		],
		[
			"BlackRock Global LifePath Index 2055 Account A Fund",
			"LIVKX",
			"FSUSA0BDPT",
			"F00000MAP0",
			1009116129,
			0.08675189738403444,
			87542738.87158206,
			0.0015049406496713052,
			1518659.8827710527,
			0.08825683803370574,
			89061398.75435312
		],
		[
			"Vanguard Extended Market Index Trust Fund",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			845832722,
			0.06544225035826598,
			55353196.75433759,
			0,
			0,
			0.06544225035826598,
			55353196.75433759
		],
		[
			"BlackRock Global LifePath Index 2035 Account A Fund",
			"LIJKX",
			"FSUSA0BDPX",
			"F00000MAPJ",
			809124596,
			0.05940459449733448,
			48065718.52319958,
			0.012372868585268242,
			10011192.295416258,
			0.07177746308260272,
			58076910.81861584
		],
		[
			"Vanguard Total International Stock Index Trust",
			"VGTSX",
			"FSUSA004JJ",
			"FOUSA00KIR",
			670033591,
			0.09782558128881824,
			65546425.52260929,
			0,
			0,
			0.09782558128881824,
			65546425.52260929
		],
		[
			"Vanguard Total Bond Market Index Trust Fund",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			569702230,
			0,
			0,
			0.04136148656372853,
			23563731.131471183,
			0.04136148656372853,
			23563731.131471183
		],
		[
			"BlackRock Global LifePath Index 2030 Account A Fund",
			"LINKX",
			"FSUSA0BDPY",
			"F00000MAPK",
			564705638,
			0.04871285292100014,
			27508422.687553547,
			0.014160420067164935,
			7996469.048376378,
			0.06287327298816507,
			35504891.73592992
		],
		[
			"William Blair Small-Mid Cap Growth Separately Managed Account",
			"~",
			"~",
			"~",
			529461492,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BHMS Large Cap Value Equity Separately Managed Account",
			"~",
			"~",
			"~",
			407751847,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Stable Value Fund Separately Managed Account",
			"~",
			"~",
			"~",
			390252918,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Baillie Gifford International Alpha CIT",
			"BGIKX",
			"FS0000BKUG",
			"F00000YMQX",
			361289240,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"BlackRock Global LifePath Index Retirement Account A Fund",
			"LIRKX",
			"FSUSA0BDPS",
			"F00000MAOX",
			333727854,
			0.032011560110599045,
			10683149.258902222,
			0.014213872858253112,
			4743565.286013657,
			0.046225432968852155,
			15426714.54491588
		],
		[
			"BlackRock Global LifePath Index 2060 Account A Fund",
			"LIZKX",
			"FS0000C8VF",
			"F00000WM8M",
			323805243,
			0.08670656047888761,
			28076038.8855604,
			0.0016559941738530904,
			536219.5958710841,
			0.0883625546527407,
			28612258.481431484
		],
		[
			"BlackRock Global LifePath Index 2025 Account A Fund",
			"LIBKX",
			"FSUSA0BDPZ",
			"F00000MAPL",
			307665832,
			0.03700173818270401,
			11384170.563427798,
			0.014567211240572073,
			4481833.166250359,
			0.051568949423276084,
			15866003.729678158
		],
		[
			"BNY Mellon EB Global Real Estate Sec II Fund",
			"DRLYX",
			"FSUSA07HW9",
			"F00000Q3F3",
			210335432,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"AB US Small Mid-Cp Value CIT W Series",
			"~",
			"~",
			"~",
			197260939,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Eaton Vance Trust Co CIT High Yield CIV",
			"~",
			"~",
			"~",
			163295225,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Loomis Sayles Core Plus Fixed Income D",
			"~",
			"~",
			"~",
			111449993,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BlackRock Global LifePath Index 2065 Account A Fund",
			"LIWKX",
			"FS0000FCWA",
			"F000013OYO",
			29135653,
			0.08654592535593908,
			2521572.0497345426,
			0.0019195903309161824,
			55928.51778372906,
			0.08846551568685526,
			2577500.5675182715
		]
	],
	"bloomberg": [
		[
			"State Street Global Advisors S&P 500 Index Fund Class K",
			"SVSPX",
			"FSUSA002BE",
			"FOUSA00F0N",
			746189676,
			0.09115788472509703,
			68021072.4678655,
			0,
			0,
			0.09115788472509703,
			68021072.4678655
		],
		[
			"Harbor Trust Company Capital Appreciation CIT 4",
			"HACAX",
			"FSUSA0016N",
			"FOUSA00D2I",
			341925258,
			0.02704260563196072,
			9246549.907700423,
			0,
			0,
			0.02704260563196072,
			9246549.907700423
		],
		[
			"BlackRock Life Path Index 2045 Non-Lendable M",
			"LIHKX",
			"FSUSA0BDPV",
			"F00000MAPH",
			297610326,
			0.07866477829716315,
			23411450.31373645,
			0.008302856189532203,
			2471015.7372977966,
			0.08696763448669535,
			25882466.051034246
		],
		[
			"State Street Global Advisors Russell Small/Mid Cap Index Fund Class K",
			"SSMHX",
			"FS0000BWAK",
			"F00000VV1D",
			283990294,
			0.06754252933228752,
			19181422.762579955,
			0,
			0,
			0.06754252933228752,
			19181422.762579955
		],
		[
			"BlackRock Life Path Index 2050 Non-Lendable M",
			"LIPKX",
			"FSUSA0BDPU",
			"F00000MAPG",
			279211808,
			0.08471012883200901,
			23652068.227098163,
			0.004415330955539908,
			1232812.5390146654,
			0.08912545978754892,
			24884880.766112827
		],
		[
			"BlackRock Life Path Index 2040 Non-Lendable M",
			"LIKKX",
			"FSUSA0BDPW",
			"F00000MAPI",
			258527341,
			0.06965019365638501,
			18006479.366120286,
			0.010014212303853631,
			2588947.6791247632,
			0.07966440596023865,
			20595427.04524505
		],
		[
			"Fidelity Contrafund Commingled Pool",
			"FCNTX",
			"FSUSA000RQ",
			"FOUSA00CEO",
			199923280,
			0.1466416548994518,
			29317080.632126473,
			0,
			0,
			0.1466416548994518,
			29317080.632126473
		],
		[
			"Loomis Sayles Small/Mid Cap Growth Trust",
			"LSMIX",
			"FS0000BTBW",
			"F00000VOGS",
			196586792,
			0.05921076123723498,
			11640053.603505976,
			0,
			0,
			0.05921076123723498,
			11640053.603505976
		],
		[
			"BlackRock Life Path Index 2035 Non-Lendable M",
			"LIJKX",
			"FSUSA0BDPX",
			"F00000MAPJ",
			193752634,
			0.05940459449733448,
			11509796.655560462,
			0.012372868585268242,
			2397275.8785315757,
			0.07177746308260272,
			13907072.534092037
		],
		[
			"Dodge & Cox Stock Fund",
			"DODGX",
			"FSUSA000KR",
			"FOUSA00C3O",
			177185983,
			0.07557975836793555,
			13391673.781325137,
			0,
			0,
			0.07557975836793555,
			13391673.781325137
		],
		[
			"BlackRock Short-Term Investment-W",
			"~",
			"~",
			"~",
			171116429,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BlackRock Life Path Index 2055 Non-Lendable M",
			"LIVKX",
			"FSUSA0BDPT",
			"F00000MAP0",
			156911423,
			0.08675189738403444,
			13612363.666478822,
			0.0015049406496713052,
			236142.378870469,
			0.08825683803370574,
			13848506.04534929
		],
		[
			"Prudential Core Plus Bond Fund 5",
			"~",
			"~",
			"~",
			141245372,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BlackRock Life Path Index 2030 Non-Lendable M",
			"LINKX",
			"FSUSA0BDPY",
			"F00000MAPK",
			138382570,
			0.04871285292100014,
			6741009.779240006,
			0.014160420067164935,
			1959555.3211738563,
			0.06287327298816507,
			8700565.100413863
		],
		[
			"Dodge & Cox Balanced Fund",
			"DODBX",
			"FSUSA000KP",
			"FOUSA00C3I",
			118397458,
			0.06217564229965332,
			7361437.997796227,
			0.02847912914602925,
			3371856.496943574,
			0.09065477144568257,
			10733294.4947398
		],
		[
			"TS&W International LRGCP Equity Trust",
			"~",
			"~",
			"~",
			97773975,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"State Street Global Advisors Global All Cap Equity EX-US Index",
			"SSGVX",
			"FS0000AREJ",
			"F00000T8Y8",
			91144361,
			0.0929421583050248,
			8471153.628672328,
			0,
			0,
			0.0929421583050248,
			8471153.628672328
		],
		[
			"Wells Fargo Synthetic Stable Value MC",
			"~",
			"~",
			"~",
			87795857,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"State Street Global Advisors US Bond Index Non-Lending Fund Class K",
			"~",
			"~",
			"~",
			78869425,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BlackRock Life Path Index 2025 Non-Lendable M",
			"LIBKX",
			"FSUSA0BDPZ",
			"F00000MAPL",
			76576968,
			0.03700173818270401,
			2833480.920761303,
			0.014567211240572073,
			1115512.869018528,
			0.051568949423276084,
			3948993.7897798307
		],
		[
			"BlackRock Life Path Index 2060 Non-Lendable M",
			"LIZKX",
			"FS0000C8VF",
			"F00000WM8M",
			70759466,
			0.08670656047888761,
			6135309.918182792,
			0.0016559941738530904,
			117177.26344095584,
			0.0883625546527407,
			6252487.181623748
		],
		[
			"Alliance Bernstein US Small & Mid Cap Val CIT TR CL P1",
			"~",
			"~",
			"~",
			63363653,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Parnassus Core Equity Institutional",
			"PRILX",
			"FSUSA001WD",
			"FOUSA05HGA",
			54565832,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"DFA Emerging Markets Core Equity I",
			"DFCEX",
			"FSUSA06GLH",
			"FOUSA05CLF",
			48729789,
			0.0997799181209767,
			4862254.356472471,
			0,
			0,
			0.0997799181209767,
			4862254.356472471
		],
		[
			"BlackRock Life Path Index Retirement Non-Lendable M",
			"LIRKX",
			"FSUSA0BDPS",
			"F00000MAOX",
			38435060,
			0.032011560110599045,
			1230366.233544481,
			0.014213872858253112,
			546311.0561393298,
			0.046225432968852155,
			1776677.289683811
		],
		[
			"BlackRock Life Path Index 2065 Non-Lendable M",
			"LIWKX",
			"FS0000FCWA",
			"F000013OYO",
			9240241,
			0.08654592535593908,
			799705.2078568878,
			0.0019195903309161824,
			17737.477278935276,
			0.08846551568685526,
			817442.6851358231
		]
	],
	"booking-holdings": [
		[
			"FIDELITY 500 INDEX",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			70869760,
			0.09162563971314869,
			6493487.096317316,
			0,
			0,
			0.09162563971314869,
			6493487.096317316
		],
		[
			"VANGUARD EXTENDED MARKET IDX",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			40746992,
			0.06544225035826598,
			2666574.851810261,
			0,
			0,
			0.06544225035826598,
			2666574.851810261
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2050 INSTL",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			35362367,
			0.08024700579457168,
			2837724.0695587704,
			0.003268008966211633,
			115564.53242246636,
			0.08351501476078331,
			2953288.6019812366
		],
		[
			"PARNASSUS CORE EQUITY - INSTL",
			"PRILX",
			"FSUSA001WD",
			"FOUSA05HGA",
			34872516,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2045 INSTL",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			30112061,
			0.0758893350582794,
			2285184.286524348,
			0.004623421317086152,
			139220.74472879857,
			0.08051275637536555,
			2424405.0312531465
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2055 INSTL",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			29145485,
			0.08032666379393759,
			2341159.5747062513,
			0.00326181821755119,
			95067.27393236494,
			0.08358848201148877,
			2436226.848638616
		],
		[
			"AMERICAN FUNDS EUROPACIFIC GR R6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			20287538,
			0.10771126450519944,
			2185196.3716772846,
			0,
			0,
			0.10771126450519944,
			2185196.3716772846
		],
		[
			"PGIM JENNISON SMALL COMPANY R6",
			"PJSQX",
			"FSUSA0023I",
			"F00000JSAQ",
			18420135,
			0.09117564641747386,
			1679467.7157221348,
			0,
			0,
			0.09117564641747386,
			1679467.7157221348
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2040 INSTL",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			16835764,
			0.06823506026662908,
			1148789.3711747443,
			0.007062568740663622,
			118903.74055158994,
			0.0752976290072927,
			1267693.1117263343
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2035 INSTL",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			16312078,
			0.06116514924323183,
			997730.6853372386,
			0.00930723295448306,
			151820.30991769815,
			0.0704723821977149,
			1149550.9952549366
		],
		[
			"VANGUARD TOTAL INTL STOCK INDEX",
			"VTSAX",
			"FSUSA002PT",
			"FOUSA00L83",
			11439120,
			0.08735255494739627,
			999236.3583498596,
			0,
			0,
			0.08735255494739627,
			999236.3583498596
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2030 INSTL",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			11342572,
			0.05426274087980579,
			615479.0453465405,
			0.011496230679006621,
			130396.82420524149,
			0.06575897155881241,
			745875.869551782
		],
		[
			"PIMCO TOTAL RETURN INSTL",
			"PTTRX",
			"FSUSA001ZG",
			"FOUSA00EH4",
			10446290,
			0,
			0,
			0.012424118201873642,
			129785.94173105061,
			0.012424118201873642,
			129785.94173105061
		],
		[
			"BNYM MELLON STABLE VALUE FUND M",
			"~",
			"~",
			"~",
			10274371,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2060 INSTL",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			9508071,
			0.08036342163620322,
			764101.1187199564,
			0.0032255517799972596,
			30668.775338390325,
			0.08358897341620047,
			794769.8940583467
		],
		[
			"VANGUARD TOTAL BOND MKT INDEX INST",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			5411930,
			0,
			0,
			0.04136148656372853,
			223845.46997883936,
			0.04136148656372853,
			223845.46997883936
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2025 INSTL",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			5020093,
			0.04647789761877514,
			233323.36849072974,
			0.012926504408448546,
			64892.25429532168,
			0.059404402027223684,
			298215.6227860514
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2020 INSTL",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			3765239,
			0.035230489202590476,
			132651.21193467255,
			0.014566823354659747,
			54847.571401075715,
			0.04979731255725022,
			187498.78333574827
		],
		[
			"PIMCO DIVERSIFIED REAL ASSET CIT",
			"~",
			"~",
			"~",
			2430188,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"VANGUARD TARGET RETIREMENT INC",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			1841528,
			0.02420873589822837,
			44581.06500119269,
			0.016543257559609954,
			30464.8720072334,
			0.04075199345783832,
			75045.93700842609
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2015 INSTL",
			"~",
			"~",
			"FOUSA04B97",
			983196,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"VANGUARD INSTL TRGT RETIRE 2065 INSTL",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			467572,
			0.08019566005615357,
			37497.245163775835,
			0.0031660668875217067,
			1480.3642267322994,
			0.08336172694367527,
			38977.609390508136
		],
		[
			"DREYFUS GOVERNMENT CASH MGT INSTL",
			"~",
			"~",
			"~",
			1,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"broadcom": [
		[
			"Fidelity Growth Company Pool Class 3",
			"FDGRX",
			"FSUSA000TD",
			"FOUSA00CH5",
			1900087310,
			0.02269849389737488,
			43129120.21051445,
			0,
			0,
			0.02269849389737488,
			43129120.21051445
		],
		[
			"Vanguard Institutional 500 Index Trust",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			1254757411,
			0.09174523974228109,
			115118019.49059893,
			0,
			0,
			0.09174523974228109,
			115118019.49059893
		],
		[
			"Fidelity Investments Money Market Treasury Only",
			"~",
			"~",
			"~",
			403282556,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2030",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			397256649,
			0.05426274087980579,
			21556234.60746696,
			0.011496230679006621,
			4566954.075673165,
			0.06575897155881241,
			26123188.68314012
		],
		[
			"Vanguard Target Retirement 2035",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			385401795,
			0.06116514924323183,
			23573158.30978444,
			0.00930723295448306,
			3587024.287140925,
			0.0704723821977149,
			27160182.596925363
		],
		[
			"Vanguard Target Retirement 2025",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			346569979,
			0.04647789761877514,
			16107844.00170305,
			0.012926504408448546,
			4479938.36137942,
			0.059404402027223684,
			20587782.36308247
		],
		[
			"Vanguard Target Retirement 2040",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			307924842,
			0.06823506026662908,
			21011270.15146224,
			0.007062568740663622,
			2174740.363582985,
			0.0752976290072927,
			23186010.515045222
		],
		[
			"MassMutual Select Mid Cap Growth",
			"MEFZX",
			"FSUSA0044N",
			"F00000JS7I",
			269016626,
			0.03964963434675889,
			10666410.85409879,
			0,
			0,
			0.03964963434675889,
			10666410.85409879
		],
		[
			"Vanguard Mid Cap Index IS",
			"VMCIX",
			"FSUSA003Q9",
			"FOUSA00J83",
			256581899,
			0.10952080365600442,
			28101055.782063756,
			0,
			0,
			0.10952080365600442,
			28101055.782063756
		],
		[
			"American Funds EuroPacific Growth R6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			214996793,
			0.10771126450519944,
			23157576.438592613,
			0,
			0,
			0.10771126450519944,
			23157576.438592613
		],
		[
			"Vanguard Target Retirement 2045",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			192395781,
			0.0758893350582794,
			14600787.888108345,
			0.004623421317086152,
			889526.755192839,
			0.08051275637536555,
			15490314.643301183
		],
		[
			"Boston Partners Mid Cap Value Equity Investments",
			"VVMCX",
			"FSUSA06UIW",
			"FOUSA05HH7",
			183810019,
			0.10178161977442962,
			18708481.464588683,
			0,
			0,
			0.10178161977442962,
			18708481.464588683
		],
		[
			"TCW Total Return Bond I",
			"TGLMX",
			"FSUSA002P5",
			"FOUSA00FPV",
			172060283,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Vanguard Small Cap Index Fund Instl",
			"VSCIX",
			"FSUSA001PZ",
			"FOUSA00GQ5",
			169351200,
			0.07578909461851184,
			12834974.120558523,
			0,
			0,
			0.07578909461851184,
			12834974.120558523
		],
		[
			"Vanguard Target Retirement 2020",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			142048551,
			0.035230489202590476,
			5004439.942249123,
			0.014566823354659747,
			2069196.1502023763,
			0.04979731255725022,
			7073636.0924515
		],
		[
			"Dodge & Cox Stock Fund",
			"DODGX",
			"FSUSA000KR",
			"FOUSA00C3O",
			140096579,
			0.07557975836793555,
			10588465.588994395,
			0,
			0,
			0.07557975836793555,
			10588465.588994395
		],
		[
			"Vanguard Short-Term Bond Index Fund Institutional",
			"VBIPX",
			"FSUSA001DN",
			"F00000MPYP",
			130811854,
			0,
			0,
			0.029389120548263967,
			3844445.346347906,
			0.029389120548263967,
			3844445.346347906
		],
		[
			"Vanguard Target Retirement 2050",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			123666709,
			0.08024700579457168,
			9923883.11371861,
			0.003268008966211633,
			404143.9138338849,
			0.08351501476078331,
			10328027.027552495
		],
		[
			"Vanguard Total Bond Market Index Fund Institutional",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			109197714,
			0,
			0,
			0.04136148656372853,
			4516579.780400871,
			0.04136148656372853,
			4516579.780400871
		],
		[
			"Vanguard Total Intl Stock Index Inv",
			"VGTSX",
			"FSUSA004JJ",
			"FOUSA00KIR",
			98230906,
			0.09782558128881824,
			9609495.479977263,
			0,
			0,
			0.09782558128881824,
			9609495.479977263
		],
		[
			"Vanguard Target Retirement 2015",
			"~",
			"~",
			"FOUSA04B97",
			43840172,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2055",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			41665640,
			0.08032666379393759,
			3346861.8560392377,
			0.00326181821755119,
			135905.74359792957,
			0.08358848201148877,
			3482767.599637167
		],
		[
			"Vanguard Target Retirement Income Fund",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			34247907,
			0.02420873589822837,
			829098.5356300867,
			0.016543257559609954,
			566571.9463785687,
			0.04075199345783832,
			1395670.4820086553
		],
		[
			"Invesco Stable Value Trust Class A1",
			"~",
			"~",
			"~",
			28338776,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2065",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			15616365,
			0.08019566005615357,
			1252364.6988528147,
			0.0031660668875217067,
			49442.456129952916,
			0.08336172694367527,
			1301807.1549827675
		],
		[
			"Vanguard Target Retirement 2060",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			12168337,
			0.08036342163620322,
			977889.1969424122,
			0.0032255517799972596,
			39249.601069956516,
			0.08358897341620047,
			1017138.7980123687
		]
	],
	"campbell-soup": [
		[
			"American Funds Growth Fund of America Class R-6",
			"RGAGX",
			"FSUSA00155",
			"F000002PJ1",
			289579704,
			0.061913527603815195,
			17928900.997108635,
			0,
			0,
			0.061913527603815195,
			17928900.997108635
		],
		[
			"Vanguard Institutional Index Fund Institutional Plus Shares",
			"VIIIX",
			"FSUSA002Q0",
			"FOUSA00GPG",
			223587685,
			0.09156609528167008,
			20473051.268518034,
			0,
			0,
			0.09156609528167008,
			20473051.268518034
		],
		[
			"Vanguard Equity-Income Fund Admiral Shares",
			"VEIRX",
			"FSUSA002PL",
			"FOUSA02TIM",
			135314876,
			0.17590873034694984,
			23803068.034214955,
			0,
			0,
			0.17590873034694984,
			23803068.034214955
		],
		[
			"Campbell Soup Company Stock Fund",
			"~",
			"~",
			"~",
			122425810,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2030 Trust I",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			122047158,
			0.05426274087980579,
			6622613.309670716,
			0.011496230679006621,
			1403082.2820851684,
			0.06575897155881241,
			8025695.591755884
		],
		[
			"Vanguard Target Retirement 2025 Trust I",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			116479548,
			0.04647789761877514,
			5413724.506625204,
			0.012926504408448546,
			1505673.390716094,
			0.059404402027223684,
			6919397.897341298
		],
		[
			"Blackrock Short-Term Investment Fund",
			"~",
			"~",
			"~",
			115196251,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2035 Trust I",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			105593994,
			0.06116514924323183,
			6458672.402198927,
			0.00930723295448306,
			982787.9007522865,
			0.0704723821977149,
			7441460.302951213
		],
		[
			"Vanguard Extended Market Index Fund Institutional Shares",
			"VIEIX",
			"FSUSA002PR",
			"FOUSA00GPW",
			105102734,
			0.06544225035826598,
			6878159.431766234,
			0,
			0,
			0.06544225035826598,
			6878159.431766234
		],
		[
			"Vanguard Target Retirement 2045 Trust I",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			104196590,
			0.0758893350582794,
			7907409.930440164,
			0.004623421317086152,
			481744.73537368583,
			0.08051275637536555,
			8389154.66581385
		],
		[
			"Vanguard Target Retirement 2040 Trust I",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			104136285,
			0.06823506026662908,
			7105745.682917862,
			0.007062568740663622,
			735469.6712098381,
			0.0752976290072927,
			7841215.3541277
		],
		[
			"Vanguard Target Retirement 2050 Trust I",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			98343407,
			0.08024700579457168,
			7891763.951386921,
			0.003268008966211633,
			321387.13584379986,
			0.08351501476078331,
			8213151.087230721
		],
		[
			"American Funds EuroPacific Growth Fund Class R-6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			75113519,
			0.10771126450519944,
			8090572.112925324,
			0,
			0,
			0.10771126450519944,
			8090572.112925324
		],
		[
			"T. Rowe Price Small-Cap Value Equity Trust D",
			"PRSVX",
			"FSUSA0021Y",
			"FOUSA00EKG",
			62335632,
			0.1029540147853292,
			6417703.5785808405,
			0,
			0,
			0.1029540147853292,
			6417703.5785808405
		],
		[
			"Vanguard Target Retirement 2055 Trust I",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			60779391,
			0.08032666379393759,
			4882205.706457276,
			0.00326181821755119,
			198251.32481546683,
			0.08358848201148877,
			5080457.031272743
		],
		[
			"Vanguard Target Retirement 2020 Trust I",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			49229021,
			0.035230489202590476,
			1734362.4927945998,
			0.014566823354659747,
			717110.4528298351,
			0.04979731255725022,
			2451472.945624435
		],
		[
			"Vanguard Short-Term Bond Index Fund Institutional Shares",
			"VBIPX",
			"FSUSA001DN",
			"F00000MPYP",
			36618864,
			0,
			0,
			0.029389120548263967,
			1076196.2084364835,
			0.029389120548263967,
			1076196.2084364835
		],
		[
			"Vanguard Total Bond Market Index Fund Institutional Shares",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			30520056,
			0,
			0,
			0.04136148656372853,
			1262354.8861682424,
			0.04136148656372853,
			1262354.8861682424
		],
		[
			"Vanguard Target Retirement 2060 Trust I",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			28551988,
			0.08036342163620322,
			2294535.4501958145,
			0.0032255517799972596,
			92095.91571586039,
			0.08358897341620047,
			2386631.3659116747
		],
		[
			"PIMCO Total Return Fund Institutional Class",
			"PTTRX",
			"FSUSA001ZG",
			"FOUSA00EH4",
			27823913,
			0,
			0,
			0.012424118201873642,
			345687.58395064867,
			0.012424118201873642,
			345687.58395064867
		],
		[
			"Vanguard Total Int’l Stock Index Fund Institutional Shares",
			"VTSNX",
			"FSUSA004JJ",
			"F00000JTBU",
			24754311,
			0.09782558128881824,
			2421604.8629791876,
			0,
			0,
			0.09782558128881824,
			2421604.8629791876
		],
		[
			"Vanguard Target Retirement 2015 Trust I",
			"~",
			"~",
			"FOUSA04B97",
			16188094,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement Income Trust I",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			14977764,
			0.02420873589822837,
			362592.73302199255,
			0.016543257559609954,
			247781.00751905382,
			0.04075199345783832,
			610373.7405410464
		],
		[
			"PIMCO Real Return Fund Institutional Class",
			"PRRIX",
			"FSUSA0041O",
			"FOUSA00G06",
			9129513,
			0,
			0,
			0.000012479734059770732,
			113.93389433521968,
			0.000012479734059770732,
			113.93389433521968
		],
		[
			"Vanguard Target Retirement 2065 Trust I",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			6816138,
			0.08019566005615357,
			546624.6859438305,
			0.0031660668875217067,
			21580.34882257843,
			0.08336172694367527,
			568205.034766409
		]
	],
	"centene": [
		[
			"Fidelity FIAM Blend Target Date 2035 T",
			"FHJDX",
			"FS0000DV8W",
			"F000010OKH",
			436650303,
			0.07249433727538379,
			31654674.337080527,
			0.007568283429980724,
			3304693.2528909626,
			0.08006262070536452,
			34959367.58997149
		],
		[
			"Fidelity FIAM Blend Target Date 2040 T",
			"FHHDX",
			"FS0000DV8X",
			"F000010OKQ",
			394918770,
			0.08603716705820114,
			33977692.188909315,
			0.002744183779413093,
			1083729.68281977,
			0.08878135083761422,
			35061421.87172908
		],
		[
			"Fidelity FIAM Blend Target Date 2030 T",
			"FHKDX",
			"FS0000DV8V",
			"F000010OK8",
			389488993,
			0.059252544045159575,
			23078213.71283735,
			0.011189234441461101,
			4358083.655045602,
			0.07044177848662067,
			27436297.367882952
		],
		[
			"Fidelity FIAM Blend Target Date 2045 T",
			"FHFDX",
			"FS0000DV7E",
			"F000010OF4",
			334812561,
			0.08888901660892752,
			29761159.295606557,
			0.001747469166078257,
			585074.6267631956,
			0.09063648577500578,
			30346233.922369752
		],
		[
			"Fidelity FIAM Blend Target Date 2025 T",
			"FHLDX",
			"FS0000DV8U",
			"F000010OJZ",
			271875751,
			0.05274411901981259,
			14339846.96934493,
			0.012380532333339609,
			3365966.5259064888,
			0.0651246513531522,
			17705813.49525142
		],
		[
			"Fidelity FIAM Blend Target Date 2050 T",
			"FHEDX",
			"FS0000DV7F",
			"F000010OFJ",
			260015281,
			0.08888381689762928,
			23111150.626989625,
			0.0017419882114271545,
			452943.554292919,
			0.09062580510905643,
			23564094.181282543
		],
		[
			"Fidelity 500 Index",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			245094157,
			0.09162563971314869,
			22456908.9250799,
			0,
			0,
			0.09162563971314869,
			22456908.9250799
		],
		[
			"Fidelity FIAM Blend Target Date 2055 T",
			"FHDDX",
			"FS0000DV7G",
			"F000010OFS",
			154818948,
			0.08887399910481011,
			13759379.045959644,
			0.0017478337527625394,
			270597.78288158844,
			0.09062183285757265,
			14029976.828841232
		],
		[
			"Fidelity FIAM Blend Target Date 2020 T",
			"FHNDX",
			"FS0000DV8T",
			"F000010OJQ",
			145821160,
			0.04565966439650298,
			6658145.227508765,
			0.014078982174377998,
			2053013.512287122,
			0.059738646570880974,
			8711158.739795886
		],
		[
			"Fidelity Large Cap Growth Index",
			"FSPGX",
			"FS0000CFE4",
			"F00000WZW5",
			124696716,
			0.014152643051489862,
			1764788.1112410047,
			0,
			0,
			0.014152643051489862,
			1764788.1112410047
		],
		[
			"T Rowe Price Blue Chip Growth I",
			"TBCIX",
			"FSUSA0020C",
			"F00000WMWX",
			98042622,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Putnam Stable Value Fund",
			"~",
			"~",
			"~",
			89708608,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity Total Bond",
			"FTBFX",
			"FSUSA04Z85",
			"FOUSA02VNL",
			77041801,
			0.0005410250110649903,
			41681.54123849178,
			0.058734103091540646,
			4524981.082291959,
			0.059275128102605636,
			4566662.62353045
		],
		[
			"Fidelity International Discovery K",
			"FIDKX",
			"FSUSA065WW",
			"FOUSA06TXE",
			69374181,
			0.03665554506774967,
			2542948.418183723,
			0,
			0,
			0.03665554506774967,
			2542948.418183723
		],
		[
			"Fidelity Mid Cap Index",
			"FSMDX",
			"FSUSA0BGZB",
			"F00000MJRP",
			56900508,
			0.10367535191096297,
			5899180.1908125635,
			0,
			0,
			0.10367535191096297,
			5899180.1908125635
		],
		[
			"Fidelity Small Cap Index",
			"FSSNX",
			"FSUSA0BGZD",
			"F00000MJRV",
			50278994,
			0.086306010873582,
			4339379.402876765,
			0,
			0,
			0.086306010873582,
			4339379.402876765
		],
		[
			"Vanguard Healthcare Administration",
			"VGHAX",
			"FSUSA002RA",
			"FOUSA02TY7",
			48738937,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity FIAM Blend Target Date 2060 T",
			"FHCDX",
			"FS0000DV7H",
			"F000010OFU",
			45136721,
			0.08884727385005128,
			4010274.6113803606,
			0.0017646940514301143,
			79652.50304976072,
			0.0906119679014814,
			4089927.114430121
		],
		[
			"Janus Henderson Enterprise N",
			"JDMNX",
			"FSUSA001B1",
			"F00000OB9Z",
			44369477,
			0.027094775321335043,
			1202181.0104401428,
			0,
			0,
			0.027094775321335043,
			1202181.0104401428
		],
		[
			"Fidelity FIMM Government Portfolio Institutional Class",
			"~",
			"~",
			"~",
			40721998,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity FIAM Blend Target Date 2015 T",
			"FHODX",
			"FS0000DV8S",
			"F000010OJH",
			35129134,
			0.03667601618560371,
			1288396.6871702417,
			0.016007513259696425,
			562330.0783066525,
			0.05268352944530014,
			1850726.765476894
		],
		[
			"UBS U.S. Small Cap Growth",
			"BISCX",
			"FSUSA003CZ",
			"FOUSA00HD4",
			34716769,
			0.06019703938142193,
			2089846.710688728,
			0,
			0,
			0.06019703938142193,
			2089846.710688728
		],
		[
			"American Beacon Large Cap Value Institutional",
			"AADEX",
			"FSUSA00016",
			"FOUSA00B2S",
			32874905,
			0.13480453410139442,
			4431686.252152602,
			0,
			0,
			0.13480453410139442,
			4431686.252152602
		],
		[
			"Vanguard Inflation Protected Securities Fund Institutional",
			"VIPIX",
			"FSUSA004EW",
			"FOUSA04BL6",
			28438282,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Cohen & Steer Realty",
			"CSRSX",
			"FSUSA000DQ",
			"FOUSA00BP7",
			22982753,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Invesco Developing Markets R5",
			"DVMFX",
			"FSUSA003HS",
			"F000011GCX",
			22958307,
			0.032453357367792326,
			745074.1416304881,
			0,
			0,
			0.032453357367792326,
			745074.1416304881
		],
		[
			"Ariel Fund Institutional",
			"ARAIX",
			"FSUSA0004M",
			"F00000N785",
			21050777,
			0.04820875437683124,
			1014831.7378344483,
			0,
			0,
			0.04820875437683124,
			1014831.7378344483
		],
		[
			"MFS Mid Cap Value R6",
			"MVCKX",
			"FSUSA00DUD",
			"F00000PGEH",
			16242470,
			0.14896223205199224,
			2419514.5852375226,
			0,
			0,
			0.14896223205199224,
			2419514.5852375226
		],
		[
			"Fidelity Large Cap Value Index",
			"FLCOX",
			"FS0000CFDS",
			"F00000WZVI",
			14620325,
			0.167974173672063,
			2455837.0106920046,
			0,
			0,
			0.167974173672063,
			2455837.0106920046
		],
		[
			"Fidelity FIAM Blend Target Date 2005 T",
			"FHQDX",
			"FS0000DV7J",
			"F000010OG4",
			9220686,
			0.018341182707600424,
			169118.28661541332,
			0.021410169743888333,
			197416.45241509474,
			0.03975135245148875,
			366534.7390305081
		],
		[
			"Northern Small Cap Value",
			"NOSGX",
			"FSUSA000W2",
			"FOUSA00CLE",
			8616336,
			0.1010029406602315,
			870275.2737166164,
			0,
			0,
			0.1010029406602315,
			870275.2737166164
		],
		[
			"Fidelity FIAM Blend Target Date 2010 T",
			"FHPDX",
			"FS0000DV7K",
			"F000010OGD",
			7642985,
			0.027753363021350536,
			212118.53727173683,
			0.018010506740289138,
			137654.03285842878,
			0.045763869761639674,
			349772.5701301656
		],
		[
			"Fidelity FIAM Income T",
			"FHRDX",
			"FS0000DV7D",
			"F000010OET",
			4343647,
			0.018272813520404687,
			79370.65162946525,
			0.020187812865364342,
			87688.73278920123,
			0.038460626385769026,
			167059.38441866648
		]
	],
	"chevron": [
		[
			"Chevron Corporation",
			"~",
			"~",
			"~",
			5355945000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional 500 Index Trust",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			3760243000,
			0.09174523974228109,
			344984395.5242343,
			0,
			0,
			0.09174523974228109,
			344984395.5242343
		],
		[
			"Vanguard Institutional Extended Market Trust",
			"VSEMX",
			"FSUSA002PR",
			"F00000WTNQ",
			1598019000,
			0.06544225035826598,
			104577959.47526585,
			0,
			0,
			0.06544225035826598,
			104577959.47526585
		],
		[
			"Vanguard PRIMECAP Fund",
			"VPMAX",
			"FSUSA002QX",
			"FOUSA02TYD",
			1402811000,
			0.025716153301301933,
			36074902.728752665,
			0,
			0,
			0.025716153301301933,
			36074902.728752665
		],
		[
			"Vanguard Federal Money Market Fund",
			"~",
			"~",
			"~",
			896371000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional Total Bond Market Index Trust",
			"VBTLX",
			"FSUSA002PJ",
			"FOUSA02TYI",
			757870000,
			0,
			0,
			0.04136148656372853,
			31346629.82205294,
			0.04136148656372853,
			31346629.82205294
		],
		[
			"Vanguard Developed Market Index Trust (New in 2021)",
			"VTMNX",
			"FSUSA004S1",
			"FOUSA02SN7",
			752607000,
			0.09912741335312461,
			74603985.18145506,
			0,
			0,
			0.09912741335312461,
			74603985.18145506
		],
		[
			"Vanguard Value Index Fund",
			"VVIAX",
			"FSUSA002PV",
			"FOUSA00LA4",
			715113000,
			0.1742718492197937,
			124624064.91111432,
			0,
			0,
			0.1742718492197937,
			124624064.91111432
		],
		[
			"Dodge & Cox Income Separate Account",
			"DODIX",
			"FSUSA000KQ",
			"FOUSA00C3M",
			409169000,
			0,
			0,
			0.08371664487003887,
			34254255.86482894,
			0.08371664487003887,
			34254255.86482894
		],
		[
			"Vanguard Target Date Retirement Trust 2025 Select",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			391702000,
			0.04647789761877514,
			18205485.45306946,
			0.012926504408448546,
			5063337.629798112,
			0.059404402027223684,
			23268823.08286757
		],
		[
			"Capital Group EuropPacific Growth Trust",
			"AEPGX",
			"FSUSA000PI",
			"FOUSA00CBJ",
			311264000,
			0.10771126450519944,
			33526639.034946397,
			0,
			0,
			0.10771126450519944,
			33526639.034946397
		],
		[
			"Vanguard Target Date Retirement Trust 2030 Select",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			304627000,
			0.05426274087980579,
			16529895.965992598,
			0.011496230679006621,
			3502062.26305375,
			0.06575897155881241,
			20031958.22904635
		],
		[
			"Vanguard Target Date Retirement Trust 2035 Select",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			276347000,
			0.06116514924323183,
			16902805.497919388,
			0.00930723295448306,
			2572025.9052725304,
			0.0704723821977149,
			19474831.403191917
		],
		[
			"Vanguard Target Date Retirement Trust 2045 Select",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			257304000,
			0.0758893350582794,
			19526629.467835523,
			0.004623421317086152,
			1189624.7985715354,
			0.08051275637536555,
			20716254.266407058
		],
		[
			"Vanguard Target Date Retirement Trust 2040 Select",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			252465000,
			0.06823506026662908,
			17226964.49021451,
			0.007062568740663622,
			1783051.4171116415,
			0.0752976290072927,
			19010015.907326154
		],
		[
			"Vanguard Target Date Retirement Trust 2020 Select",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			245367000,
			0.035230489202590476,
			8644399.444172017,
			0.014566823354659747,
			3574217.7460627984,
			0.04979731255725022,
			12218617.190234816
		],
		[
			"Vanguard Emerging Market Stock Index Fund",
			"VEMAX",
			"FSUSA000I3",
			"FOUSA05IBW",
			238347000,
			0.09589525710246337,
			22856346.844600838,
			0,
			0,
			0.09589525710246337,
			22856346.844600838
		],
		[
			"Vanguard Target Date Retirement Trust 2050 Select",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			203237000,
			0.08024700579457168,
			16309160.716671364,
			0.003268008966211633,
			664180.3382659537,
			0.08351501476078331,
			16973341.054937318
		],
		[
			"Vanguard Short-Term Bond Fund Index",
			"VBIRX",
			"FSUSA001DN",
			"FOUSA02TYF",
			188474000,
			0,
			0,
			0.029389120548263967,
			5539085.106213503,
			0.029389120548263967,
			5539085.106213503
		],
		[
			"Vanguard REIT Index Fund",
			"VGSLX",
			"FSUSA004JF",
			"FOUSA02TYE",
			164401000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"SSgA Inflation Prot Bond Index",
			"SPIP",
			"FSUSA07YZA",
			"FOUSA06B89",
			133404000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Vanguard Target Date Retirement Trust 2055 Select",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			108883000,
			0.08032666379393759,
			8746208.133875307,
			0.00326181821755119,
			355156.5529816262,
			0.08358848201148877,
			9101364.686856933
		],
		[
			"Vanguard Target Date Retirement Trust 2015 Select",
			"~",
			"~",
			"FOUSA04B97",
			86166000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Date Retirement Trust Select",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			70713000,
			0.02420873589822837,
			1711872.3415714225,
			0.016543257559609954,
			1169823.3718126987,
			0.04075199345783832,
			2881695.713384121
		],
		[
			"Vanguard Target Date Retirement Trust 2060 Select",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			52601000,
			0.08036342163620322,
			4227196.341485926,
			0.0032255517799972596,
			169667.24917963587,
			0.08358897341620047,
			4396863.590665562
		],
		[
			"Vanguard Target Date Retirement Trust 2065 Select",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			19077000,
			0.08019566005615357,
			1529892.6068912416,
			0.0031660668875217067,
			60399.0580132516,
			0.08336172694367527,
			1590291.6649044931
		]
	],
	"chipotle": [
		[
			"Vanguard Target Retirement 2055 Investment",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			31719308,
			0.08032666379393759,
			2547906.189492355,
			0.00326181821755119,
			103462.6166825172,
			0.08358848201148877,
			2651368.8061748724
		],
		[
			"Vanguard Institutional - Target Retirement 2045 Fund",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			31080746,
			0.0758893350582794,
			2358697.147055277,
			0.004623421317086152,
			143699.38360734016,
			0.08051275637536555,
			2502396.530662617
		],
		[
			"T.Rowe Price Blue Chip Growth",
			"TRBCX",
			"FSUSA0020C",
			"FOUSA00EI7",
			19838817,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Vanguard Institutional - Target Retirement 2035 Fund",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			18984007,
			0.06116514924323183,
			1161159.6213895578,
			0.00930723295448306,
			176688.5755585371,
			0.0704723821977149,
			1337848.196948095
		],
		[
			"Vanguard Institutional Index I",
			"VINIX",
			"FSUSA002Q0",
			"FOUSA00FR3",
			17130439,
			0.09156609528167008,
			1568567.4096908371,
			0,
			0,
			0.09156609528167008,
			1568567.4096908371
		],
		[
			"Vanguard Value Index Inst Fund",
			"VIVIX",
			"FSUSA002PV",
			"FOUSA00IJP",
			12277964,
			0.1742718492197937,
			2139703.490934055,
			0,
			0,
			0.1742718492197937,
			2139703.490934055
		],
		[
			"Vanguard Institutional - Target Retirement 2025 Fund",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			10173045,
			0.04647789761877514,
			472821.74398119235,
			0.012926504408448546,
			131501.91103984544,
			0.059404402027223684,
			604323.6550210378
		],
		[
			"DFA Funds - US Small Cap Portfolio Fund",
			"DFSTX",
			"FSUSA000JV",
			"FOUSA00C29",
			8533171,
			0.07573702220972035,
			646276.9615463417,
			0,
			0,
			0.07573702220972035,
			646276.9615463417
		],
		[
			"American Funds - Europacific Fund",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			7357306,
			0.10771126450519944,
			792464.7326116909,
			0,
			0,
			0.10771126450519944,
			792464.7326116909
		],
		[
			"Vanguard Institutional - Target Retirement 2060 Fund",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			4527650,
			0.08036342163620322,
			363857.4459711555,
			0.0032255517799972596,
			14604.169516704593,
			0.08358897341620047,
			378461.61548786005
		],
		[
			"Vanguard Institutional - Target Retirement 2050 Fund",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			4171034,
			0.08024700579457168,
			334712.9895673555,
			0.003268008966211633,
			13630.976510373572,
			0.08351501476078331,
			348343.96607772907
		],
		[
			"Baird Core Plus Bond Inst",
			"BCOIX",
			"FSUSA008LJ",
			"FOUSA00P5F",
			4120439,
			0.00011463174457650682,
			472.3331109910772,
			0.07245362201307136,
			298540.72983391775,
			0.07256825375764786,
			299013.0629449088
		],
		[
			"Goldman Sachs Stable Value Collective Trust",
			"~",
			"~",
			"~",
			3382963,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Total International Stock Index Adm",
			"VTIAX",
			"FSUSA004JJ",
			"F00000JTEF",
			3311422,
			0.09782558128881824,
			323941.78204258106,
			0,
			0,
			0.09782558128881824,
			323941.78204258106
		],
		[
			"Vangaurd Institutional - Target Retirement 2065 Fund",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			3085984,
			0.08019566005615357,
			247482.52380272903,
			0.0031660668875217067,
			9770.431757821787,
			0.08336172694367527,
			257252.95556055082
		],
		[
			"Vanguard Extended Market Index Adm",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			2937306,
			0.06544225035826598,
			192223.9146308368,
			0,
			0,
			0.06544225035826598,
			192223.9146308368
		],
		[
			"DFA Funds - International Small Company Fund",
			"DFISX",
			"FSUSA003AE",
			"FOUSA00H6R",
			2923433,
			0.0725357888819701,
			212053.5188985845,
			0,
			0,
			0.0725357888819701,
			212053.5188985845
		],
		[
			"Carillon Eagle Mid Cap Growth",
			"HRAUX",
			"FSUSA00439",
			"F00000MMWN",
			2378345,
			0.03976601381031713,
			94577.30011569869,
			0,
			0,
			0.03976601381031713,
			94577.30011569869
		],
		[
			"American Century Mid Cap Value",
			"AMDVX",
			"FSUSA04XKE",
			"F00000Q7J5",
			1785476,
			0.14064807933063395,
			251123.77009094297,
			0,
			0,
			0.14064807933063395,
			251123.77009094297
		],
		[
			"Vanguard Total Bond Market Index Adm",
			"VBTLX",
			"FSUSA002PJ",
			"FOUSA02TYI",
			1595975,
			0,
			0,
			0.04136148656372853,
			66011.89851854664,
			0.04136148656372853,
			66011.89851854664
		],
		[
			"Vanguard Institutional - Target Retirement 2030 Fund",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			1294991,
			0.05426274087980579,
			70269.76107468057,
			0.011496230679006621,
			14887.515263237463,
			0.06575897155881241,
			85157.27633791804
		],
		[
			"Vanguard Funds - Short Term Investment Grade Fund",
			"~",
			"~",
			"~",
			1280389,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional - Target Retirement 2040 Fund",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			1140777,
			0.06823506026662908,
			77840.98734578432,
			0.007062568740663622,
			8056.815980268025,
			0.0752976290072927,
			85897.80332605235
		],
		[
			"Vanguard Institutional - Target Retirement 2015 Fund",
			"~",
			"~",
			"FOUSA04B97",
			794680,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement Income Investment",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			280661,
			0.02420873589822837,
			6794.448025932672,
			0.016543257559609954,
			4643.047209937689,
			0.04075199345783832,
			11437.495235870361
		],
		[
			"Vanguard Target Retirement 2020",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			139389,
			0.035230489202590476,
			4910.742659459884,
			0.014566823354659747,
			2030.4549405826676,
			0.04979731255725022,
			6941.197600042551
		]
	],
	"comcast": [
		[
			"FID 500 INDEX",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			2627720518,
			0.09162563971314869,
			240766573.44911644,
			0,
			0,
			0.09162563971314869,
			240766573.44911644
		],
		[
			"VANGUARD TARGET 2040",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			1542720011,
			0.06823506026662908,
			105267592.92511968,
			0.007062568740663622,
			10895566.12528484,
			0.0752976290072927,
			116163159.05040452
		],
		[
			"VANGUARD TARGET 2035",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			1464184903,
			0.06116514924323183,
			89557088.11168192,
			0.00930723295448306,
			13627509.980658183,
			0.0704723821977149,
			103184598.09234011
		],
		[
			"VANGUARD TARGET 2045",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			1400668934,
			0.0758893350582794,
			106295834.03804903,
			0.004623421317086152,
			6475882.607635937,
			0.08051275637536555,
			112771716.64568496
		],
		[
			"LARGE CAP STOCK FUND",
			"FLCSX",
			"FSUSA000HJ",
			"FOUSA00BWS",
			1394528421,
			0.13737490076042747,
			191573203.4424706,
			0,
			0,
			0.13737490076042747,
			191573203.4424706
		],
		[
			"VANGUARD TARGET 2030",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			1259365743,
			0.05426274087980579,
			68336636.98531309,
			0.011496230679006621,
			14477959.090766568,
			0.06575897155881241,
			82814596.07607965
		],
		[
			"VANGUARD TARGET 2050",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			1155649322,
			0.08024700579457168,
			92737397.83902684,
			0.003268008966211633,
			3776672.3460923946,
			0.08351501476078331,
			96514070.18511923
		],
		[
			"FID GLB EX US IDX",
			"FSGGX",
			"FSUSA0BGZ9",
			"F00000MJRI",
			932094640,
			0.10172962118461953,
			94821634.63541432,
			7.388638841580746e-7,
			688.6910661133222,
			0.10173036004850369,
			94822323.32648043
		],
		[
			"VANGUARD TARGET 2025",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			858675968,
			0.04647789761877514,
			39909453.72840664,
			0.012926504408448546,
			11099678.685780823,
			0.059404402027223684,
			51009132.41418746
		],
		[
			"VANG SM CP IDX IS PL",
			"VSMAX",
			"FSUSA001PZ",
			"FOUSA00L7W",
			783301757,
			0.07578909461851184,
			59365730.97611957,
			0,
			0,
			0.07578909461851184,
			59365730.97611957
		],
		[
			"COMCAST STABLE VALUE",
			"~",
			"~",
			"~",
			740648358,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BOND INDEX FUND",
			"VBMFX",
			"FSUSA002PJ",
			"FOUSA00FQH",
			722787364,
			0,
			0,
			0.04136148656372853,
			29895559.844518762,
			0.04136148656372853,
			29895559.844518762
		],
		[
			"VANGUARD TARGET 2055",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			707730361,
			0.08032666379393759,
			56849618.76480908,
			0.00326181821755119,
			2308487.78462388,
			0.08358848201148877,
			59158106.54943296
		],
		[
			"SMALL MID CAP STOCK",
			"FSCFX",
			"FSUSA077GI",
			"FOUSA05J7U",
			548626425,
			0.03983193288325197,
			21852850.93857847,
			0,
			0,
			0.03983193288325197,
			21852850.93857847
		],
		[
			"VANGUARD TARGET 2020",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			392358018,
			0.035230489202590476,
			13822964.9166988,
			0.014566823354659747,
			5715409.93999041,
			0.04979731255725022,
			19538374.85668921
		],
		[
			"INTERNATIONAL FUND",
			"VTIAX",
			"FSUSA004JJ",
			"F00000JTEF",
			336698754,
			0.09782558128881824,
			32937751.329270817,
			0,
			0,
			0.09782558128881824,
			32937751.329270817
		],
		[
			"VANGUARD TARGET 2060",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			253444613,
			0.08036342163620322,
			20367676.295943353,
			0.0032255517799972596,
			817498.7225928666,
			0.08358897341620047,
			21185175.01853622
		],
		[
			"BOND FUND",
			"~",
			"~",
			"~",
			240486337,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"VANGUARD TARGET 2015",
			"~",
			"~",
			"FOUSA04B97",
			107373636,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"VANGUARD TARGET INC",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			87573769,
			0.02420873589822837,
			2120050.2453334588,
			0.016543257559609954,
			1448755.4160327858,
			0.04075199345783832,
			3568805.661366245
		],
		[
			"VANGUARD TARGET 2065",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			38441631,
			0.08019566005615357,
			3082851.971680095,
			0.0031660668875217067,
			121708.77501142795,
			0.08336172694367527,
			3204560.746691523
		]
	],
	"disney": [
		[
			"Vanguard Institutional 500 Index Trust",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			2603768683,
			0.09174523974228109,
			238883382.05527848,
			0,
			0,
			0.09174523974228109,
			238883382.05527848
		],
		[
			"Disney Stock ESOP Fund",
			"~",
			"~",
			"~",
			2507852220,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Mid-Cap Index Fund Institutional Shares",
			"VIMAX",
			"FSUSA003Q9",
			"FOUSA02TYC",
			771762717,
			0.10952080365600442,
			84524072.9975815,
			0,
			0,
			0.10952080365600442,
			84524072.9975815
		],
		[
			"BlackRock BTC LifePath 2035 F",
			"LIJKX",
			"FSUSA0BDPX",
			"F00000MAPJ",
			602372823,
			0.05940459449733448,
			35783713.28652964,
			0.012372868585268242,
			7453079.778316047,
			0.07177746308260272,
			43236793.06484568
		],
		[
			"BlackRock BTC LifePath 2040 F",
			"LIKKX",
			"FSUSA0BDPW",
			"F00000MAPI",
			597963605,
			0.06965019365638501,
			41648280.887720115,
			0.010014212303853631,
			5988134.490447673,
			0.07966440596023865,
			47636415.378167786
		],
		[
			"Vanguard Institutional Total Bond Market Index Trust",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			587657823,
			0,
			0,
			0.04136148656372853,
			24306401.15008446,
			0.04136148656372853,
			24306401.15008446
		],
		[
			"BlackRock BTC LifePath 2030 F",
			"LINKX",
			"FSUSA0BDPY",
			"F00000MAPK",
			563079772,
			0.04871285292100014,
			27429222.116226293,
			0.014160420067164935,
			7973446.102843456,
			0.06287327298816507,
			35402668.21906975
		],
		[
			"BlackRock BTC LifePath 2045 F",
			"LIHKX",
			"FSUSA0BDPV",
			"F00000MAPH",
			517203038,
			0.07866477829716315,
			40685662.318889245,
			0.008302856189532203,
			4294262.44530316,
			0.08696763448669535,
			44979924.7641924
		],
		[
			"BlackRock BTC LifePath 2050 F",
			"LIPKX",
			"FSUSA0BDPU",
			"F00000MAPG",
			457838521,
			0.08471012883200901,
			38783560.098166466,
			0.004415330955539908,
			2021508.5944099082,
			0.08912545978754892,
			40805068.69257637
		],
		[
			"BlackRock BTC LifePath 2025 F",
			"LIBKX",
			"FSUSA0BDPZ",
			"F00000MAPL",
			456047422,
			0.03700173818270401,
			16874547.307741128,
			0.014567211240572073,
			6643339.131992316,
			0.051568949423276084,
			23517886.439733446
		],
		[
			"Vanguard Prime Money Market Fund Admiral Shares",
			"~",
			"~",
			"~",
			439570973,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BlackRock BTC LifePath Ret F",
			"LIRKX",
			"FSUSA0BDPS",
			"F00000MAOX",
			378844875,
			0.032011560110599045,
			12127415.488654882,
			0.014213872858253112,
			5384852.886250793,
			0.046225432968852155,
			17512268.374905676
		],
		[
			"Vanguard Small-Cap Index Fund Institutional Plus Shares",
			"VSMAX",
			"FSUSA001PZ",
			"FOUSA00L7W",
			373447247,
			0.07578909461851184,
			28303228.737905763,
			0,
			0,
			0.07578909461851184,
			28303228.737905763
		],
		[
			"Fidelity Diversified International Commingled Pool",
			"FDIVX",
			"FSUSA000S4",
			"FOUSA00CF9",
			356785375,
			0.05531848102979012,
			19736824.998644054,
			0,
			0,
			0.05531848102979012,
			19736824.998644054
		],
		[
			"Baron Growth Fund - Unitized",
			"BGRIX",
			"FSUSA002JL",
			"F000002PE0",
			352484913,
			0.006910197893552182,
			2435740.5033215242,
			0,
			0,
			0.006910197893552182,
			2435740.5033215242
		],
		[
			"BlackRock BTC LifePath 2055 F",
			"LIVKX",
			"FSUSA0BDPT",
			"F00000MAP0",
			328076951,
			0.08675189738403444,
			28461297.987218894,
			0.0015049406496713052,
			493736.339780121,
			0.08825683803370574,
			28955034.326999016
		],
		[
			"Vanguard Institutional Total Stock Market Index Trust",
			"VTSAX",
			"FSUSA002PT",
			"FOUSA00L83",
			283099632,
			0.08735255494739627,
			24729476.159867663,
			0,
			0,
			0.08735255494739627,
			24729476.159867663
		],
		[
			"Fidelity International Index Fund",
			"FSPSX",
			"FSUSA004DM",
			"F00000MJRM",
			150479764,
			0.09446078993825728,
			14214437.377162531,
			0,
			0,
			0.09446078993825728,
			14214437.377162531
		],
		[
			"BTC Total Ret Bond M",
			"MAHQX",
			"FSUSA001KY",
			"FOUSA00DR2",
			118356821,
			0.0005349538066688728,
			63315.43193917638,
			0.054640709692091206,
			6467100.696339804,
			0.05517566349876008,
			6530416.12827898
		],
		[
			"Vanguard Treasury Money Market Fund",
			"~",
			"~",
			"~",
			95925767,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BlackRock BTC LifePath 2060 F",
			"LIZKX",
			"FS0000C8VF",
			"F00000WM8M",
			93756566,
			0.08670656047888761,
			8129309.360171818,
			0.0016559941738530904,
			155260.32705647274,
			0.0883625546527407,
			8284569.687228291
		],
		[
			"Frontier MFG Global Equity Fund Institutional Class",
			"FMGEX",
			"FS00008XZA",
			"F00000N7YD",
			75397235,
			0.06105735755658536,
			4603555.936172892,
			0,
			0,
			0.06105735755658536,
			4603555.936172892
		],
		[
			"BlackRock Emerging Markets Index - Unitized",
			"MADCX",
			"FSUSA001KS",
			"FOUSA00DQS",
			52460526,
			0.06684846790969587,
			3506905.7888367656,
			0,
			0,
			0.06684846790969587,
			3506905.7888367656
		],
		[
			"Northern Trust Global Sustainability Index Fund",
			"NSRKX",
			"FSUSA08GBJ",
			"F000014VXA",
			5176424,
			0.0506508680827167,
			262190.3691642087,
			0,
			0,
			0.0506508680827167,
			262190.3691642087
		],
		[
			"BlackRock BTC LifePath 2065 F",
			"LIWKX",
			"FS0000FCWA",
			"F000013OYO",
			3757707,
			0.08654592535593908,
			325214.2295314898,
			0.0019195903309161824,
			7213.258023616055,
			0.08846551568685526,
			332427.4875551058
		],
		[
			"BlackRock EAFE Equity Index Fund",
			"EFA",
			"FSUSA00B7C",
			"FEUSA0002W",
			2055952,
			0.09773802437661318,
			200944.68669314662,
			0,
			0,
			0.09773802437661318,
			200944.68669314662
		],
		[
			"Disney Stock Non ESOP Fund",
			"~",
			"~",
			"~",
			1590997,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"dollar-general": [
		[
			"Vanguard Institutional Index Fund",
			"VINIX",
			"FSUSA002Q0",
			"FOUSA00FR3",
			99279081,
			0.09156609528167008,
			9090597.79032264,
			0,
			0,
			0.09156609528167008,
			9090597.79032264
		],
		[
			"Dodge & Cox Balanced Fund",
			"DODBX",
			"FSUSA000KP",
			"FOUSA00C3I",
			56711462,
			0.06217564229965332,
			3526071.575602382,
			0.02847912914602925,
			1615093.0503581304,
			0.09065477144568257,
			5141164.625960512
		],
		[
			"Nuveen Winslow Large Cap Growth",
			"NVLIX",
			"FSUSA09Q6S",
			"FOUSA08PQ5",
			52709845,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Galliard Capital Wells Fargo Stable Return Fund",
			"~",
			"~",
			"~",
			50182207,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Total Int. Stock Idx Fund",
			"VTSNX",
			"FSUSA004JJ",
			"F00000JTBU",
			48842196,
			0.09782558128881824,
			4778016.215122393,
			0,
			0,
			0.09782558128881824,
			4778016.215122393
		],
		[
			"Vanguard Total Bond Fund",
			"VBTLX",
			"FSUSA002PJ",
			"FOUSA02TYI",
			40617505,
			0,
			0,
			0.04136148656372853,
			1680000.3873096765,
			0.04136148656372853,
			1680000.3873096765
		],
		[
			"The American Funds Group Washington Mutual Investors Fund",
			"RWMGX",
			"FSUSA002RR",
			"F000002PIZ",
			36106044,
			0.08273247126159322,
			2987142.24759982,
			0,
			0,
			0.08273247126159322,
			2987142.24759982
		],
		[
			"Vanguard Extended Mkts Idx Fund",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			30266149,
			0.06544225035826598,
			1980684.9002385815,
			0,
			0,
			0.06544225035826598,
			1980684.9002385815
		],
		[
			"T. Rowe Price Retirement 2035 Fund",
			"TRRJX",
			"FSUSA04WWU",
			"FOUSA0565C",
			22792532,
			0.06280618735226419,
			1431512.0350244767,
			0.006230772697966531,
			142015.0861031285,
			0.06903696005023072,
			1573527.1211276052
		],
		[
			"T. Rowe Price Retirement 2030 Fund",
			"TRRCX",
			"FSUSA00IKU",
			"FOUSA02VNC",
			21896331,
			0.05346417298331525,
			1170669.2282839282,
			0.010217225750691004,
			223719.7569388537,
			0.06368139873400626,
			1394388.985222782
		],
		[
			"Fidelity Low Priced Stock Fund",
			"FLPSX",
			"FSUSA000S6",
			"FOUSA00CFE",
			21889635,
			0.12840389562333845,
			2810714.4077729764,
			0,
			0,
			0.12840389562333845,
			2810714.4077729764
		],
		[
			"T. Rowe Price Retirement 2045 Fund",
			"TRRKX",
			"FSUSA06ALQ",
			"FOUSA05C00",
			21828721,
			0.0758805333888774,
			1656374.9926769894,
			0.000610380574419743,
			13323.827262828307,
			0.07649091396329714,
			1669698.8199398178
		],
		[
			"T. Rowe Price Retirement 2040 Fund",
			"TRRDX",
			"FSUSA00IKV",
			"FOUSA02VND",
			20021239,
			0.07108511849095803,
			1423212.14665079,
			0.0025870968840735814,
			51796.88503219247,
			0.0736722153750316,
			1475009.0316829826
		],
		[
			"The American Funds Group EuroPacific Growth Fund",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			19253054,
			0.10771126450519944,
			2073770.791926888,
			0,
			0,
			0.10771126450519944,
			2073770.791926888
		],
		[
			"MetWest Total Return Bnd Fund",
			"MWTIX",
			"FSUSA003M1",
			"FOUSA00H9T",
			18643047,
			0,
			0,
			0.01732500428117021,
			322990.86908905744,
			0.01732500428117021,
			322990.86908905744
		],
		[
			"T. Rowe Price Retirement 2050 Fund",
			"TRRMX",
			"FSUSA07VNR",
			"FOUSA068A0",
			18493850,
			0.07706701077861977,
			1425265.7372881772,
			0.0002542667347442549,
			4702.370852350039,
			0.07732127751336403,
			1429968.1081405273
		],
		[
			"T. Rowe Price Retirement 2055 Fund",
			"TRRNX",
			"FSUSA07VNU",
			"FOUSA068A1",
			15901453,
			0.0777479202277828,
			1236304.8993498376,
			0.0002564644226942413,
			4078.156963644611,
			0.07800438465047704,
			1240383.056313482
		],
		[
			"T. Rowe Price Retirement 2025 Fund",
			"TRRHX",
			"FSUSA04WWT",
			"FOUSA0565B",
			15891393,
			0.04454610900182352,
			707899.7247688153,
			0.013662544600876634,
			217116.86563255874,
			0.05820865360270015,
			925016.590401374
		],
		[
			"Carillon Eagle Small Cap Growth Fnd",
			"HSRUX",
			"FSUSA001RL",
			"F00000MMWM",
			13858487,
			0.059104100631599175,
			819093.4102497089,
			0,
			0,
			0.059104100631599175,
			819093.4102497089
		],
		[
			"Carillon Eagle Mid Cap Growth Fnd",
			"HRAUX",
			"FSUSA00439",
			"F00000MMWN",
			8281584,
			0.03976601381031713,
			329325.58371530136,
			0,
			0,
			0.03976601381031713,
			329325.58371530136
		],
		[
			"T. Rowe Price Retirement 2020 Fund",
			"TRRBX",
			"FSUSA00IKT",
			"FOUSA02VNB",
			6936066,
			0.03896737715584961,
			270280.29979986517,
			0.01601524401261812,
			111082.78947762412,
			0.05498262116846773,
			381363.0892774893
		],
		[
			"T. Rowe Price Retirement 2060 Fund",
			"TRRLX",
			"FS0000AOEU",
			"F00000SZHW",
			6919746,
			0.07767173056805268,
			537468.6469113603,
			0.0002557631270544299,
			1769.8158753823832,
			0.07792749369510711,
			539238.4627867427
		],
		[
			"T. Rowe Price Retirement 2005 Fund",
			"TRRFX",
			"FSUSA04WWR",
			"FOUSA05659",
			4258137,
			0.03113399984904949,
			132572.83671523206,
			0.0180240645308849,
			76748.93606934864,
			0.04915806437993439,
			209321.7727845807
		],
		[
			"Victory Integrity Small-Cap Value Fn",
			"MVSSX",
			"FSUSA04YJ3",
			"F00000O2T1",
			3534910,
			0.096119404970849,
			339773.44582550385,
			0,
			0,
			0.096119404970849,
			339773.44582550385
		],
		[
			"T. Rowe Price Retirement 2015 Fund",
			"TRRGX",
			"FSUSA04WWS",
			"FOUSA0565A",
			1891594,
			0.036351302616986436,
			68761.90592247584,
			0.01669395071816623,
			31578.177014778932,
			0.05304525333515267,
			100340.08293725477
		],
		[
			"T. Rowe Price Retirement 2010 Fund",
			"TRRAX",
			"FSUSA00IKS",
			"FOUSA02VNA",
			1632619,
			0.03398477448010643,
			55484.18852693688,
			0.01723055890743696,
			28130.93785290082,
			0.05121533338754339,
			83615.1263798377
		],
		[
			"T. Rowe Price Retirement 2065 Fund",
			"TRSJX",
			"FS0000G0EV",
			"F0000155P4",
			444366,
			0.07806994425862915,
			34691.62885043,
			0.0002592726907538679,
			115.21196849953327,
			0.07832921694938301,
			34806.84081892954
		]
	],
	"duke-university": [
		[
			"Annuity contracts",
			"~",
			"~",
			"~",
			1822001478,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Inst Index Plus",
			"VIIIX",
			"FSUSA002Q0",
			"FOUSA00GPG",
			732551318,
			0.09156609528167008,
			67076863.78270099,
			0,
			0,
			0.09156609528167008,
			67076863.78270099
		],
		[
			"Fidelity Contrafund K6",
			"FLCNX",
			"FS0000D2Y7",
			"F00000YI8R",
			687291328,
			0.13439961963992988,
			92371693.06502229,
			0,
			0,
			0.13439961963992988,
			92371693.06502229
		],
		[
			"Vanguard Inst TR 2030",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			509176819,
			0.05426274087980579,
			27629329.79140077,
			0.011496230679006621,
			5853614.167626802,
			0.06575897155881241,
			33482943.959027573
		],
		[
			"Vanguard Inst TR 2035",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			483924196,
			0.06116514924323183,
			29599295.670750972,
			0.00930723295448306,
			4503995.22448292,
			0.0704723821977149,
			34103290.89523389
		],
		[
			"Vanguard Inst TR 2025",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			458960100,
			0.04647789761877514,
			21331500.5389028,
			0.012926504408448546,
			5932749.755951986,
			0.059404402027223684,
			27264250.294854786
		],
		[
			"Vanguard Inst TR 2040",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			424569231,
			0.06823506026662908,
			28970507.064641364,
			0.007062568740663622,
			2998549.3791081924,
			0.0752976290072927,
			31969056.443749554
		],
		[
			"Vanguard Inst TR 2045",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			361496358,
			0.0758893350582794,
			27433718.23460972,
			0.004623421317086152,
			1671349.9676262073,
			0.08051275637536555,
			29105068.202235926
		],
		[
			"Vanguard Inst TR 2020",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			278119597,
			0.035230489202590476,
			9798289.459137315,
			0.014566823354659747,
			4051319.040968157,
			0.04979731255725022,
			13849608.500105472
		],
		[
			"Vanguard Inst TR 2050",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			244282463,
			0.08024700579457168,
			19602936.223873243,
			0.003268008966211633,
			798317.2793722615,
			0.08351501476078331,
			20401253.503245503
		],
		[
			"Vanguard Extended Market Index ISP",
			"VEMPX",
			"FSUSA002PR",
			"F00000JXVS",
			230891495,
			0.06544225035826598,
			15110059.021384317,
			0,
			0,
			0.06544225035826598,
			15110059.021384317
		],
		[
			"Vanguard Vmmr – Fed MMKT",
			"~",
			"~",
			"~",
			186163345,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"MFS Value R6",
			"MEIKX",
			"FSUSA003SQ",
			"FOUSA05HQN",
			157270894,
			0.12293311937951451,
			19333801.58702497,
			0,
			0,
			0.12293311937951451,
			19333801.58702497
		],
		[
			"Metwest Tot Rtn BD P",
			"MWTSX",
			"FSUSA003M1",
			"F00000MN7G",
			142347103,
			0,
			0,
			0.01732500428117021,
			2466164.168887177,
			0.01732500428117021,
			2466164.168887177
		],
		[
			"VALIC Fixed Interest",
			"~",
			"~",
			"~",
			131918542,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Intl Growth Adm",
			"VWILX",
			"FSUSA002RE",
			"FOUSA02TID",
			130944715,
			0.018540085303569338,
			2427726.1861515753,
			0,
			0,
			0.018540085303569338,
			2427726.1861515753
		],
		[
			"Vanguard Total Bond Mk IS Pl",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			124390603,
			0,
			0,
			0.04136148656372853,
			5144980.25463859,
			0.04136148656372853,
			5144980.25463859
		],
		[
			"PIMCO Income Inst",
			"PIMIX",
			"FSUSA07XD8",
			"FOUSA069X9",
			115410391,
			0.0002500573069478645,
			28859.21156726006,
			0.009435029807897632,
			1088900.4792261205,
			0.009685087114845496,
			1117759.6907933806
		],
		[
			"Vanguard Inst TR 2055",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			114139770,
			0.08032666379393759,
			9168466.930307364,
			0.00326181821755119,
			372303.18113310274,
			0.08358848201148877,
			9540770.111440467
		],
		[
			"Vanguard PRIMECAP Adm",
			"VPMAX",
			"FSUSA002QX",
			"FOUSA02TYD",
			109460274,
			0.025716153301301933,
			2814897.186586514,
			0,
			0,
			0.025716153301301933,
			2814897.186586514
		],
		[
			"AF Europac Growth R6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			83958709,
			0.10771126450519944,
			9043298.712614069,
			0,
			0,
			0.10771126450519944,
			9043298.712614069
		],
		[
			"MM Sel Mid Cap Gr I",
			"MEFZX",
			"FSUSA0044N",
			"F00000JS7I",
			83345914,
			0.03964963434675889,
			3304635.0143964123,
			0,
			0,
			0.03964963434675889,
			3304635.0143964123
		],
		[
			"TRP Growth Stock I",
			"PRUFX",
			"FSUSA00219",
			"F00000VWMT",
			83102504,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"J H Triton N",
			"JGMNX",
			"FSUSA067P5",
			"F00000OB8D",
			83009475,
			0.02656424417069494,
			2205083.9623811976,
			0,
			0,
			0.02656424417069494,
			2205083.9623811976
		],
		[
			"Vanguard Total Intl Stk IS",
			"VTSNX",
			"FSUSA004JJ",
			"F00000JTBU",
			76005008,
			0.09782558128881824,
			7435234.088461281,
			0,
			0,
			0.09782558128881824,
			7435234.088461281
		],
		[
			"Vanguard Inst TR 2015",
			"~",
			"~",
			"FOUSA04B97",
			73892744,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard FTSE Social Index IS",
			"VFTNX",
			"FSUSA003PD",
			"FOUSA02SNF",
			62000486,
			0.003717931470108064,
			230513.55806139443,
			0,
			0,
			0.003717931470108064,
			230513.55806139443
		],
		[
			"Vanguard Inst TR Income",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			57407154,
			0.02420873589822837,
			1389754.6298549243,
			0.016543257559609954,
			949701.3343861928,
			0.04075199345783832,
			2339455.9642411172
		],
		[
			"MFS Mid Cap Value R6",
			"MVCKX",
			"FSUSA00DUD",
			"F00000PGEH",
			47709595,
			0.14896223205199224,
			7106927.761496569,
			0,
			0,
			0.14896223205199224,
			7106927.761496569
		],
		[
			"Vanguard Equity Income Adm",
			"VEIRX",
			"FSUSA002PL",
			"FOUSA02TIM",
			47192579,
			0.17590873034694984,
			8301586.653688128,
			0,
			0,
			0.17590873034694984,
			8301586.653688128
		],
		[
			"Vanguard Real Est Idx IS",
			"VGSNX",
			"FSUSA004JF",
			"FOUSA04BEQ",
			43873485,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Vanguard Emerging Markets Stock Index IS",
			"VEMIX",
			"FSUSA000I3",
			"FOUSA00P1W",
			39754233,
			0.09589525710246337,
			3812242.3944462338,
			0,
			0,
			0.09589525710246337,
			3812242.3944462338
		],
		[
			"AM Cent MD Cp Val R6",
			"AMDVX",
			"FSUSA04XKE",
			"F00000Q7J5",
			35120571,
			0.14064807933063395,
			4939640.856145162,
			0,
			0,
			0.14064807933063395,
			4939640.856145162
		],
		[
			"Vanguard Inst TR 2060",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			33338072,
			0.08036342163620322,
			2679161.536674101,
			0.0032255517799972596,
			107533.6774812768,
			0.08358897341620047,
			2786695.214155378
		],
		[
			"Fidelity Small Cap Growth K6",
			"FOCSX",
			"FS0000D2Y4",
			"F00000YI8K",
			33328510,
			0.05535856413350323,
			1845018.4583091037,
			0,
			0,
			0.05535856413350323,
			1845018.4583091037
		],
		[
			"GS SM Cap Value R6",
			"GSSUX",
			"FSUSA00159",
			"F00000VYY8",
			27961319,
			0.08787665710784386,
			2457147.2420460396,
			0,
			0,
			0.08787665710784386,
			2457147.2420460396
		],
		[
			"Fidelity Small Cap Value",
			"FCPVX",
			"FSUSA05RFV",
			"FOUSA05B4X",
			26556140,
			0.08686543487473683,
			2306810.649694394,
			0,
			0,
			0.08686543487473683,
			2306810.649694394
		],
		[
			"Fidelity Intl Small Cap",
			"FISMX",
			"FSUSA04AR6",
			"FOUSA02VJ6",
			16128252,
			0.04716640215995503,
			760711.6199690991,
			0,
			0,
			0.04716640215995503,
			760711.6199690991
		],
		[
			"Vanguard Inst TR 2065",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			9774380,
			0.08019566005615357,
			783862.8557396664,
			0.0031660668875217067,
			30946.34086405442,
			0.08336172694367527,
			814809.1966037208
		],
		[
			"Fidelity Low Priced St K6",
			"FLKSX",
			"FS0000D3Q5",
			"F00000YK7Z",
			5755451,
			0.12726351010832462,
			732458.8965164671,
			0,
			0,
			0.12726351010832462,
			732458.8965164671
		]
	],
	"etsy": [
		[
			"Vanguard Target Retirement 2050 Institutional Fund",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			28435649,
			0.08024700579457168,
			2281875.6900754063,
			0.003268008966211633,
			92927.95589204686,
			0.08351501476078331,
			2374803.6459674533
		],
		[
			"Vanguard Target Retirement 2055 Institutional Fund",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			26844038,
			0.08032666379393759,
			2156292.015297685,
			0.00326181821755119,
			87560.37218103641,
			0.08358848201148877,
			2243852.3874787213
		],
		[
			"Vanguard Target Retirement 2045 Institutional Fund",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			18019155,
			0.0758893350582794,
			1367461.6912620706,
			0.004623421317086152,
			83310.14534287954,
			0.08051275637536555,
			1450771.83660495
		],
		[
			"Fidelity 500 Index Fund",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			12976925,
			0.09162563971314869,
			1189019.054634552,
			0,
			0,
			0.09162563971314869,
			1189019.054634552
		],
		[
			"Vanguard Target Retirement 2040 Institutional Fund",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			8971633,
			0.06823506026662908,
			612179.9184450783,
			0.007062568740663622,
			63362.774778506195,
			0.0752976290072927,
			675542.6932235844
		],
		[
			"Vanguard Target Retirement 2060 Institutional Fund",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			8315813,
			0.08036342163620322,
			668287.18636682,
			0.0032255517799972596,
			26823.08542427435,
			0.08358897341620047,
			695110.2717910943
		],
		[
			"Vanguard Target Retirement 2035 Institutional Fund",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			5567445,
			0.06116514924323183,
			340533.60432848486,
			0.00930723295448306,
			51817.50757627194,
			0.0704723821977149,
			392351.1119047568
		],
		[
			"Vanguard Target Retirement 2030 Institutional Fund",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			2499565,
			0.05426274087980579,
			135633.24790723177,
			0.011496230679006621,
			28735.575837171185,
			0.06575897155881241,
			164368.82374440297
		],
		[
			"Vanguard Target Retirement 2025 Institutional Fund",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			2203591,
			0.04647789761877514,
			102418.27689165433,
			0.012926504408448546,
			28484.72877591754,
			0.059404402027223684,
			130903.00566757187
		],
		[
			"T. Rowe Price Blue Chip Growth Fund (Class I)",
			"TBCIX",
			"FSUSA0020C",
			"F00000WMWX",
			1924041,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Vanguard FTSE Social Index Fund (Admiral Shares)",
			"VFTAX",
			"FSUSA003PD",
			"F000011IZ5",
			1853920,
			0.003717931470108064,
			6892.747511062742,
			0,
			0,
			0.003717931470108064,
			6892.747511062742
		],
		[
			"Fidelity International Index Fund",
			"FSPSX",
			"FSUSA004DM",
			"F00000MJRM",
			1811419,
			0.09446078993825728,
			171108.06964916806,
			0,
			0,
			0.09446078993825728,
			171108.06964916806
		],
		[
			"Fidelity Mid Cap Index Fund",
			"FSMDX",
			"FSUSA0BGZB",
			"F00000MJRP",
			1619025,
			0.10367535191096297,
			167852.9866276468,
			0,
			0,
			0.10367535191096297,
			167852.9866276468
		],
		[
			"Fidelity Small Cap Index Fund",
			"FSSNX",
			"FSUSA0BGZD",
			"F00000MJRV",
			1248009,
			0.086306010873582,
			107710.6783243282,
			0,
			0,
			0.086306010873582,
			107710.6783243282
		],
		[
			"MetLife Stable Value Solutions Fund - Class J",
			"~",
			"~",
			"~",
			1010165,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity US Bond Index Fund",
			"FXNAX",
			"FSUSA000VD",
			"F00000LZX3",
			770475,
			0,
			0,
			0.03886106613218048,
			29941.479928191755,
			0.03886106613218048,
			29941.479928191755
		],
		[
			"Columbia Select Large Cap Value (Institutional 3 Class)",
			"CSRYX",
			"FSUSA0033M",
			"F00000UH3C",
			682195,
			0.23677577786107676,
			161527.25177793726,
			0,
			0,
			0.23677577786107676,
			161527.25177793726
		],
		[
			"Delaware Emerging Markets Fund (Class R6)",
			"DEMZX",
			"FSUSA004R8",
			"F00000X539",
			568410,
			0.13318397180851077,
			75703.10141567561,
			0,
			0,
			0.13318397180851077,
			75703.10141567561
		],
		[
			"DFA Global Equity Portfolio (Institutional Class)",
			"~",
			"~",
			"~",
			525448,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Janus Henderson Enterprise (N)",
			"JDMNX",
			"FSUSA001B1",
			"F00000OB9Z",
			515310,
			0.027094775321335043,
			13962.20867083716,
			0,
			0,
			0.027094775321335043,
			13962.20867083716
		],
		[
			"Cohen & Steers Real Estate Securities Fund (Class Z)",
			"CSZIX",
			"FSUSA003CQ",
			"F00000TXPJ",
			448653,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Carillon Scout Mid Cap Fund (Class R6)",
			"CSMUX",
			"FSUSA0776G",
			"F00000Z6HF",
			375730,
			0.11351931178605341,
			42652.61101737385,
			0,
			0,
			0.11351931178605341,
			42652.61101737385
		],
		[
			"PIMCO Income Fund (Institutional Class)",
			"PIMIX",
			"FSUSA07XD8",
			"FOUSA069X9",
			175540,
			0.0002500573069478645,
			43.89505966162814,
			0.009435029807897632,
			1656.2251324783504,
			0.009685087114845496,
			1700.1201921399786
		],
		[
			"PGIM Total Return Bond Fund (Class R6)",
			"PTRQX",
			"FSUSA0002S",
			"F00000JWHG",
			161785,
			0.0007910288329743016,
			127.97659974274738,
			0.04619359094594325,
			7473.430111189428,
			0.04698461977891755,
			7601.406710932176
		],
		[
			"Vanguard Target Retirement Income Institutional Fund",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			126741,
			0.02420873589822837,
			3068.239396477362,
			0.016543257559609954,
			2096.709006362525,
			0.04075199345783832,
			5164.948402839887
		],
		[
			"Vanguard Target Retirement 2020 Institutional Fund",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			78279,
			0.035230489202590476,
			2757.80746428958,
			0.014566823354659747,
			1140.2763653794104,
			0.04979731255725022,
			3898.0838296689903
		],
		[
			"Vanguard Target Retirement 2065 Institutional Fund",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			69938,
			0.08019566005615357,
			5608.724073007268,
			0.0031660668875217067,
			221.42838597949313,
			0.08336172694367527,
			5830.152458986761
		],
		[
			"Vanguard Target Retirement 2015 Institutional Fund",
			"~",
			"~",
			"FOUSA04B97",
			1290,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"fedex": [
		[
			"Vanguard PRIMECAP Fund Admiral Shares",
			"VPMAX",
			"FSUSA002QX",
			"FOUSA02TYD",
			4065299804,
			0.025716153301301933,
			104543872.9754167,
			0,
			0,
			0.025716153301301933,
			104543872.9754167
		],
		[
			"Vanguard Institutional 500 Index Trust",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			2571701544,
			0.09174523974228109,
			235941374.69987443,
			0,
			0,
			0.09174523974228109,
			235941374.69987443
		],
		[
			"Vanguard Wellington Fund Admiral Shares",
			"VWENX",
			"FSUSA002SA",
			"FOUSA02T18",
			1742523134,
			0.0773361686721528,
			134760063.00615233,
			0.041343049707700606,
			72041220.54578024,
			0.1186792183798534,
			206801283.55193257
		],
		[
			"Vanguard Institutional Total Bond Market Index Trust",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			1413260957,
			0,
			0,
			0.04136148656372853,
			58454574.08399763,
			0.04136148656372853,
			58454574.08399763
		],
		[
			"Vanguard Institutional Extended Market Index Trust",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			1409530651,
			0.06544225035826598,
			92242857.75039163,
			0,
			0,
			0.06544225035826598,
			92242857.75039163
		],
		[
			"Vanguard Institutional Total International Stock Market Index Trust",
			"VTPSX",
			"FSUSA004JJ",
			"F00000JTBV",
			1294269631,
			0.09782558128881824,
			126612678.99703929,
			0,
			0,
			0.09782558128881824,
			126612678.99703929
		],
		[
			"Vanguard Target Retirement 2030 Trust Select",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			1160895874,
			0.05426274087980579,
			62993391.99929767,
			0.011496230679006621,
			13345926.761811005,
			0.06575897155881241,
			76339318.76110868
		],
		[
			"Vanguard Windsor Fund Admiral Shares",
			"VWNEX",
			"FSUSA002SE",
			"FOUSA02TYJ",
			1107876374,
			0.12095909633325012,
			134007725.04799785,
			0,
			0,
			0.12095909633325012,
			134007725.04799785
		],
		[
			"Vanguard Target Retirement 2025 Trust Select",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			1096060610,
			0.04647789761877514,
			50942592.81555223,
			0.012926504408448546,
			14168232.307091802,
			0.059404402027223684,
			65110825.12264403
		],
		[
			"Vanguard Target Retirement 2035 Trust Select",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			1048892147,
			0.06116514924323183,
			64155644.71130886,
			0.00930723295448306,
			9762283.55625689,
			0.0704723821977149,
			73917928.26756576
		],
		[
			"Vanguard Cash Reserves Federal Money Market Fund Admiral Shares",
			"~",
			"~",
			"~",
			1040378190,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Retirement Savings Trust II",
			"~",
			"~",
			"~",
			875219726,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2040 Trust Select",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			831423124,
			0.06823506026662908,
			56732206.97320902,
			0.007062568740663622,
			5871982.965827295,
			0.0752976290072927,
			62604189.93903632
		],
		[
			"Vanguard Target Retirement 2045 Trust Select",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			719608135,
			0.0758893350582794,
			54610582.86767855,
			0.004623421317086152,
			3327051.59130761,
			0.08051275637536555,
			57937634.45898616
		],
		[
			"Vanguard Target Retirement 2050 Trust Select",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			625548405,
			0.08024700579457168,
			50198386.480820075,
			0.003268008966211633,
			2044297.796339386,
			0.08351501476078331,
			52242684.27715946
		],
		[
			"Vanguard Target Retirement 2020 Trust Select",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			576800038,
			0.035230489202590476,
			20320947.510812778,
			0.014566823354659747,
			8402144.26450703,
			0.04979731255725022,
			28723091.775319807
		],
		[
			"Vanguard Target Retirement 2055 Trust Select",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			406916816,
			0.08032666379393759,
			32686270.270931564,
			0.00326181821755119,
			1327288.6834567254,
			0.08358848201148877,
			34013558.95438829
		],
		[
			"Vanguard International Value Fund",
			"VTRIX",
			"FSUSA002L7",
			"FOUSA00FIG",
			330798547,
			0.11946800839662212,
			39519843.5905864,
			0,
			0,
			0.11946800839662212,
			39519843.5905864
		],
		[
			"Vanguard International Growth Fund Admiral Shares",
			"VWILX",
			"FSUSA002RE",
			"FOUSA02TID",
			330155396,
			0.018540085303569338,
			6121109.205273715,
			0,
			0,
			0.018540085303569338,
			6121109.205273715
		],
		[
			"FedEx Corporation Stock Fund",
			"~",
			"~",
			"~",
			277413618,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Inflation-Protected Securities Fund: Inst'l Shares",
			"VIPIX",
			"FSUSA004EW",
			"FOUSA04BL6",
			277108736,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Vanguard Target Retirement 2060 Trust Select",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			178423725,
			0.08036342163620322,
			14338741.042076973,
			0.0032255517799972596,
			575514.9637674915,
			0.08358897341620047,
			14914256.005844465
		],
		[
			"Vanguard Target Retirement 2015 Trust Select",
			"~",
			"~",
			"FOUSA04B97",
			176116184,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"FedEx Diversified Bond Fund",
			"~",
			"~",
			"~",
			103886051,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement Income Trust Select",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			96992005,
			0.02420873589822837,
			2348053.8332846453,
			0.016543257559609954,
			1604563.7199379764,
			0.04075199345783832,
			3952617.553222622
		],
		[
			"Vanguard Target Retirement 2065 Trust Select",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			20966016,
			0.08019566005615357,
			1681383.4918678766,
			0.0031660668875217067,
			66379.8090208503,
			0.08336172694367527,
			1747763.300888727
		],
		[
			"PGIM Total Return Bond Fund; Class R6",
			"PTRQX",
			"FSUSA0002S",
			"F00000JWHG",
			218221,
			0.0007910288329743016,
			172.61910296048507,
			0.04619359094594325,
			10080.41160981468,
			0.04698461977891755,
			10253.030712775166
		],
		[
			"Vanguard Treasury Money Market Fund",
			"~",
			"~",
			"~",
			141,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"google": [
		[
			"The Vanguard Group Inc. Target Retirement Trust 2050",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			4589099444,
			0.08024700579457168,
			368261489.67453367,
			0.003268008966211633,
			14997218.12982882,
			0.08351501476078331,
			383258707.8043625
		],
		[
			"The Vanguard Group Inc. Target Retirement Trust 2045",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			3918414761,
			0.0758893350582794,
			297365890.6948368,
			0.004623421317086152,
			18116482.335192442,
			0.08051275637536555,
			315482373.03002924
		],
		[
			"The Vanguard Group Inc. Institutional 500 Index Trust",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			3897418567,
			0.09174523974228109,
			357569600.8054326,
			0,
			0,
			0.09174523974228109,
			357569600.8054326
		],
		[
			"The Vanguard Group Inc. Target Retirement Trust 2055",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			3702732059,
			0.08032666379393759,
			297428113.2223273,
			0.00326181821755119,
			12077638.884757027,
			0.08358848201148877,
			309505752.10708433
		],
		[
			"The Vanguard Group Inc. Target Retirement Trust 2040",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			2390621883,
			0.06823506026662908,
			163124228.26122728,
			0.007062568740663622,
			16883931.381622206,
			0.0752976290072927,
			180008159.64284948
		],
		[
			"The Vanguard Group Inc. Target Retirement Trust 2060",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			1599578382,
			0.08036342163620322,
			128547591.95282173,
			0.0032255517799972596,
			5159522.897305236,
			0.08358897341620047,
			133707114.85012697
		],
		[
			"The Vanguard Group Inc. Target Retirement Trust 2035",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			1437216376,
			0.06116514924323183,
			87907554.1328568,
			0.00930723295448306,
			13376507.617429918,
			0.0704723821977149,
			101284061.75028671
		],
		[
			"The Vanguard Group Inc. Extended Market Index Trust",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			1296355896,
			0.06544225035826598,
			84836447.09944622,
			0,
			0,
			0.06544225035826598,
			84836447.09944622
		],
		[
			"The Vanguard Group Inc. Developed Markets Index Institutional Plus",
			"VTMNX",
			"FSUSA004S1",
			"FOUSA02SN7",
			912576631,
			0.09912741335312461,
			90461360.91753887,
			0,
			0,
			0.09912741335312461,
			90461360.91753887
		],
		[
			"The Vanguard Group Inc. Target Retirement Trust 2030",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			792261296,
			0.05426274087980579,
			42990269.41394711,
			0.011496230679006621,
			9108018.616864746,
			0.06575897155881241,
			52098288.03081186
		],
		[
			"The Vanguard Group Inc. Total Bond Market Index Trust",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			767703804,
			0,
			0,
			0.04136148656372853,
			31753370.574069284,
			0.04136148656372853,
			31753370.574069284
		],
		[
			"The Vanguard Group Inc. Wellesley Income Fund Admiral Shares",
			"VWIAX",
			"FSUSA002S3",
			"FOUSA02T3B",
			585104843,
			0.06674364087015035,
			39052027.512577705,
			0.07505708756791446,
			43916265.437461846,
			0.1418007284380648,
			82968292.95003955
		],
		[
			"American Funds Growth Fund of America R6 Fund",
			"RGAGX",
			"FSUSA00155",
			"F000002PJ1",
			500619508,
			0.061913527603815195,
			30995119.727566384,
			0,
			0,
			0.061913527603815195,
			30995119.727566384
		],
		[
			"The Vanguard Group Inc. Retirement Savings Trust II (at contract value)",
			"~",
			"~",
			"~",
			425419859,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"The Vanguard Group Inc. REIT Index Fund Institutional Shares",
			"VGSNX",
			"FSUSA004JF",
			"FOUSA04BEQ",
			415282747,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"The Vanguard Group Inc. Emerging Market Index Fund Institutional Plus",
			"VEMRX",
			"FSUSA000I3",
			"F00000JXVQ",
			365820052,
			0.09589525710246337,
			35080407.93977652,
			0,
			0,
			0.09589525710246337,
			35080407.93977652
		],
		[
			"The Vanguard Group Inc. Target Retirement Trust 2025",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			343626508,
			0.04647789761877514,
			15971037.657921216,
			0.012926504408448546,
			4441889.570521779,
			0.059404402027223684,
			20412927.228442997
		],
		[
			"Dodge & Cox Stock Fund",
			"DODGX",
			"FSUSA000KR",
			"FOUSA00C3O",
			226907537,
			0.07557975836793555,
			17149616.818323396,
			0,
			0,
			0.07557975836793555,
			17149616.818323396
		],
		[
			"Fidelity Investments Fidelity Diversified Commingled Pool Fund",
			"FKIDX",
			"FS0000D3Q2",
			"F00000YK7W",
			216875145,
			0.055266179170256585,
			11985860.621145377,
			0,
			0,
			0.055266179170256585,
			11985860.621145377
		],
		[
			"TIAA-CREF Social Choice Equity Fund Institutional Class",
			"TISCX",
			"FSUSA00I37",
			"FOUSA02VJF",
			216283143,
			0.07673451665103896,
			16596382.43787254,
			0,
			0,
			0.07673451665103896,
			16596382.43787254
		],
		[
			"The Vanguard Group Inc. Target Retirement Trust 2065",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			156030285,
			0.08019566005615357,
			12512951.694324758,
			0.0031660668875217067,
			494002.31878907484,
			0.08336172694367527,
			13006954.013113832
		],
		[
			"William Blair Small-Mid Cap Growth Fund, CIT Class III",
			"WSMRX",
			"FSUSA04CED",
			"F000013ARA",
			145117183,
			0.06886535348225435,
			9993546.103643993,
			0,
			0,
			0.06886535348225435,
			9993546.103643993
		],
		[
			"The Vanguard Group Inc. Target Retirement Trust 2020",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			131594758,
			0.035230489202590476,
			4636147.700836507,
			0.014566823354659747,
			1916917.5941851977,
			0.04979731255725022,
			6553065.295021704
		],
		[
			"CRM Small Cap Value Institutional Fund",
			"CRISX",
			"FSUSA000XO",
			"FOUSA00I2O",
			128672680,
			0.11125059196904954,
			14314911.820244081,
			0,
			0,
			0.11125059196904954,
			14314911.820244081
		],
		[
			"Metropolitan West Funds Total Return Bond Fund Class P",
			"MWTSX",
			"FSUSA003M1",
			"F00000MN7G",
			97770182,
			0,
			0,
			0.01732500428117021,
			1693868.8217207906,
			0.01732500428117021,
			1693868.8217207906
		],
		[
			"The Vanguard Group Inc. Total Intl Bond Market Index Fund Institutional",
			"VTIFX",
			"FS0000901Z",
			"F00000NBIN",
			91203954,
			0,
			0,
			0.011645588703408939,
			1062123.7364086285,
			0.011645588703408939,
			1062123.7364086285
		],
		[
			"The Vanguard Group Inc. Target Retirement Income Trust",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			63963820,
			0.02420873589822837,
			1548483.2254218177,
			0.016543257559609954,
			1058169.9487565304,
			0.04075199345783832,
			2606653.174178348
		],
		[
			"The Vanguard Group Inc. Target Retirement Trust 2015",
			"~",
			"~",
			"FOUSA04B97",
			43522382,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Federal Money Market Fund",
			"~",
			"~",
			"~",
			3443266,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"intuit": [
		[
			"Vanguard Target Retirement Trust Plus 2035 Fund",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			363180657,
			0.06116514924323183,
			22213999.08765999,
			0.00930723295448306,
			3380206.9792612093,
			0.0704723821977149,
			25594206.066921197
		],
		[
			"Vanguard Target Retirement Trust Plus 2040 Fund",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			341973783,
			0.06823506026662908,
			23334601.692612134,
			0.007062568740663622,
			2415213.349942285,
			0.0752976290072927,
			25749815.04255442
		],
		[
			"Vanguard Target Retirement Trust Plus 2045 Fund",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			293272624,
			0.0758893350582794,
			22256264.426156793,
			0.004623421317086152,
			1355922.901519392,
			0.08051275637536555,
			23612187.327676184
		],
		[
			"State Street S&P 500 Index SL CL II",
			"SVSPX",
			"FSUSA002BE",
			"FOUSA00F0N",
			286143874,
			0.09115788472509703,
			26084270.28088469,
			0,
			0,
			0.09115788472509703,
			26084270.28088469
		],
		[
			"Vanguard Target Retirement Trust Plus 2050 Fund",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			248365218,
			0.08024700579457168,
			19930565.08801606,
			0.003268008966211633,
			811659.7593191068,
			0.08351501476078331,
			20742224.847335167
		],
		[
			"Vanguard Target Retirement Trust Plus 2030 Fund",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			243924681,
			0.05426274087980579,
			13236021.759292286,
			0.011496230679006621,
			2804214.4010791034,
			0.06575897155881241,
			16040236.16037139
		],
		[
			"Vanguard Target Retirement Trust Plus 2025 Fund",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			170621932,
			0.04647789761877514,
			7930148.687013614,
			0.012926504408448546,
			2205545.156176008,
			0.059404402027223684,
			10135693.843189621
		],
		[
			"Vanguard Target Retirement Trust Plus 2055 Fund",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			160402421,
			0.08032666379393759,
			12884591.343400635,
			0.00326181821755119,
			523203.53895711555,
			0.08358848201148877,
			13407794.88235775
		],
		[
			"State Street S&P Midcap Index SL CL XIV",
			"MDY",
			"FSUSA00B4D",
			"FEUSA00004",
			83801191,
			0.07506285470779923,
			6290356.624373533,
			0,
			0,
			0.07506285470779923,
			6290356.624373533
		],
		[
			"State Street Russell Small Cap Index II",
			"IWM",
			"FSUSA00B5H",
			"FEUSA00017",
			66157645,
			0.08865152567332518,
			5864976.164204233,
			0,
			0,
			0.08865152567332518,
			5864976.164204233
		],
		[
			"Putnam Stable Value Fund",
			"~",
			"~",
			"~",
			59156809,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement Trust Plus 2020 Fund",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			56853455,
			0.035230489202590476,
			2002975.0325074636,
			0.014566823354659747,
			828174.236087097,
			0.04979731255725022,
			2831149.2685945607
		],
		[
			"Vanguard Target Retirement Trust Plus 2060 Fund",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			49373761,
			0.08036342163620322,
			3967844.373008127,
			0.0032255517799972596,
			159257.62267870927,
			0.08358897341620047,
			4127101.995686836
		],
		[
			"State Street US Bond Index SL CL XIV",
			"SSAFX",
			"FS0000AREI",
			"F00000T8Y7",
			45727094,
			0,
			0,
			0.037079954755993495,
			1695558.5766430616,
			0.037079954755993495,
			1695558.5766430616
		],
		[
			"State Street Global All Cap Equity Ex-US Index",
			"SSGVX",
			"FS0000AREJ",
			"F00000T8Y8",
			43798346,
			0.0929421583050248,
			4070712.8074302496,
			0,
			0,
			0.0929421583050248,
			4070712.8074302496
		],
		[
			"Vanguard FTSE Social Index I",
			"VFTAX",
			"FSUSA003PD",
			"F000011IZ5",
			32541790,
			0.003717931470108064,
			120988.14513464789,
			0,
			0,
			0.003717931470108064,
			120988.14513464789
		],
		[
			"Vanguard Target Retirement Trust Plus Income Fund",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			19986446,
			0.02420873589822837,
			483846.5927582028,
			0.016543257559609954,
			330640.92387923616,
			0.04075199345783832,
			814487.5166374389
		],
		[
			"Vanguard Target Retirement Trust Plus 2015 Fund",
			"~",
			"~",
			"FOUSA04B97",
			18723123,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement Trust Plus 2065 Fund",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			13837904,
			0.08019566005615357,
			1109739.8450736876,
			0.0031660668875217067,
			43811.72964710418,
			0.08336172694367527,
			1153551.5747207918
		]
	],
	"keurig-dr-pepper": [
		[
			"Vanguard Target 2035",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			241118409,
			0.06116514924323183,
			14748043.471775614,
			0.00930723295448306,
			2244145.202177325,
			0.0704723821977149,
			16992188.673952937
		],
		[
			"Vanguard Target 2030",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			224716689,
			0.05426274087980579,
			12193743.466574904,
			0.011496230679006621,
			2583394.8941665897,
			0.06575897155881241,
			14777138.360741492
		],
		[
			"Vanguard Target 2025",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			200928097,
			0.04647789761877514,
			9338715.52110132,
			0.012926504408448546,
			2597297.931651677,
			0.059404402027223684,
			11936013.452752996
		],
		[
			"Vanguard Target 2040",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			161977028,
			0.06823506026662908,
			11052512.267389465,
			0.007062568740663622,
			1143973.8946583963,
			0.0752976290072927,
			12196486.162047861
		],
		[
			"Vanguard Target 2045",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			146086607,
			0.0758893350582794,
			11086415.466150185,
			0.004623421317086152,
			675419.9329445871,
			0.08051275637536555,
			11761835.399094772
		],
		[
			"Fidelity Growth Company Pool",
			"FGKFX",
			"FS0000F98E",
			"F000013FUR",
			136944011,
			0.0250924480935117,
			3436260.4877347955,
			0,
			0,
			0.0250924480935117,
			3436260.4877347955
		],
		[
			"Vanguard Target 2050",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			108414348,
			0.08024700579457168,
			8699926.81217071,
			0.003268008966211633,
			354299.06132998824,
			0.08351501476078331,
			9054225.8735007
		],
		[
			"Fidelity Managed Income Portfolio II Class 3",
			"~",
			"~",
			"~",
			96797999,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity 500 Index Fund",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			76455689,
			0.09162563971314869,
			7005301.414334545,
			0,
			0,
			0.09162563971314869,
			7005301.414334545
		],
		[
			"Vanguard Target 2020",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			70837713,
			0.035230489202590476,
			2495647.282982703,
			0.014566823354659747,
			1031880.4521190844,
			0.04979731255725022,
			3527527.7351017874
		],
		[
			"Vanguard Target 2055",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			63374218,
			0.08032666379393759,
			5090639.502489707,
			0.00326181821755119,
			206715.17879546052,
			0.08358848201148877,
			5297354.681285168
		],
		[
			"William Blair Small Mid Cap Growth CIT",
			"WSMRX",
			"FSUSA04CED",
			"F000013ARA",
			28970626,
			0.06886535348225435,
			1995072.4000921885,
			0,
			0,
			0.06886535348225435,
			1995072.4000921885
		],
		[
			"Vanguard Windsor II Fund, Admiral Shares",
			"VWNAX",
			"FSUSA002SF",
			"FOUSA02T2O",
			27361170,
			0.07000661552520242,
			1915462.9085097027,
			0,
			0,
			0.07000661552520242,
			1915462.9085097027
		],
		[
			"Fidelity Extended Market Index Fund",
			"FSMAX",
			"FSUSA003EG",
			"F00000MJRH",
			21858458,
			0.06751712557082101,
			1475820.253570517,
			0,
			0,
			0.06751712557082101,
			1475820.253570517
		],
		[
			"Fidelity U.S. Bond Index Fund",
			"FXNAX",
			"FSUSA000VD",
			"F00000LZX3",
			19227514,
			0,
			0,
			0.03886106613218048,
			747201.6931114261,
			0.03886106613218048,
			747201.6931114261
		],
		[
			"Vanguard Target 2060",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			18309360,
			0.08036342163620322,
			1471402.8175690337,
			0.0032255517799972596,
			59057.78873861062,
			0.08358897341620047,
			1530460.6063076444
		],
		[
			"Vanguard Target 2015",
			"~",
			"~",
			"FOUSA04B97",
			16488302,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"DFA U.S. Small Cap Value Portfolio Institutional Class",
			"DFSVX",
			"FSUSA000K8",
			"FOUSA00C2O",
			15820172,
			0.09200040093616921,
			1455462.166879158,
			0,
			0,
			0.09200040093616921,
			1455462.166879158
		],
		[
			"Metropolitan West Total Return Bond Fund",
			"MWTSX",
			"FSUSA003M1",
			"F00000MN7G",
			14403396,
			0,
			0,
			0.01732500428117021,
			249538.89736338987,
			0.01732500428117021,
			249538.89736338987
		],
		[
			"American Funds EuroPacific Growth Fund",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			12898950,
			0.10771126450519944,
			1389362.2152893422,
			0,
			0,
			0.10771126450519944,
			1389362.2152893422
		],
		[
			"Fidelity Total International Index Fund",
			"FTIHX",
			"FS0000CFDT",
			"F00000WZVM",
			11587430,
			0.0968680146355377,
			1122451.3388282685,
			0,
			0,
			0.0968680146355377,
			1122451.3388282685
		],
		[
			"Vanguard Target Inc.",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			6777324,
			0.02420873589822837,
			164070.4468127247,
			0.016543257559609954,
			112119.01649692598,
			0.04075199345783832,
			276189.46330965066
		],
		[
			"Vanguard Target 2065",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			4290188,
			0.08019566005615357,
			344054.45842498937,
			0.0031660668875217067,
			13583.022168042975,
			0.08336172694367527,
			357637.4805930323
		],
		[
			"Fidelity Government Money Market Fund",
			"~",
			"~",
			"~",
			11242,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"meta": [
		[
			"State Street U.S. Total Market Index Securities Lending Series Fund Class II",
			"SWTSX",
			"FSUSA0042L",
			"FOUSA00K0Q",
			1696370616,
			0.08786211292006932,
			149046706.61727956,
			0,
			0,
			0.08786211292006932,
			149046706.61727956
		],
		[
			"Vanguard Target Retirement 2050 Trust Select",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			1125242438,
			0.08024700579457168,
			90297336.44248396,
			0.003268008966211633,
			3677302.3765458376,
			0.08351501476078331,
			93974638.8190298
		],
		[
			"Vanguard Target Retirement 2055 Trust Select",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			1106582537,
			0.08032666379393759,
			88888083.40984151,
			0.00326181821755119,
			3609471.0784106134,
			0.08358848201148877,
			92497554.48825212
		],
		[
			"Vanguard Target Retirement 2045 Trust Select",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			827189046,
			0.0758893350582794,
			62774826.66843249,
			0.004623421317086152,
			3824443.468536558,
			0.08051275637536555,
			66599270.136969045
		],
		[
			"Vanguard Target Retirement 2060 Trust Select",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			643689590,
			0.08036342163620322,
			51729097.92400478,
			0.0032255517799972596,
			2076254.1027902062,
			0.08358897341620047,
			53805352.026794985
		],
		[
			"Vanguard Target Retirement 2040 Trust Select",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			518738888,
			0.06823506026662908,
			35396179.28532415,
			0.007062568740663622,
			3663629.054955408,
			0.0752976290072927,
			39059808.34027956
		],
		[
			"Vanguard Target Retirement 2065 Trust Select",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			320317539,
			0.08019566005615357,
			25688076.467667714,
			0.0031660668875217067,
			1014146.7537203429,
			0.08336172694367527,
			26702223.221388057
		],
		[
			"Vanguard Target Retirement 2035 Trust Select",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			270872925,
			0.06116514924323183,
			16567982.883575743,
			0.00930723295448306,
			2521077.4140372183,
			0.0704723821977149,
			19089060.29761296
		],
		[
			"State Street Global All Cap Equity Ex-U.S. Index Securities Lending Series Fund Class II",
			"SSGVX",
			"FS0000AREJ",
			"F00000T8Y8",
			212597968,
			0.0929421583050248,
			19759313.997182596,
			0,
			0,
			0.0929421583050248,
			19759313.997182596
		],
		[
			"Vanguard Target Retirement 2030 Trust Select",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			130249356,
			0.05426274087980579,
			7067687.054389577,
			0.011496230679006621,
			1497376.6423680552,
			0.06575897155881241,
			8565063.696757633
		],
		[
			"State Street U.S. Bond Index Securities Lending Series Fund Class XIV",
			"~",
			"~",
			"~",
			119393771,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2025 Trust Select",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			64491927,
			0.04647789761877514,
			2997449.18034352,
			0.012926504408448546,
			833655.1786748418,
			0.059404402027223684,
			3831104.3590183617
		],
		[
			"Invesco Stable Value Trust Class B1",
			"~",
			"~",
			"~",
			50613531,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2020 Trust Select",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			24710386,
			0.035230489202590476,
			870558.9871648429,
			0.014566823354659747,
			359951.8278874573,
			0.04979731255725022,
			1230510.8150523002
		],
		[
			"Vanguard Target Retirement Income Trust Select",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			24157697,
			0.02420873589822837,
			584827.3065824237,
			0.016543257559609954,
			399647.0035180167,
			0.04075199345783832,
			984474.3101004404
		],
		[
			"State Street U.S. Inflation Protected Bond Index Fund",
			"~",
			"~",
			"~",
			23710898,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2015 Trust Select",
			"~",
			"~",
			"FOUSA04B97",
			16827736,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Total International Bond Index Fund Institutional Shares",
			"VTIFX",
			"FS0000901Z",
			"F00000NBIN",
			14463028,
			0,
			0,
			0.011645588703408939,
			168430.47549388718,
			0.011645588703408939,
			168430.47549388718
		],
		[
			"Fidelity Investments Money Market Government Portfolio - Institutional Class",
			"~",
			"~",
			"~",
			1103304,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"microsoft": [
		[
			"Fidelity Growth Company Pool Class 3",
			"FDGRX",
			"FSUSA000TD",
			"FOUSA00CH5",
			5383452917,
			0.02269849389737488,
			122196273.1833295,
			0,
			0,
			0.02269849389737488,
			122196273.1833295
		],
		[
			"Vanguard S&P 500 Index Trust",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			5380662682,
			0.09174523974228109,
			493650187.73243517,
			0,
			0,
			0.09174523974228109,
			493650187.73243517
		],
		[
			"Microsoft Common Stock",
			"~",
			"~",
			"~",
			4765882486,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BlackRock LifePath Index 2040",
			"LIKKX",
			"FSUSA0BDPW",
			"F00000MAPI",
			3373875182,
			0.06965019365638501,
			234991059.79877123,
			0.010014212303853631,
			33786702.359250806,
			0.07966440596023865,
			268777762.15802205
		],
		[
			"BlackRock LifePath Index 2050",
			"LIPKX",
			"FSUSA0BDPU",
			"F00000MAPG",
			3359773694,
			0.08471012883200901,
			284606862.4651348,
			0.004415330955539908,
			14834512.794726865,
			0.08912545978754892,
			299441375.25986165
		],
		[
			"Fidelity Contrafund Pool Class 3",
			"FCNTX",
			"FSUSA000RQ",
			"FOUSA00CEO",
			2676014243,
			0.1466416548994518,
			392415157.12802374,
			0,
			0,
			0.1466416548994518,
			392415157.12802374
		],
		[
			"Artisan Mid Cap Account",
			"~",
			"~",
			"~",
			2507282280,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Russell 1000 Growth Index Trust",
			"VRGWX",
			"FSUSA0AXVO",
			"F00000J3K7",
			2312829817,
			0.014257426913167677,
			32975002.078472473,
			0,
			0,
			0.014257426913167677,
			32975002.078472473
		],
		[
			"BlackRock LifePath Index 2030",
			"LINKX",
			"FSUSA0BDPY",
			"F00000MAPK",
			1955231873,
			0.04871285292100014,
			95244922.65590063,
			0.014160420067164935,
			27686904.650389683,
			0.06287327298816507,
			122931827.30629031
		],
		[
			"Vanguard Russell 1000 Value Index Trust",
			"VRVIX",
			"FSUSA0AXVN",
			"F00000J3KB",
			1643808104,
			0.168348713667367,
			276732979.82439345,
			0,
			0,
			0.168348713667367,
			276732979.82439345
		],
		[
			"International Growth Account",
			"~",
			"~",
			"~",
			1530540995,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Russell 2000 Growth Index Trust",
			"VRTGX",
			"FSUSA0AXVR",
			"F00000J3KD",
			1472231319,
			0.07298745273479551,
			107454413.81019816,
			0,
			0,
			0.07298745273479551,
			107454413.81019816
		],
		[
			"PIMCO Total Return Account",
			"PTTRX",
			"FSUSA001ZG",
			"FOUSA00EH4",
			1403439397,
			0,
			0,
			0.012424118201873642,
			17436496.95749427,
			0.012424118201873642,
			17436496.95749427
		],
		[
			"International Value Account",
			"~",
			"~",
			"~",
			1236307983,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BlackRock LifePath Index 2060",
			"LIZKX",
			"FS0000C8VF",
			"F00000WM8M",
			996631665,
			0.08670656047888761,
			86414503.73649696,
			0.0016559941738530904,
			1650416.2307175049,
			0.0883625546527407,
			88064919.96721447
		],
		[
			"SMID Cap Value Account",
			"~",
			"~",
			"~",
			955125733,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BlackRock Short-term Investment Fund",
			"~",
			"~",
			"~",
			807776060,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Short-Term Bond Index Fund (Signal)",
			"VBIPX",
			"FSUSA001DN",
			"F00000MPYP",
			670093907,
			0,
			0,
			0.029389120548263967,
			19693470.611480184,
			0.029389120548263967,
			19693470.611480184
		],
		[
			"BlackRock LifePath Index Retirement",
			"LIRKX",
			"FSUSA0BDPS",
			"F00000MAOX",
			652370202,
			0.032011560110599045,
			20883387.93568664,
			0.014213872858253112,
			9272707.1077409,
			0.046225432968852155,
			30156095.04342754
		],
		[
			"BlackRock LifePath Index 2055",
			"LIVKX",
			"FSUSA0BDPT",
			"F00000MAP0",
			521616388,
			0.08675189738403444,
			45251211.365606695,
			0.0015049406496713052,
			785001.7058359196,
			0.08825683803370574,
			46036213.07144261
		],
		[
			"BlackRock LifePath Index 2045",
			"LIHKX",
			"FSUSA0BDPV",
			"F00000MAPH",
			445303357,
			0.07866477829716315,
			35029689.85338749,
			0.008302856189532203,
			3697289.7338869185,
			0.08696763448669535,
			38726979.58727441
		],
		[
			"BlackRock LifePath Index 2035",
			"LIJKX",
			"FSUSA0BDPX",
			"F00000MAPJ",
			292686474,
			0.05940459449733448,
			17386921.30282463,
			0.012372868585268242,
			3621371.2794875302,
			0.07177746308260272,
			21008292.582312163
		],
		[
			"BlackRock LifePath Index 2025",
			"LIBKX",
			"FSUSA0BDPZ",
			"F00000MAPL",
			134090083,
			0.03700173818270401,
			4961566.14406305,
			0.014567211240572073,
			1953318.5643268423,
			0.051568949423276084,
			6914884.708389892
		],
		[
			"BlackRock LifePath Index 2065",
			"LIWKX",
			"FS0000FCWA",
			"F000013OYO",
			83687303,
			0.08654592535593908,
			7242795.078677856,
			0.0019195903309161824,
			160645.3376592528,
			0.08846551568685526,
			7403440.416337109
		],
		[
			"PIMCO Inflation Response Multi-Asset Response",
			"PIRMX",
			"FSUSA0BGJW",
			"F00000MISP",
			65110950,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"PIMCO All Asset All Authority",
			"~",
			"~",
			"~",
			47865111,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Wells Fargo Stable Fund C",
			"~",
			"~",
			"~",
			1976487,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"monster-energy-company": [
		[
			"Fidelity 500 Index Fund",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			14458878,
			0.09162563971314869,
			1324803.946284372,
			0,
			0,
			0.09162563971314869,
			1324803.946284372
		],
		[
			"MFS Value Fund",
			"MEIIX",
			"FSUSA003SQ",
			"FOUSA00J13",
			14199853,
			0.12293311937951451,
			1745632.2240205572,
			0,
			0,
			0.12293311937951451,
			1745632.2240205572
		],
		[
			"Columbia Disciplined Growth Fund",
			"RDLAX",
			"FSUSA082GS",
			"FOUSA06C9J",
			13979399,
			0.010353086108154871,
			144729.9215872541,
			0,
			0,
			0.010353086108154871,
			144729.9215872541
		],
		[
			"Vanguard FTSE All World ex-U.S. Index Fund",
			"VFWAX",
			"FSUSA07YWA",
			"F00000MPZ0",
			10625499,
			0.1030830690230197,
			1095309.0468210268,
			0,
			0,
			0.1030830690230197,
			1095309.0468210268
		],
		[
			"Principal Real Estate Securities Fund",
			"PIREX",
			"FSUSA004YD",
			"FOUSA02UNQ",
			9540072,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"MFS International Intrinsic Value Fund",
			"MINJX",
			"FSUSA0003O",
			"FOUSA05IM1",
			9123990,
			0.05971523985556767,
			544841.2512898009,
			0,
			0,
			0.05971523985556767,
			544841.2512898009
		],
		[
			"JPMorgan Emerging Markets Equity Fund",
			"JEMWX",
			"FSUSA00DPZ",
			"F00000QHZ6",
			8919759,
			0.03342197208468727,
			298115.93630013807,
			0,
			0,
			0.03342197208468727,
			298115.93630013807
		],
		[
			"Calvert Equity Fund",
			"CEYIX",
			"FSUSA000AZ",
			"FOUSA00G1X",
			8399339,
			0.01570956800938352,
			131949.98725436736,
			0,
			0,
			0.01570956800938352,
			131949.98725436736
		],
		[
			"PGIM Total Return Bond Fund",
			"PTRQX",
			"FSUSA0002S",
			"F00000JWHG",
			7373239,
			0.0007910288329743016,
			5832.444641410606,
			0.04619359094594325,
			340596.38631267566,
			0.04698461977891755,
			346428.83095408627
		],
		[
			"Goldman Sachs Stable Value Fund",
			"~",
			"~",
			"~",
			6511951,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Intermediate-Term Bond Index Fund",
			"VBILX",
			"FSUSA0005G",
			"FOUSA02TYB",
			5948170,
			0,
			0,
			0.05405218245973321,
			321511.57014151127,
			0.05405218245973321,
			321511.57014151127
		],
		[
			"American Funds EuroPacific Growth Fund",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			5556773,
			0.10771126450519944,
			598527.0463983506,
			0,
			0,
			0.10771126450519944,
			598527.0463983506
		],
		[
			"Hartford World Bond Fund",
			"HWDFX",
			"FSUSA0BDR2",
			"F00000YLPX",
			4750356,
			0,
			0,
			0.013106817935791019,
			62262.05122219248,
			0.013106817935791019,
			62262.05122219248
		],
		[
			"Victory INCORE Fund for Income",
			"VFFIX",
			"FSUSA0014O",
			"F00000LQWX",
			4041248,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"JPMorgan Mid Cap Growth Fund",
			"JMGMX",
			"FSUSA0017G",
			"F00000MT9D",
			3957333,
			0.037644927539160745,
			148973.51403332961,
			0,
			0,
			0.037644927539160745,
			148973.51403332961
		],
		[
			"Victory Sycamore Established Value Fund",
			"VEVRX",
			"FSUSA0014P",
			"F00000SCG4",
			3083916,
			0.05694062466486702,
			175600.10345397802,
			0,
			0,
			0.05694062466486702,
			175600.10345397802
		],
		[
			"Vanguard Small-Cap Index Fund",
			"VSMAX",
			"FSUSA001PZ",
			"FOUSA00L7W",
			2963821,
			0.07578909461851184,
			224625.31020133238,
			0,
			0,
			0.07578909461851184,
			224625.31020133238
		],
		[
			"Vanguard Mid-Cap Index Fund",
			"VIMAX",
			"FSUSA003Q9",
			"FOUSA02TYC",
			2829816,
			0.10952080365600442,
			309923.7225186198,
			0,
			0,
			0.10952080365600442,
			309923.7225186198
		],
		[
			"PIMCO Real Return Fund",
			"PRRIX",
			"FSUSA0041O",
			"FOUSA00G06",
			2711124,
			0,
			0,
			0.000012479734059770732,
			33.83410652306187,
			0.000012479734059770732,
			33.83410652306187
		],
		[
			"Janus Herderson Triton Fund",
			"JGMNX",
			"FSUSA067P5",
			"F00000OB8D",
			2494516,
			0.02656424417069494,
			66264.93211170526,
			0,
			0,
			0.02656424417069494,
			66264.93211170526
		],
		[
			"Victory Sycamore Small Company Opportunity Fund",
			"VSOIX",
			"FSUSA0014N",
			"FOUSA06J7M",
			2202857,
			0.06675300308360864,
			147047.32011374886,
			0,
			0,
			0.06675300308360864,
			147047.32011374886
		],
		[
			"Hartford Schroders U.S. Small Cap Opportunities Fund",
			"SCUIX",
			"FSUSA002F2",
			"FOUSA00F7U",
			1356924,
			0.07390678423387755,
			100285.88928977006,
			0,
			0,
			0.07390678423387755,
			100285.88928977006
		],
		[
			"Vanguard High-Yield Corporate Fund",
			"VWEAX",
			"FSUSA002PZ",
			"FOUSA02TY8",
			1176866,
			0,
			0,
			0.1265529175491234,
			148935.82586436666,
			0.1265529175491234,
			148935.82586436666
		],
		[
			"Eaton Vance High Income Opportunities Fund",
			"EIHIX",
			"FSUSA000NG",
			"F0000044W3",
			1140510,
			0.0033797226453989183,
			3854.6074743039203,
			0.1337193061513311,
			152508.20585865463,
			0.13709902879673003,
			156362.81333295855
		],
		[
			"T. Rowe Price Global Technology Fund",
			"PRGTX",
			"FSUSA004SO",
			"FOUSA00L6I",
			1134538,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"BlackRock Health Sciences Opportunities Fund",
			"SHSSX",
			"FSUSA008V6",
			"FOUSA02SV3",
			972707,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"American Funds American Balanced Fund",
			"RLBGX",
			"FSUSA00023",
			"F000002PJG",
			468766,
			0.06010590625892797,
			28175.60525337263,
			0.01125622765292745,
			5276.536811952189,
			0.07136213391185542,
			33452.14206532482
		],
		[
			"Davis Financial Fund",
			"DVFYX",
			"FSUSA0026W",
			"FOUSA00KXL",
			459737,
			0.06954025528308215,
			31970.22834307834,
			0,
			0,
			0.06954025528308215,
			31970.22834307834
		],
		[
			"Franklin Utilities Fund",
			"FKUTX",
			"FSUSA0011N",
			"FOUSA00CTN",
			289992,
			0.9682305837189952,
			280779.12343383883,
			0,
			0,
			0.9682305837189952,
			280779.12343383883
		],
		[
			"Fidelity Freedom Index 2040 Fund",
			"FFIZX",
			"FSUSA0A7LC",
			"F00000VQAE",
			218236,
			0.08118178627059154,
			17716.788308548814,
			0.002284358349720326,
			498.52922880956504,
			0.08346614462031186,
			18215.31753735838
		],
		[
			"Vanguard Energy Fund",
			"VGELX",
			"FSUSA002R4",
			"FOUSA02TY4",
			212469,
			0.9186086070139206,
			195175.85212364068,
			0,
			0,
			0.9186086070139206,
			195175.85212364068
		],
		[
			"State Street Bank and Trust Company",
			"~",
			"~",
			"~",
			89320,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity Freedom Index 2035 Fund",
			"FFEZX",
			"FSUSA0A7L9",
			"F00000VQAD",
			35358,
			0.06752411712457172,
			2387.517733290607,
			0.006141119326629516,
			217.13769715096643,
			0.07366523645120124,
			2604.655430441573
		],
		[
			"Fidelity Freedom Index 2030 Fund",
			"FFEGX",
			"FSUSA0A7LB",
			"F00000VQAC",
			23845,
			0.0548683033138469,
			1308.3346925186793,
			0.009010601150611443,
			214.85778443632987,
			0.06387890446445835,
			1523.1924769550092
		],
		[
			"Fidelity Freedom Index 2020 Fund",
			"FIWTX",
			"FSUSA0A7LQ",
			"F00000VQAA",
			20950,
			0.04243163690805418,
			888.9427932237351,
			0.01123720740113092,
			235.41949505369277,
			0.0536688443091851,
			1124.3622882774278
		],
		[
			"Fidelity Freedom Index 2015 Fund",
			"FIWFX",
			"FSUSA0A7LJ",
			"F00000VQA9",
			20774,
			0.0341865563797354,
			710.1915222326232,
			0.01249996034774296,
			259.67417626401226,
			0.04668651672747837,
			969.8656984966356
		],
		[
			"Fidelity Freedom Index 2045 Fund",
			"FFOLX",
			"FSUSA0A7LD",
			"F00000VQAF",
			8669,
			0.08415997195869995,
			729.5827969099699,
			0.001467166960861474,
			12.718870383708117,
			0.08562713891956143,
			742.3016672936781
		],
		[
			"Fidelity Freedom Index 2050 Fund",
			"FFOPX",
			"FSUSA0A7L8",
			"F00000VQAG",
			4853,
			0.08416020310030271,
			408.4294656457691,
			0.0014671437717586916,
			7.12004872434493,
			0.0856273468720614,
			415.549514370114
		],
		[
			"Fidelity Freedom Index 2060 Fund",
			"FFLEX",
			"FS0000ASQV",
			"F00000VQ8G",
			1324,
			0.08416118487454465,
			111.42940877389711,
			0.0014670353720073772,
			1.9423548325377673,
			0.08562822024655202,
			113.37176360643488
		],
		[
			"Fidelity Freedom Index 2025 Fund",
			"FFEDX",
			"FSUSA0A7LN",
			"F00000VQAB",
			341,
			0.04892073119255335,
			16.681969336660693,
			0.009985511700430653,
			3.405059489846853,
			0.058906242892984004,
			20.087028826507545
		]
	],
	"netflix": [
		[
			"Vanguard Target 2050",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			179375194,
			0.08024700579457168,
			14394322.23232042,
			0.003268008966211633,
			586199.7423079511,
			0.08351501476078331,
			14980521.974628372
		],
		[
			"Vanguard Target 2045",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			160171473,
			0.0758893350582794,
			12155306.581275152,
			0.004623421317086152,
			740540.2026572891,
			0.08051275637536555,
			12895846.783932442
		],
		[
			"Fidelity Total Market Index Fund",
			"FSKAX",
			"FSUSA003JP",
			"F00000MJS0",
			121843500,
			0.08802007572915496,
			10724674.097105293,
			0,
			0,
			0.08802007572915496,
			10724674.097105293
		],
		[
			"Vanguard Target 2055",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			113997828,
			0.08032666379393759,
			9157065.202995125,
			0.00326181821755119,
			371840.1921316671,
			0.08358848201148877,
			9528905.395126792
		],
		[
			"Fidelity Nasdaq Composite Index Fund",
			"FNCMX",
			"FSUSA04X80",
			"FOUSA04BCT",
			109920219,
			0.018042723673397466,
			1983260.1375363339,
			0,
			0,
			0.018042723673397466,
			1983260.1375363339
		],
		[
			"Vanguard Target 2040",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			109332800,
			0.06823506026662908,
			7460330.197119304,
			0.007062568740663622,
			772170.4156092277,
			0.0752976290072927,
			8232500.6127285315
		],
		[
			"Fidelity Contrafund",
			"FLCNX",
			"FS0000D2Y7",
			"F00000YI8R",
			74104555,
			0.13439961963992988,
			9959624.005586265,
			0,
			0,
			0.13439961963992988,
			9959624.005586265
		],
		[
			"Vanguard Target 2035",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			73186612,
			0.06116514924323183,
			4476470.045586502,
			0.00930723295448306,
			681164.8470333654,
			0.0704723821977149,
			5157634.892619868
		],
		[
			"MainStay Large-Cap Growth Fund",
			"MLRSX",
			"FSUSA000FZ",
			"F00000PRFP",
			31667690,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity Extended Market Index Fund",
			"FSMAX",
			"FSUSA003EG",
			"F00000MJRH",
			30263443,
			0.06751712557082101,
			2043300.6812363842,
			0,
			0,
			0.06751712557082101,
			2043300.6812363842
		],
		[
			"Fidelity International Index Fund",
			"FSPSX",
			"FSUSA004DM",
			"F00000MJRM",
			28541118,
			0.09446078993825728,
			2696016.552001014,
			0,
			0,
			0.09446078993825728,
			2696016.552001014
		],
		[
			"Vanguard Target 2060",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			28127312,
			0.08036342163620322,
			2260407.0337490384,
			0.0032255517799972596,
			90726.10128813828,
			0.08358897341620047,
			2351133.135037177
		],
		[
			"Vanguard Target 2030",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			27835779,
			0.05426274087980579,
			1510445.6630645394,
			0.011496230679006621,
			320006.53651384823,
			0.06575897155881241,
			1830452.1995783877
		],
		[
			"Victory Sycamore Established Value Fund",
			"VEVRX",
			"FSUSA0014P",
			"F00000SCG4",
			25747874,
			0.05694062466486702,
			1466100.0293522882,
			0,
			0,
			0.05694062466486702,
			1466100.0293522882
		],
		[
			"Fidelity Balanced Fund",
			"FBKFX",
			"FS0000F98J",
			"F000013FUW",
			24035624,
			0.04994185355630948,
			1200383.6139425174,
			0.015488563494162869,
			372277.28844582493,
			0.06543041705047235,
			1572660.9023883424
		],
		[
			"Fidelity U.S. Bond Index Fund",
			"FXNAX",
			"FSUSA000VD",
			"F00000LZX3",
			21899816,
			0,
			0,
			0.03886106613218048,
			851050.1978585842,
			0.03886106613218048,
			851050.1978585842
		],
		[
			"Fidelity International Capital Appreciation Fund",
			"FCAKX",
			"FSUSA000RO",
			"FOUSA06U11",
			21681296,
			0.038643952533785816,
			837850.9734949602,
			0,
			0,
			0.038643952533785816,
			837850.9734949602
		],
		[
			"Eaton Vance Atlanta Capital SMID-Cap Fund",
			"ERASX",
			"FSUSA00GIO",
			"F00000T3GN",
			17676273,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"PIMCO Total Return Institutional Fund",
			"PTTRX",
			"FSUSA001ZG",
			"FOUSA00EH4",
			15063239,
			0,
			0,
			0.012424118201873642,
			187147.46183907293,
			0.012424118201873642,
			187147.46183907293
		],
		[
			"Vanguard Target 2025",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			14705155,
			0.04647789761877514,
			683464.6885582193,
			0.012926504408448546,
			190086.25093441916,
			0.059404402027223684,
			873550.9394926385
		],
		[
			"American Beacon Small-Cap Value Institutional Fund",
			"AASRX",
			"FSUSA004F4",
			"F00000YDJB",
			14672961,
			0.09657446583105811,
			1417033.3707349482,
			0,
			0,
			0.09657446583105811,
			1417033.3707349482
		],
		[
			"American Beacon Large-Cap Value Institutional Fund",
			"AALRX",
			"FSUSA00016",
			"F00000YM9F",
			12789314,
			0.13480453410139442,
			1724057.5152464411,
			0,
			0,
			0.13480453410139442,
			1724057.5152464411
		],
		[
			"Franklin Small-Cap Growth Fund",
			"FSMLX",
			"FSUSA0044H",
			"F00000PW2C",
			11708438,
			0.02897519370382724,
			339254.2590192516,
			0,
			0,
			0.02897519370382724,
			339254.2590192516
		],
		[
			"Fidelity Government Money Market Fund",
			"~",
			"~",
			"~",
			9467509,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target 2065",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			7428094,
			0.08019566005615357,
			595700.901289154,
			0.0031660668875217067,
			23517.842450798664,
			0.08336172694367527,
			619218.7437399526
		],
		[
			"Vanguard Target 2020",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			6267211,
			0.035230489202590476,
			220796.90946585627,
			0.014566823354659747,
			91293.35556338046,
			0.04979731255725022,
			312090.26502923673
		],
		[
			"Vanguard Target Retirement Income Fund",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			4188178,
			0.02420873589822837,
			101390.49509677029,
			0.016543257559609954,
			69286.1073594921,
			0.04075199345783832,
			170676.6024562624
		],
		[
			"Vanguard Target 2015",
			"~",
			"~",
			"FOUSA04B97",
			2423763,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity Managed Income Portfolio Fund",
			"~",
			"~",
			"~",
			2179138,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"MFS International Diversification Fund",
			"~",
			"~",
			"~",
			1029872,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"oracle": [
		[
			"Fidelity Growth Company Commingled Pool—Class 3",
			"FDGRX",
			"FSUSA000TD",
			"FOUSA00CH5",
			2918255000,
			0.02269849389737488,
			66239993.30848373,
			0,
			0,
			0.02269849389737488,
			66239993.30848373
		],
		[
			"Vanguard Institutional 500 Index Trust",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			2827124000,
			0.09174523974228109,
			259375169.16115668,
			0,
			0,
			0.09174523974228109,
			259375169.16115668
		],
		[
			"Fidelity Contrafund Commingled Pool—Class 3",
			"FCNTX",
			"FSUSA000RQ",
			"FOUSA00CEO",
			2422214000,
			0.1466416548994518,
			355197469.48062074,
			0,
			0,
			0.1466416548994518,
			355197469.48062074
		],
		[
			"Oracle Corporation Common Stock Fund",
			"~",
			"~",
			"~",
			1077828000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Galliard Stable Value Fund",
			"~",
			"~",
			"~",
			1043942000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Dodge & Cox Stock Fund",
			"DODGX",
			"FSUSA000KR",
			"FOUSA00C3O",
			998766000,
			0.07557975836793555,
			75486492.94610952,
			0,
			0,
			0.07557975836793555,
			75486492.94610952
		],
		[
			"Vanguard Target Retirement 2030 Trust Select",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			903669000,
			0.05426274087980579,
			49035556.788113214,
			0.011496230679006621,
			10388787.281467235,
			0.06575897155881241,
			59424344.06958045
		],
		[
			"Vanguard Target Retirement 2035 Trust Select",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			848753000,
			0.06116514924323183,
			51914103.91564075,
			0.00930723295448306,
			7899541.891816361,
			0.0704723821977149,
			59813645.80745711
		],
		[
			"Fidelity Balanced Fund—Class K",
			"FBAKX",
			"FSUSA000RN",
			"FOUSA06TXQ",
			792229000,
			0.052318992987575336,
			41448623.49555382,
			0.01613312917688602,
			12781132.794675235,
			0.06845212216446135,
			54229756.29022905
		],
		[
			"Vanguard Target Retirement 2040 Trust Select",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			772200000,
			0.06823506026662908,
			52691113.53789098,
			0.007062568740663622,
			5453715.5815404495,
			0.0752976290072927,
			58144829.11943143
		],
		[
			"Vanguard Target Retirement 2025 Trust Select",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			712376000,
			0.04647789761877514,
			33109738.794072557,
			0.012926504408448546,
			9208531.504472941,
			0.059404402027223684,
			42318270.298545495
		],
		[
			"Fidelity Low‐Priced Stock Commingled Pool—Class 3",
			"FLPSX",
			"FSUSA000S6",
			"FOUSA00CFE",
			581708000,
			0.12840389562333845,
			74693573.31526096,
			0,
			0,
			0.12840389562333845,
			74693573.31526096
		],
		[
			"Vanguard Institutional Total Bond Market Index Trust",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			544466000,
			0,
			0,
			0.04136148656372853,
			22519923.14340702,
			0.04136148656372853,
			22519923.14340702
		],
		[
			"Vanguard Institutional Extended Market Index Trust",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			531956000,
			0.06544225035826598,
			34812397.73158174,
			0,
			0,
			0.06544225035826598,
			34812397.73158174
		],
		[
			"Vanguard Target Retirement 2045 Trust Select",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			531207000,
			0.0758893350582794,
			40312946.008303426,
			0.004623421317086152,
			2455993.7675853837,
			0.08051275637536555,
			42768939.77588881
		],
		[
			"US Small Mid Cap Value Fund",
			"~",
			"~",
			"~",
			467495000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2020 Trust Select",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			412433000,
			0.035230489202590476,
			14530216.353291998,
			0.014566823354659747,
			6007838.656632383,
			0.04979731255725022,
			20538055.009924382
		],
		[
			"Vanguard Target Retirement 2050 Trust Select",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			394216000,
			0.08024700579457168,
			31634653.636312872,
			0.003268008966211633,
			1288301.422624085,
			0.08351501476078331,
			32922955.058936957
		],
		[
			"Fidelity Worldwide Fund",
			"FWWFX",
			"FSUSA000VH",
			"FOUSA00CK3",
			391969000,
			0.023570852280737613,
			9239043.397628441,
			0,
			0,
			0.023570852280737613,
			9239043.397628441
		],
		[
			"William Blair Small Mid Cap Growth Separate Account",
			"WSMRX",
			"FSUSA04CED",
			"F000013ARA",
			385970000,
			0.06886535348225435,
			26579960.483545713,
			0,
			0,
			0.06886535348225435,
			26579960.483545713
		],
		[
			"Dodge & Cox International Stock Fund",
			"DODFX",
			"FSUSA0096D",
			"FOUSA02TGA",
			342459000,
			0.10073749418465221,
			34498461.52098181,
			0,
			0,
			0.10073749418465221,
			34498461.52098181
		],
		[
			"Vanguard Target Retirement 2055 Trust Select",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			261421000,
			0.08032666379393759,
			20999076.775674958,
			0.00326181821755119,
			852707.7802504495,
			0.08358848201148877,
			21851784.555925407
		],
		[
			"Loomis Sayles Core Plus Fixed Income Fund D",
			"~",
			"~",
			"~",
			249051000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Wells Fargo Core Bond CIT II – E3",
			"~",
			"~",
			"~",
			249051000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Emerging Markets Stock Fund",
			"~",
			"~",
			"~",
			223157000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional Total International Stock Market Index Trust",
			"VGTSX",
			"FSUSA004JJ",
			"FOUSA00KIR",
			204556000,
			0.09782558128881824,
			20010809.606115505,
			0,
			0,
			0.09782558128881824,
			20010809.606115505
		],
		[
			"Artisan International Separate Account",
			"APHIX",
			"FSUSA0008G",
			"FOUSA00K3X",
			183978000,
			0.04178365419288318,
			7687273.131098261,
			0,
			0,
			0.04178365419288318,
			7687273.131098261
		],
		[
			"Vanguard Target Retirement 2060 Trust Select",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			176141000,
			0.08036342163620322,
			14155293.450422471,
			0.0032255517799972596,
			568151.9160804973,
			0.08358897341620047,
			14723445.366502969
		],
		[
			"Vanguard Target Retirement Income Trust Select",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			114181000,
			0.02420873589822837,
			2764177.6735956133,
			0.016543257559609954,
			1888925.6914138242,
			0.04075199345783832,
			4653103.365009437
		],
		[
			"Vanguard Target Retirement 2015 Trust Select",
			"~",
			"~",
			"FOUSA04B97",
			92106000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2065 Trust Select",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			42628000,
			0.08019566005615357,
			3418580.5968737146,
			0.0031660668875217067,
			134963.09928127532,
			0.08336172694367527,
			3553543.69615499
		],
		[
			"PIMCO Inflation Response Multi‐Asset Fund Institutional",
			"PIRMX",
			"FSUSA0BGJW",
			"F00000MISP",
			25861000,
			0,
			0,
			0,
			0,
			0,
			0
		]
	],
	"oreilly-automotive": [
		[
			"O’Reilly Automotive, Inc. common stock",
			"~",
			"~",
			"~",
			512230000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"T. Rowe Price Retirement 2025 Trust, B",
			"TRRHX",
			"FSUSA04WWT",
			"FOUSA0565B",
			123891000,
			0.04454610900182352,
			5518861.990344917,
			0.013662544600876634,
			1692666.313147207,
			0.05820865360270015,
			7211528.303492124
		],
		[
			"T. Rowe Price Retirement 2030 Trust, B",
			"TRRCX",
			"FSUSA00IKU",
			"FOUSA02VNC",
			119728000,
			0.05346417298331525,
			6401158.502946368,
			0.010217225750691004,
			1223288.0046787325,
			0.06368139873400626,
			7624446.507625101
		],
		[
			"T. Rowe Price Retirement 2035 Trust, B",
			"TRRJX",
			"FSUSA04WWU",
			"FOUSA0565C",
			113749000,
			0.06280618735226419,
			7144141.005132699,
			0.006230772697966531,
			708744.1636209949,
			0.06903696005023072,
			7852885.168753695
		],
		[
			"T. Rowe Price Retirement 2040 Trust, B",
			"TRRDX",
			"FSUSA00IKV",
			"FOUSA02VND",
			94794000,
			0.07108511849095803,
			6738442.722231875,
			0.0025870968840735814,
			245241.26202887108,
			0.0736722153750316,
			6983683.984260746
		],
		[
			"T. Rowe Price Retirement 2045 Trust, B",
			"TRRKX",
			"FSUSA06ALQ",
			"FOUSA05C00",
			88160000,
			0.0758805333888774,
			6689627.823563431,
			0.000610380574419743,
			53811.151440844544,
			0.07649091396329714,
			6743438.975004276
		],
		[
			"T. Rowe Price Retirement 2050 Trust, B",
			"TRRMX",
			"FSUSA07VNR",
			"FOUSA068A0",
			77741000,
			0.07706701077861977,
			5991266.48494068,
			0.0002542667347442549,
			19766.95022575312,
			0.07732127751336403,
			6011033.4351664325
		],
		[
			"T. Rowe Price Retirement 2055 Trust, B",
			"TRRNX",
			"FSUSA07VNU",
			"FOUSA068A1",
			66208000,
			0.0777479202277828,
			5147534.302441044,
			0.0002564644226942413,
			16979.99649774033,
			0.07800438465047704,
			5164514.298938784
		],
		[
			"T. Rowe Price Retirement 2020 Trust, B",
			"TRRBX",
			"FSUSA00IKT",
			"FOUSA02VNB",
			61008000,
			0.03896737715584961,
			2377321.745524073,
			0.01601524401261812,
			977058.0067218062,
			0.05498262116846773,
			3354379.7522458793
		],
		[
			"Fidelity 500 Index Fund",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			29990000,
			0.09162563971314869,
			2747852.934997329,
			0,
			0,
			0.09162563971314869,
			2747852.934997329
		],
		[
			"T. Rowe Price Retirement 2015 Trust, B",
			"TRRGX",
			"FSUSA04WWS",
			"FOUSA0565A",
			27054000,
			0.036351302616986436,
			983448.140999951,
			0.01669395071816623,
			451638.1427292692,
			0.05304525333515267,
			1435086.2837292203
		],
		[
			"T. Rowe Price Retirement 2060 Trust, B",
			"TRRLX",
			"FS0000AOEU",
			"F00000SZHW",
			26722000,
			0.07767173056805268,
			2075543.9842395037,
			0.0002557631270544299,
			6834.502281148476,
			0.07792749369510711,
			2082378.4865206522
		],
		[
			"T. Rowe Price Stable Value Common Trust Fund, N",
			"~",
			"~",
			"~",
			26228000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Harbor Capital Appreciation Fund, Institutional",
			"HACAX",
			"FSUSA0016N",
			"FOUSA00D2I",
			13243000,
			0.02704260563196072,
			358125.2263840558,
			0,
			0,
			0.02704260563196072,
			358125.2263840558
		],
		[
			"T. Rowe Price Retirement 2010 Trust, B",
			"TRRAX",
			"FSUSA00IKS",
			"FOUSA02VNA",
			9097000,
			0.03398477448010643,
			309159.4934455282,
			0.01723055890743696,
			156746.394380954,
			0.05121533338754339,
			465905.8878264822
		],
		[
			"T. Rowe Price QM U.S. Small-Cap Growth Equity Fund",
			"TQAIX",
			"FSUSA0034J",
			"F00000WZOY",
			7958000,
			0.04374968268949459,
			348159.97484299797,
			0,
			0,
			0.04374968268949459,
			348159.97484299797
		],
		[
			"T. Rowe Price Institutional Mid Cap Equity Growth",
			"PMEGX",
			"FSUSA004OJ",
			"FOUSA00KWE",
			7578000,
			0.03855662187698925,
			292182.08058382454,
			0,
			0,
			0.03855662187698925,
			292182.08058382454
		],
		[
			"Vanguard Total International Stock Index Fund, Admiral",
			"VTIAX",
			"FSUSA004JJ",
			"F00000JTEF",
			7391000,
			0.09782558128881824,
			723028.8713056556,
			0,
			0,
			0.09782558128881824,
			723028.8713056556
		],
		[
			"Fidelity Extended Market Index Fund",
			"FSMAX",
			"FSUSA003EG",
			"F00000MJRH",
			7365000,
			0.06751712557082101,
			497263.6298290968,
			0,
			0,
			0.06751712557082101,
			497263.6298290968
		],
		[
			"Fidelity U.S. Bond Index Fund",
			"FXNAX",
			"FSUSA000VD",
			"F00000LZX3",
			7270000,
			0,
			0,
			0.03886106613218048,
			282519.9507809521,
			0.03886106613218048,
			282519.9507809521
		],
		[
			"Vanguard International Growth Fund",
			"VWILX",
			"FSUSA002RE",
			"FOUSA02TID",
			6439000,
			0.018540085303569338,
			119379.60926968296,
			0,
			0,
			0.018540085303569338,
			119379.60926968296
		],
		[
			"JPMorgan Mid Cap Value Fund, L",
			"FLMVX",
			"FSUSA003PY",
			"FOUSA00ID5",
			5330000,
			0.11246280211910323,
			599426.7352948202,
			0,
			0,
			0.11246280211910323,
			599426.7352948202
		],
		[
			"American Beacon Small Cap Value Fund, Institutional",
			"ABSYX",
			"FSUSA004F4",
			"F000002YE4",
			4242000,
			0.09657446583105811,
			409668.8840553485,
			0,
			0,
			0.09657446583105811,
			409668.8840553485
		],
		[
			"T. Rowe Price Retirement 2005 Trust, B",
			"TRRFX",
			"FSUSA04WWR",
			"FOUSA05659",
			3996000,
			0.03113399984904949,
			124411.46339680176,
			0.0180240645308849,
			72024.16186541607,
			0.04915806437993439,
			196435.62526221783
		],
		[
			"BlackRock Equity Dividend Fund, I",
			"MADVX",
			"FSUSA001M1",
			"FOUSA00DTN",
			3949000,
			0.12089250850571198,
			477404.5160890566,
			0,
			0,
			0.12089250850571198,
			477404.5160890566
		],
		[
			"PIMCO Income Fund Institutional Class",
			"PIMIX",
			"FSUSA07XD8",
			"FOUSA069X9",
			3502000,
			0.0002500573069478645,
			875.7006889314215,
			0.009435029807897632,
			33041.474387257505,
			0.009685087114845496,
			33917.17507618893
		],
		[
			"Vanguard Federal Money Market Fund",
			"~",
			"~",
			"~",
			3211000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Inflation Protected Securities Fund",
			"VAIPX",
			"FSUSA004EW",
			"FOUSA05C3V",
			3087000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Metropolitan West Total Return Bond, Admin",
			"MWTNX",
			"FSUSA003M1",
			"FOUSA06P0L",
			2233000,
			0,
			0,
			0.01732500428117021,
			38686.73455985308,
			0.01732500428117021,
			38686.73455985308
		],
		[
			"T. Rowe Price Retirement 2065 Trust, B",
			"TRSJX",
			"FS0000G0EV",
			"F0000155P4",
			1906000,
			0.07806994425862915,
			148801.31375694714,
			0.0002592726907538679,
			494.17374857687224,
			0.07832921694938301,
			149295.487505524
		],
		[
			"Oakmark International Fund, I",
			"OANIX",
			"FSUSA001UU",
			"F00000XOSV",
			1003000,
			0.01617592636046206,
			16224.454139543446,
			0,
			0,
			0.01617592636046206,
			16224.454139543446
		],
		[
			"Cash and cash equivalents",
			"~",
			"~",
			"~",
			55000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"pinterest": [
		[
			"Vanguard Target Retirement 2050 Trust II",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			53588849,
			0.08024700579457168,
			4300344.676227427,
			0.003268008966211633,
			175128.8390209613,
			0.08351501476078331,
			4475473.515248388
		],
		[
			"Vanguard Target Retirement 2055 Trust II",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			51271519,
			0.08032666379393759,
			4118470.068917483,
			0.00326181821755119,
			167238.37471572196,
			0.08358848201148877,
			4285708.443633205
		],
		[
			"Vanguard Institutional Index Fund",
			"VINIX",
			"FSUSA002Q0",
			"FOUSA00FR3",
			32593549,
			0.09156609528167008,
			2984464.0133017823,
			0,
			0,
			0.09156609528167008,
			2984464.0133017823
		],
		[
			"Vanguard Target Retirement 2045 Trust II",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			30330383,
			0.0758893350582794,
			2301752.5979329413,
			0.004623421317086152,
			140230.13931758745,
			0.08051275637536555,
			2441982.7372505288
		],
		[
			"Vanguard Target Retirement 2060 Trust II",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			19617428,
			0.08036342163620322,
			1576523.637781859,
			0.0032255517799972596,
			63277.02980436808,
			0.08358897341620047,
			1639800.667586227
		],
		[
			"Vanguard Target Retirement 2040 Trust II",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			16350477,
			0.06823506026662908,
			1115675.7834831327,
			0.007062568740663622,
			115476.36775513952,
			0.0752976290072927,
			1231152.1512382722
		],
		[
			"Vanguard Extended Market Index Fund",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			8058903,
			0.06544225035826598,
			527392.7477389808,
			0,
			0,
			0.06544225035826598,
			527392.7477389808
		],
		[
			"Vanguard Target Retirement 2035 Trust II",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			6831293,
			0.06116514924323183,
			417837.0558692449,
			0.00930723295448306,
			63580.43533132945,
			0.0704723821977149,
			481417.4912005744
		],
		[
			"Vanguard Developed Markets Index Fund",
			"VTMGX",
			"FSUSA004S1",
			"FOUSA00L5B",
			5787708,
			0.09912741335312461,
			573720.5232831861,
			0,
			0,
			0.09912741335312461,
			573720.5232831861
		],
		[
			"Vanguard Total Bond Market Index Fund",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			5489735,
			0,
			0,
			0.04136148656372853,
			227063.60044093025,
			0.04136148656372853,
			227063.60044093025
		],
		[
			"MFS Growth Fund",
			"MFEKX",
			"FSUSA001JN",
			"F00000MMTN",
			5446197,
			0.02389415547878974,
			130132.27788611825,
			0,
			0,
			0.02389415547878974,
			130132.27788611825
		],
		[
			"Vanguard Emerging Markets Stock Index Fund",
			"VEMAX",
			"FSUSA000I3",
			"FOUSA05IBW",
			3245510,
			0.09589525710246337,
			311229.0158786159,
			0,
			0,
			0.09589525710246337,
			311229.0158786159
		],
		[
			"Vanguard Real Estate Index Fund",
			"VGSNX",
			"FSUSA004JF",
			"FOUSA04BEQ",
			2486514,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Vanguard FTSE Social Index Fund",
			"VFTAX",
			"FSUSA003PD",
			"F000011IZ5",
			2291988,
			0.003717931470108064,
			8521.454314310042,
			0,
			0,
			0.003717931470108064,
			8521.454314310042
		],
		[
			"Vanguard Target Retirement 2065 Trust II",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			1964730,
			0.08019566005615357,
			157562.8191821266,
			0.0031660668875217067,
			6220.466595920523,
			0.08336172694367527,
			163783.28577804714
		],
		[
			"American Funds New Perspective Fund",
			"RNPGX",
			"FSUSA001SL",
			"F000002PIY",
			1938001,
			0.05955341430550321,
			115414.57647747952,
			0,
			0,
			0.05955341430550321,
			115414.57647747952
		],
		[
			"Vanguard Federal Money Market Fund",
			"~",
			"~",
			"~",
			1835030,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2030 Trust II",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			1659709,
			0.05426274087980579,
			90060.35940288159,
			0.011496230679006621,
			19080.3975240234,
			0.06575897155881241,
			109140.75692690499
		],
		[
			"BlackRock Equity Dividend Fund",
			"MRDVX",
			"FSUSA001M1",
			"FOUSA04AXL",
			1652972,
			0.12089250850571198,
			199831.93156970374,
			0,
			0,
			0.12089250850571198,
			199831.93156970374
		],
		[
			"Vanguard Target Retirement 2025 Trust II",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			988573,
			0.04647789761877514,
			45946.794682685395,
			0.012926504408448546,
			12778.793242573205,
			0.059404402027223684,
			58725.5879252586
		],
		[
			"Federated MDT Small Cap Core Fund",
			"QLSCX",
			"FSUSA06FFY",
			"F00000X3MB",
			630873,
			0.09379607358452875,
			59173.41033049241,
			0,
			0,
			0.09379607358452875,
			59173.41033049241
		],
		[
			"American Funds EuroPacific Growth Fund",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			451003,
			0.10771126450519944,
			48578.10342563846,
			0,
			0,
			0.10771126450519944,
			48578.10342563846
		],
		[
			"Vanguard Target Retirement Income Trust II",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			220802,
			0.02420873589822837,
			5345.33730380062,
			0.016543257559609954,
			3652.784355676997,
			0.04075199345783832,
			8998.121659477618
		],
		[
			"Vanguard Target Retirement 2015 Trust II",
			"~",
			"~",
			"FOUSA04B97",
			79858,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2020 Trust II",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			56935,
			0.035230489202590476,
			2005.8479027494886,
			0.014566823354659747,
			829.3620876975527,
			0.04979731255725022,
			2835.2099904470415
		]
	],
	"progressive": [
		[
			"The Progressive Corporation Common Shares",
			"~",
			"~",
			"~",
			2142728019,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional Index Fund Institutional Plus Shares",
			"VIIIX",
			"FSUSA002Q0",
			"FOUSA00GPG",
			782465520,
			0.09156609528167008,
			71647312.35894153,
			0,
			0,
			0.09156609528167008,
			71647312.35894153
		],
		[
			"Vanguard Growth Index Fund Institutional Shares",
			"VIGIX",
			"FSUSA002PU",
			"FOUSA00JGS",
			409540194,
			0.013651090142077344,
			5590670.105097843,
			0,
			0,
			0.013651090142077344,
			5590670.105097843
		],
		[
			"Vanguard Mid-Cap Index Fund Institutional Shares",
			"VMCIX",
			"FSUSA003Q9",
			"FOUSA00J83",
			389333712,
			0.10952080365600442,
			42640141.02861537,
			0,
			0,
			0.10952080365600442,
			42640141.02861537
		],
		[
			"Vanguard Target Retirement 2030 Fund Institutional Shares",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			335685433,
			0.05426274087980579,
			18215211.66800441,
			0.011496230679006621,
			3859117.173350222,
			0.06575897155881241,
			22074328.84135463
		],
		[
			"Vanguard Target Retirement 2040 Fund Institutional Shares",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			327135714,
			0.06823506026662908,
			22322125.160156734,
			0.007062568740663622,
			2310418.4676510748,
			0.0752976290072927,
			24632543.62780781
		],
		[
			"Vanguard Target Retirement 2045 Fund Institutional Shares",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			317513158,
			0.0758893350582794,
			24095862.432874404,
			0.004623421317086152,
			1467997.1031525435,
			0.08051275637536555,
			25563859.536026947
		],
		[
			"Vanguard Target Retirement 2035 Fund Institutional Shares",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			303170655,
			0.06116514924323183,
			18543478.35924335,
			0.00930723295448306,
			2821679.911048215,
			0.0704723821977149,
			21365158.270291563
		],
		[
			"Fidelity Managed Income Portfolio II Class 3",
			"~",
			"~",
			"~",
			280600046,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Small Cap Index Fund Institutional Plus Shares",
			"VSCPX",
			"FSUSA001PZ",
			"F00000JXW4",
			278698858,
			0.07578909461851184,
			21122334.119033195,
			0,
			0,
			0.07578909461851184,
			21122334.119033195
		],
		[
			"Vanguard Balanced Index Fund Institutional Shares",
			"VBAIX",
			"FSUSA002PK",
			"FOUSA00L7S",
			243408173,
			0.05284206680123672,
			12862190.937632985,
			0.01660871007843185,
			4042695.776077783,
			0.06945077687966858,
			16904886.71371077
		],
		[
			"Fidelity Diversified International Fund - Class K6",
			"FKIDX",
			"FS0000D3Q2",
			"F00000YK7W",
			230969612,
			0.055266179170256585,
			12764807.959676646,
			0,
			0,
			0.055266179170256585,
			12764807.959676646
		],
		[
			"Vanguard Target Retirement 2050 Fund Institutional Shares",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			225307499,
			0.08024700579457168,
			18080252.17781345,
			0.003268008966211633,
			736306.9268867185,
			0.08351501476078331,
			18816559.10470017
		],
		[
			"Fidelity Low-Priced Stock Fund - Class K6",
			"FLKSX",
			"FS0000D3Q5",
			"F00000YK7Z",
			199855490,
			0.12726351010832462,
			25434311.17181917,
			0,
			0,
			0.12726351010832462,
			25434311.17181917
		],
		[
			"Vanguard Target Retirement 2025 Fund Institutional Shares",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			199505727,
			0.04647789761877514,
			9272606.753865303,
			0.012926504408448546,
			2578911.659576232,
			0.059404402027223684,
			11851518.413441535
		],
		[
			"Vanguard Value Index Fund Institutional Shares",
			"VIVIX",
			"FSUSA002PV",
			"FOUSA00IJP",
			160556825,
			0.1742718492197937,
			27980534.7976088,
			0,
			0,
			0.1742718492197937,
			27980534.7976088
		],
		[
			"Vanguard Total Bond Market Fund Institutional Plus Shares",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			144305038,
			0,
			0,
			0.04136148656372853,
			5968670.890315335,
			0.04136148656372853,
			5968670.890315335
		],
		[
			"Vanguard Target Retirement 2055 Fund Institutional Shares",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			129855277,
			0.08032666379393759,
			10430841.177447636,
			0.00326181821755119,
			423564.30816375604,
			0.08358848201148877,
			10854405.485611392
		],
		[
			"Vanguard Target Retirement 2020 Fund Institutional Shares",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			96636597,
			0.035230489202590476,
			3404554.5871835873,
			0.014566823354659747,
			1407688.238094442,
			0.04979731255725022,
			4812242.825278029
		],
		[
			"PIMCO Total Return Fund Institutional Class",
			"PTTRX",
			"FSUSA001ZG",
			"FOUSA00EH4",
			81634235,
			0,
			0,
			0.012424118201873642,
			1014233.3849595303,
			0.012424118201873642,
			1014233.3849595303
		],
		[
			"Vanguard Total International Stock Index Fund Institutional Shares",
			"VTSNX",
			"FSUSA004JJ",
			"F00000JTBU",
			81141096,
			0.09782558128881824,
			7937674.882611805,
			0,
			0,
			0.09782558128881824,
			7937674.882611805
		],
		[
			"Vanguard Federal Money Market Fund",
			"~",
			"~",
			"~",
			73363405,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2060 Fund Institutional Shares",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			57362196,
			0.08036342163620322,
			4609822.34312653,
			0.0032255517799972596,
			185024.7334123517,
			0.08358897341620047,
			4794847.076538881
		],
		[
			"Vanguard Target Retirement Income Fund Institutional Shares",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			44953046,
			0.02420873589822837,
			1088256.4184349112,
			0.016543257559609954,
			743669.818066994,
			0.04075199345783832,
			1831926.2365019051
		],
		[
			"Vanguard Target Retirement 2015 Fund Institutional Shares",
			"~",
			"~",
			"FOUSA04B97",
			20165299,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement 2065 Fund Institutional Shares",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			13532211,
			0.08019566005615357,
			1085224.593164142,
			0.0031660668875217067,
			42843.885162057,
			0.08336172694367527,
			1128068.4783261989
		],
		[
			"Fidelity Cash Reserves",
			"~",
			"~",
			"~",
			18646,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"prologis": [
		[
			"Fidelity 500 Index",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			49703000,
			0.09162563971314869,
			4554069.170662629,
			0,
			0,
			0.09162563971314869,
			4554069.170662629
		],
		[
			"Vanguard Growth Index",
			"VIGAX",
			"FSUSA002PU",
			"FOUSA00L97",
			30147000,
			0.013651090142077344,
			411539.4145132057,
			0,
			0,
			0.013651090142077344,
			411539.4145132057
		],
		[
			"Prologis common stock",
			"~",
			"~",
			"~",
			26310000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity Mid Cap Index",
			"FSMDX",
			"FSUSA0BGZB",
			"F00000MJRP",
			25962000,
			0.10367535191096297,
			2691619.4863124206,
			0,
			0,
			0.10367535191096297,
			2691619.4863124206
		],
		[
			"Vanguard Institutional Target Retirement 2035",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			18086000,
			0.06116514924323183,
			1106232.889213091,
			0.00930723295448306,
			168330.61521478064,
			0.0704723821977149,
			1274563.5044278717
		],
		[
			"American Funds Washington Mutual",
			"RWMGX",
			"FSUSA002RR",
			"F000002PIZ",
			17977000,
			0.08273247126159322,
			1487281.6358696613,
			0,
			0,
			0.08273247126159322,
			1487281.6358696613
		],
		[
			"Vanguard Balanced Index",
			"VBIAX",
			"FSUSA002PK",
			"FOUSA00LAO",
			17214000,
			0.05284206680123672,
			909623.337916489,
			0.01660871007843185,
			285902.33529012586,
			0.06945077687966858,
			1195525.6732066148
		],
		[
			"Vanguard Institutional Target Retirement 2045",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			17162000,
			0.0758893350582794,
			1302412.768270191,
			0.004623421317086152,
			79347.15664383255,
			0.08051275637536555,
			1381759.9249140236
		],
		[
			"American Funds Growth Fund of America",
			"RGAGX",
			"FSUSA00155",
			"F000002PJ1",
			16631000,
			0.061913527603815195,
			1029683.8775790505,
			0,
			0,
			0.061913527603815195,
			1029683.8775790505
		],
		[
			"Vanguard Treasury Money Market",
			"~",
			"~",
			"~",
			16588000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Sm-Cap Growth Index",
			"VSGAX",
			"FSUSA003FZ",
			"F00000MPYF",
			15317000,
			0.04976539738744048,
			762256.5917834258,
			0,
			0,
			0.04976539738744048,
			762256.5917834258
		],
		[
			"Vanguard Institutional Target Retirement 2025",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			10500000,
			0.04647789761877514,
			488017.92499713897,
			0.012926504408448546,
			135728.29628870974,
			0.059404402027223684,
			623746.2212858486
		],
		[
			"Fidelity U.S. Bond Index",
			"FXNAX",
			"FSUSA000VD",
			"F00000LZX3",
			9829000,
			0,
			0,
			0.03886106613218048,
			381965.41901320196,
			0.03886106613218048,
			381965.41901320196
		],
		[
			"Vanguard Institutional Target Retirement 2050",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			9555000,
			0.08024700579457168,
			766760.1403671324,
			0.003268008966211633,
			31225.825672152154,
			0.08351501476078331,
			797985.9660392845
		],
		[
			"Artisan International",
			"APHIX",
			"FSUSA0008G",
			"FOUSA00K3X",
			8869000,
			0.04178365419288318,
			370579.2290366809,
			0,
			0,
			0.04178365419288318,
			370579.2290366809
		],
		[
			"Fidelity Total International Index",
			"FTIHX",
			"FS0000CFDT",
			"F00000WZVM",
			8447000,
			0.0968680146355377,
			818244.1196263869,
			0,
			0,
			0.0968680146355377,
			818244.1196263869
		],
		[
			"Vanguard Institutional Target Retirement 2055",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			7805000,
			0.08032666379393759,
			626949.6109116828,
			0.00326181821755119,
			25458.491187987038,
			0.08358848201148877,
			652408.1020996699
		],
		[
			"Vanguard Institutional Target Retirement 2040",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			7284000,
			0.06823506026662908,
			497024.17898212624,
			0.007062568740663622,
			51443.75070699383,
			0.0752976290072927,
			548467.92968912
		],
		[
			"Vanguard Institutional Target Retirement 2030",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			6377000,
			0.05426274087980579,
			346033.4985905215,
			0.011496230679006621,
			73311.46304002522,
			0.06575897155881241,
			419344.9616305467
		],
		[
			"Invesco Global Real Estate",
			"FGREX",
			"FSUSA069N2",
			"F00000OTW6",
			4352000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"American Beacon Small Cap Value",
			"AASRX",
			"FSUSA004F4",
			"F00000YDJB",
			3308000,
			0.09657446583105811,
			319468.3329691402,
			0,
			0,
			0.09657446583105811,
			319468.3329691402
		],
		[
			"Metropolitan West High Yield Bond",
			"MWHIX",
			"FSUSA00GOR",
			"FOUSA02VB5",
			3208000,
			0,
			0,
			0.06615342037369121,
			212220.1725588014,
			0.06615342037369121,
			212220.1725588014
		],
		[
			"Vanguard Institutional Target Retirement 2020",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			3107000,
			0.035230489202590476,
			109461.12995244861,
			0.014566823354659747,
			45259.12016292784,
			0.04979731255725022,
			154720.25011537643
		],
		[
			"Vanguard Institutional Target Retirement 2060",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			2678000,
			0.08036342163620322,
			215213.24314175223,
			0.0032255517799972596,
			8638.02766683266,
			0.08358897341620047,
			223851.2708085849
		],
		[
			"Fidelity Short-Term Bond",
			"~",
			"~",
			"~",
			1887000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional Target Retirement 2015",
			"~",
			"~",
			"FOUSA04B97",
			1663000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"PIMCO Real Return",
			"PRRIX",
			"FSUSA0041O",
			"FOUSA00G06",
			1248000,
			0,
			0,
			0.000012479734059770732,
			15.574708106593874,
			0.000012479734059770732,
			15.574708106593874
		],
		[
			"Vanguard Institutional Target Retirement Income",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			1041000,
			0.02420873589822837,
			25201.29407005573,
			0.016543257559609954,
			17221.53111955396,
			0.04075199345783832,
			42422.82518960969
		],
		[
			"Vanguard Institutional Target Retirement 2065",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			258000,
			0.08019566005615357,
			20690.48029448762,
			0.0031660668875217067,
			816.8452569806003,
			0.08336172694367527,
			21507.32555146822
		],
		[
			"Vanguard Total International Bond Index",
			"VTABX",
			"FS0000901Z",
			"F00000NBIL",
			46000,
			0,
			0,
			0.011645588703408939,
			535.6970803568112,
			0.011645588703408939,
			535.6970803568112
		]
	],
	"qualcomm": [
		[
			"Vanguard Institutional 500 Index Trust",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			1141671249,
			0.09174523974228109,
			104742902.44637449,
			0,
			0,
			0.09174523974228109,
			104742902.44637449
		],
		[
			"Fidelity® OTC Portfolio",
			"FOKFX",
			"FS0000F98G",
			"F000013FUT",
			1076077111,
			0.05161023758962989,
			55536595.363472536,
			0,
			0,
			0.05161023758962989,
			55536595.363472536
		],
		[
			"Fidelity® Contrafund® Commingled Pool",
			"FLCNX",
			"FS0000D2Y7",
			"F00000YI8R",
			1023087300,
			0.13439961963992988,
			137502543.97844285,
			0,
			0,
			0.13439961963992988,
			137502543.97844285
		],
		[
			"Vanguard Target Retirement 2035 Trust Plus",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			410946971,
			0.06116514924323183,
			25135632.812269066,
			0.00930723295448306,
			3824779.1910361946,
			0.0704723821977149,
			28960412.00330526
		],
		[
			"Vanguard Institutional Extended Market Index Trust",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			398143511,
			0.06544225035826598,
			26055407.325381026,
			0,
			0,
			0.06544225035826598,
			26055407.325381026
		],
		[
			"Vanguard Target Retirement 2045 Trust Plus",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			397882277,
			0.0758893350582794,
			30195021.433004133,
			0.004623421317086152,
			1839577.4011725774,
			0.08051275637536555,
			32034598.83417671
		],
		[
			"MetWest Total Return Bond Fund (Class B)",
			"MWTSX",
			"FSUSA003M1",
			"F00000MN7G",
			323639752,
			0,
			0,
			0.01732500428117021,
			5607060.0889568655,
			0.01732500428117021,
			5607060.0889568655
		],
		[
			"Vanguard Target Retirement 2025 Trust Plus",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			304085815,
			0.04647789761877514,
			14133269.376891797,
			0.012926504408448546,
			3930766.6281441688,
			0.059404402027223684,
			18064036.005035967
		],
		[
			"Synthetic Guaranteed Investment Contracts",
			"~",
			"~",
			"~",
			297679383,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"American Beacon Small Cap Value Fund Class R5",
			"AVFIX",
			"FSUSA004F4",
			"FOUSA009MW",
			247799669,
			0.09657446583105811,
			23931120.666788008,
			0,
			0,
			0.09657446583105811,
			23931120.666788008
		],
		[
			"Vanguard Windsor™ II Fund Admiral™ Shares",
			"VWNAX",
			"FSUSA002SF",
			"FOUSA02T2O",
			199741352,
			0.07000661552520242,
			13983216.033948122,
			0,
			0,
			0.07000661552520242,
			13983216.033948122
		],
		[
			"Vanguard Target Retirement 2040 Trust Plus",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			196589465,
			0.06823506026662908,
			13414293.992059369,
			0.007062568740663622,
			1388426.6102527853,
			0.0752976290072927,
			14802720.602312153
		],
		[
			"Vanguard Explorer Fund Admiral Shares",
			"VEXRX",
			"FSUSA000PQ",
			"FOUSA02TY5",
			181102528,
			0.04493826310961819,
			8138433.053080995,
			0,
			0,
			0.04493826310961819,
			8138433.053080995
		],
		[
			"Vanguard Target Retirement 2030 Trust Plus",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			176572902,
			0.05426274087980579,
			9581329.627621341,
			0.011496230679006621,
			2029922.8130536296,
			0.06575897155881241,
			11611252.440674972
		],
		[
			"American Funds EuroPacific Growth Fund® Class R-6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			165259186,
			0.10771126450519944,
			17800275.895159952,
			0,
			0,
			0.10771126450519944,
			17800275.895159952
		],
		[
			"Vanguard Target Retirement 2050 Trust Plus",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			128757916,
			0.08024700579457168,
			10332437.231348975,
			0.003268008966211633,
			420782.0239587243,
			0.08351501476078331,
			10753219.255307699
		],
		[
			"Vanguard Target Retirement 2055 Trust Plus",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			92846461,
			0.08032666379393759,
			7458046.457203939,
			0.00326181821755119,
			302848.27792495606,
			0.08358848201148877,
			7760894.735128894
		],
		[
			"Vanguard Institutional Total Bond Market Index Trust",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			87609100,
			0,
			0,
			0.04136148656372853,
			3623642.612510349,
			0.04136148656372853,
			3623642.612510349
		],
		[
			"Vanguard Target Retirement 2060 Trust Plus",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			54084796,
			0.08036342163620322,
			4346439.265056037,
			0.0032255517799972596,
			174453.31000858865,
			0.08358897341620047,
			4520892.575064626
		],
		[
			"Vanguard Target Retirement 2015 Trust Plus",
			"~",
			"~",
			"FOUSA04B97",
			53555972,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement Income Trust Plus",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			51133257,
			0.02420873589822837,
			1237871.514329237,
			0.016543257559609954,
			845910.6404127287,
			0.04075199345783832,
			2083782.1547419657
		],
		[
			"Vanguard Target Retirement 2020 Trust Plus",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			48699074,
			0.035230489202590476,
			1715692.2007331545,
			0.014566823354659747,
			709390.8084935033,
			0.04979731255725022,
			2425083.009226658
		],
		[
			"Vanguard Institutional Total International Stock Market Index Trust",
			"VTIAX",
			"FSUSA004JJ",
			"F00000JTEF",
			47876208,
			0.09782558128881824,
			4683517.87750437,
			0,
			0,
			0.09782558128881824,
			4683517.87750437
		],
		[
			"Vanguard Target Retirement 2065 Trust Plus",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			13019274,
			0.08019566005615357,
			1044089.2718819187,
			0.0031660668875217067,
			41219.89231097228,
			0.08336172694367527,
			1085309.164192891
		],
		[
			"Wells Fargo/ BlackRock Short Term Investment Fund (ClassS)",
			"~",
			"~",
			"~",
			11014154,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"DFA World ex US Core Equity Portfolio",
			"DFWIX",
			"FS00009WWM",
			"F00000PA0N",
			9802296,
			0.11363940215203903,
			1113927.0571573237,
			0,
			0,
			0.11363940215203903,
			1113927.0571573237
		],
		[
			"Noninterest-bearing cash",
			"~",
			"~",
			"~",
			930022,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Federal Money Market Fund Investor",
			"~",
			"~",
			"~",
			55703,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"quanta-services": [
		[
			"American Funds The Growth Fund of America",
			"RGAGX",
			"FSUSA00155",
			"F000002PJ1",
			138455940,
			0.061913527603815195,
			8572295.66310218,
			0,
			0,
			0.061913527603815195,
			8572295.66310218
		],
		[
			"Fidelity Freedom Blend 2040 Commingled Pool",
			"FHYDX",
			"FS0000DV8X",
			"F000010OKR",
			126965948,
			0.08603716705820114,
			10923790.478778878,
			0.002744183779413093,
			348417.89503940626,
			0.08878135083761422,
			11272208.373818284
		],
		[
			"Fidelity Freedom Blend 2030 Commingled Pool",
			"FHAEX",
			"FS0000DV8V",
			"F000010OK9",
			118300868,
			0.059252544045159575,
			7009627.391750609,
			0.011189234441461101,
			1323696.1466803434,
			0.07044177848662067,
			8333323.538430952
		],
		[
			"Dodge & Cox Stock Fund",
			"DODGX",
			"FSUSA000KR",
			"FOUSA00C3O",
			103453597,
			0.07557975836793555,
			7818997.863553783,
			0,
			0,
			0.07557975836793555,
			7818997.863553783
		],
		[
			"Fidelity Freedom Blend 2050 Commingled Pool",
			"FHWDX",
			"FS0000DV7F",
			"F000010OFI",
			97095500,
			0.08888381689762928,
			8630218.643583763,
			0.0017419882114271545,
			169139.21638262528,
			0.09062580510905643,
			8799357.859966388
		],
		[
			"Fidelity 500 Index Fund",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			93583815,
			0.09162563971314869,
			8574676.91617196,
			0,
			0,
			0.09162563971314869,
			8574676.91617196
		],
		[
			"Vanguard Growth Index Institutional Fund",
			"VIGIX",
			"FSUSA002PU",
			"FOUSA00JGS",
			79165672,
			0.013651090142077344,
			1080697.7246301284,
			0,
			0,
			0.013651090142077344,
			1080697.7246301284
		],
		[
			"Fidelity Freedom Blend 2020 Commingled Pool",
			"FHCEX",
			"FS0000DV8T",
			"F000010OJR",
			76090298,
			0.04565966439650298,
			3474257.4705099016,
			0.014078982174377998,
			1071273.94918511,
			0.059738646570880974,
			4545531.419695011
		],
		[
			"Fidelity Diversified International Fund",
			"FKIDX",
			"FS0000D3Q2",
			"F00000YK7W",
			64359180,
			0.055266179170256585,
			3556885.9731307942,
			0,
			0,
			0.055266179170256585,
			3556885.9731307942
		],
		[
			"Fidelity Total Bond Fund",
			"FTKFX",
			"FS0000D3Q4",
			"F00000YK7Y",
			58355614,
			0.0007172136653917145,
			41853.443813124046,
			0.07059424312342495,
			4119570.402332741,
			0.07131145678881666,
			4161423.846145865
		],
		[
			"Fidelity Freedom Blend 2035 Commingled Pool",
			"FHZDX",
			"FS0000DV8W",
			"F000010OKI",
			51875564,
			0.07249433727538379,
			3760684.6329667573,
			0.007568283429980724,
			392608.97144210455,
			0.08006262070536452,
			4153293.604408862
		],
		[
			"Fidelity Freedom Blend 2045 Commingled Pool",
			"FHXDX",
			"FS0000DV7E",
			"F000010OF5",
			45751051,
			0.08888901660892752,
			4066765.93221489,
			0.001747469166078257,
			79948.55093817381,
			0.09063648577500578,
			4146714.483153064
		],
		[
			"Fidelity Freedom Blend 2025 Commingled Pool",
			"FHBEX",
			"FS0000DV8U",
			"F000010OK0",
			42866406,
			0.05274411901981259,
			2260950.8200156083,
			0.012380532333339609,
			530708.925497063,
			0.0651246513531522,
			2791659.7455126713
		],
		[
			"Fidelity Freedom Blend 2055 Commingled Pool",
			"FHVDX",
			"FS0000DV7G",
			"F000010OFR",
			41262179,
			0.08887399910481011,
			3667134.859508515,
			0.0017478337527625394,
			72119.42916872965,
			0.09062183285757265,
			3739254.2886772444
		],
		[
			"Fidelity Small Cap Growth Fund",
			"FOCSX",
			"FS0000D2Y4",
			"F00000YI8K",
			40467859,
			0.05535856413350323,
			2240242.5677970657,
			0,
			0,
			0.05535856413350323,
			2240242.5677970657
		],
		[
			"Fidelity Freedom Blend 2060 Commingled Pool",
			"FHTDX",
			"FS0000DV7H",
			"F000010OFV",
			31969676,
			0.08884727385005128,
			2840418.558469412,
			0.0017646940514301143,
			56416.69706334809,
			0.0906119679014814,
			2896835.25553276
		],
		[
			"Fidelity Investments Money Market Government Portfolio Fund",
			"~",
			"~",
			"~",
			29036840,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity Low Priced Stock Fund",
			"FLPKX",
			"FSUSA000S6",
			"FOUSA06TXR",
			28764905,
			0.12840389562333845,
			3693525.859235246,
			0,
			0,
			0.12840389562333845,
			3693525.859235246
		],
		[
			"Fidelity Managed Income Portfolio Fund",
			"~",
			"~",
			"~",
			26463933,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity Extended Market Index Fund",
			"FSMAX",
			"FSUSA003EG",
			"F00000MJRH",
			24632999,
			0.06751712557082101,
			1663149.2866689085,
			0,
			0,
			0.06751712557082101,
			1663149.2866689085
		],
		[
			"American Beacon Small Cap Value Fund",
			"AASRX",
			"FSUSA004F4",
			"F00000YDJB",
			18216087,
			0.09657446583105811,
			1759208.8715570818,
			0,
			0,
			0.09657446583105811,
			1759208.8715570818
		],
		[
			"Fidelity Balanced Fund",
			"FBAKX",
			"FSUSA000RN",
			"FOUSA06TXQ",
			16808777,
			0.052318992987575336,
			879418.2859927176,
			0.01613312917688602,
			271178.1706464707,
			0.06845212216446135,
			1150596.4566391883
		],
		[
			"Vanguard Value Index Institutional Fund",
			"VIVIX",
			"FSUSA002PV",
			"FOUSA00IJP",
			16446755,
			0.1742718492197937,
			2866206.407514888,
			0,
			0,
			0.1742718492197937,
			2866206.407514888
		],
		[
			"Fidelity Freedom Blend 2010 Commingled Pool",
			"FHFEX",
			"FS0000DV7K",
			"F000010OGE",
			14392863,
			0.027753363021350536,
			399450.35175556433,
			0.018010506740289138,
			259222.75607355815,
			0.045763869761639674,
			658673.1078291225
		],
		[
			"Vanguard GNMA Admiral Fund",
			"VFIJX",
			"FSUSA002PM",
			"FOUSA02SMJ",
			11224156,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity Freedom Blend 2065 Commingled Pool",
			"FFBKX",
			"FS0000F7H8",
			"F000013DJ9",
			5035700,
			0.09152145142416998,
			460874.5729366928,
			0.001363032595198796,
			6863.8232396425765,
			0.09288448401936877,
			467738.3961763354
		],
		[
			"Dimensional Fund Advisors International Small Cap Value Fund",
			"DISVX",
			"FSUSA0000K",
			"FOUSA00B1V",
			4697143,
			0.09215946232729093,
			432886.1733543983,
			0,
			0,
			0.09215946232729093,
			432886.1733543983
		],
		[
			"Fidelity Freedom Blend Income Commingled Pool",
			"FHHEX",
			"FS0000DV7D",
			"F000010OEU",
			4166690,
			0.018272813520404687,
			76137.149367335,
			0.020187812865364342,
			84116.35798798496,
			0.038460626385769026,
			160253.50735531998
		],
		[
			"Fidelity Freedom Blend 2015 Commingled Pool",
			"FHEEX",
			"FS0000DV8S",
			"F000010OJI",
			3494377,
			0.03667601618560371,
			128159.82741060134,
			0.016007513259696425,
			55936.28616187821,
			0.05268352944530014,
			184096.11357247955
		],
		[
			"Fidelity Freedom Blend 2005 Commingled Pool",
			"FHGEX",
			"FS0000DV7J",
			"F000010OG5",
			1743823,
			0.018341182707600424,
			31983.776252715892,
			0.021410169743888333,
			37335.546433296586,
			0.03975135245148875,
			69319.32268601249
		]
	],
	"regeneron-pharmaceuticals": [
		[
			"Regeneron Pharmaceuticals, Inc.",
			"~",
			"~",
			"~",
			424328591,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"JPMorgan Large Cap Growth Fund Class R6",
			"JLGMX",
			"FSUSA002IK",
			"F00000JSGY",
			190578218,
			0.02391431039980187,
			4557546.660693108,
			0,
			0,
			0.02391431039980187,
			4557546.660693108
		],
		[
			"Vanguard Institutional Index Fund Institutional",
			"VINIX",
			"FSUSA002Q0",
			"FOUSA00FR3",
			145468894,
			0.09156609528167008,
			13320018.608523164,
			0,
			0,
			0.09156609528167008,
			13320018.608523164
		],
		[
			"Vanguard Target Retirement 2045 Trust II",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			83269620,
			0.0758893350582794,
			6319276.092355603,
			0.004623421317086152,
			384990.5361736634,
			0.08051275637536555,
			6704266.628529266
		],
		[
			"Vanguard Target Retirement 2040 Trust II",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			78293310,
			0.06823506026662908,
			5342348.726323873,
			0.007062568740663622,
			552951.8838090866,
			0.0752976290072927,
			5895300.61013296
		],
		[
			"Vanguard Target Retirement 2035 Trust II",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			74826713,
			0.06116514924323183,
			4576787.068025475,
			0.00930723295448306,
			696429.6491092461,
			0.0704723821977149,
			5273216.717134722
		],
		[
			"Vanguard Target Retirement 2030 Trust II",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			67163025,
			0.05426274087980579,
			3644449.822278918,
			0.011496230679006621,
			772121.6284998887,
			0.06575897155881241,
			4416571.450778807
		],
		[
			"Vanguard Target Retirement 2050 Trust II",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			65843287,
			0.08024700579457168,
			5283726.633422647,
			0.003268008966211633,
			215176.45228084584,
			0.08351501476078331,
			5498903.085703492
		],
		[
			"Vanguard Target Retirement 2055 Trust II",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			61949178,
			0.08032666379393759,
			4976170.793516795,
			0.00326181821755119,
			202066.95736272138,
			0.08358848201148877,
			5178237.750879517
		],
		[
			"John Hancock Disciplined Value Fund Class R6",
			"JDVWX",
			"FSUSA0030D",
			"F00000MNDY",
			51891070,
			0.16643495809124473,
			8636488.060759846,
			0,
			0,
			0.16643495809124473,
			8636488.060759846
		],
		[
			"American Funds EuroPacific Growth Fund Class R-6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			49917377,
			0.10771126450519944,
			5376663.797452759,
			0,
			0,
			0.10771126450519944,
			5376663.797452759
		],
		[
			"American Funds Small Cap World Fund Class R-6",
			"RLLGX",
			"FSUSA002F6",
			"F000002PJF",
			49244258,
			0.03816797285475196,
			1879553.5025964018,
			0,
			0,
			0.03816797285475196,
			1879553.5025964018
		],
		[
			"Vanguard Extended Market Index Fund Admiral Shares",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			47029362,
			0.06544225035826598,
			3077707.2821935206,
			0,
			0,
			0.06544225035826598,
			3077707.2821935206
		],
		[
			"Vanguard Target Retirement 2025 Trust II",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			43059349,
			0.04647789761877514,
			2001308.0143531077,
			0.012926504408448546,
			556606.8646734245,
			0.059404402027223684,
			2557914.879026532
		],
		[
			"Vanguard Target Retirement 2060 Trust II",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			35139826,
			0.08036342163620322,
			2823956.653060816,
			0.0032255517799972596,
			113345.32830309398,
			0.08358897341620047,
			2937301.9813639103
		],
		[
			"Metropolitan West Funds Total Return Bond Fund Plan Class",
			"MWTSX",
			"FSUSA003M1",
			"F00000MN7G",
			32056069,
			0,
			0,
			0.01732500428117021,
			555371.5326624877,
			0.01732500428117021,
			555371.5326624877
		],
		[
			"Morley Capital Management Stable Value Fund",
			"~",
			"~",
			"~",
			27753791,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Total International Stock Index Fund Admiral",
			"VTIAX",
			"FSUSA004JJ",
			"F00000JTEF",
			21355810,
			0.09782558128881824,
			2089144.5271435576,
			0,
			0,
			0.09782558128881824,
			2089144.5271435576
		],
		[
			"Delaware Funds by Macquarie Small Cap Value Fund Institutional",
			"DEVIX",
			"FSUSA000JN",
			"FOUSA00DUZ",
			20099149,
			0.10094069169544821,
			2028822.0025498762,
			0,
			0,
			0.10094069169544821,
			2028822.0025498762
		],
		[
			"T. Rowe Price QM U.S. Small-Cap Growth I",
			"TQAIX",
			"FSUSA0034J",
			"F00000WZOY",
			19610643,
			0.04374968268949459,
			857959.4085869583,
			0,
			0,
			0.04374968268949459,
			857959.4085869583
		],
		[
			"Vanguard Total Bond Market Index Fund Admiral Shrs",
			"VBTLX",
			"FSUSA002PJ",
			"FOUSA02TYI",
			18322092,
			0,
			0,
			0.04136148656372853,
			757828.962077398,
			0.04136148656372853,
			757828.962077398
		],
		[
			"Fidelity Money Market Fund",
			"~",
			"~",
			"~",
			15519063,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"MassMutual Select Mid Cap Growth I",
			"MEFZX",
			"FSUSA0044N",
			"F00000JS7I",
			14834707,
			0.03964963434675889,
			588190.7081913045,
			0,
			0,
			0.03964963434675889,
			588190.7081913045
		],
		[
			"MFS Mid Cap Value Fund Class R6",
			"MVCKX",
			"FSUSA00DUD",
			"F00000PGEH",
			12371959,
			0.14896223205199224,
			1842954.627495734,
			0,
			0,
			0.14896223205199224,
			1842954.627495734
		],
		[
			"Vanguard Target Retirement 2020 Trust II",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			11056770,
			0.035230489202590476,
			389535.4161005263,
			0.014566823354659747,
			161062.01546310124,
			0.04979731255725022,
			550597.4315636276
		],
		[
			"Vanguard Target Retirement 2065 Trust II",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			4850013,
			0.08019566005615357,
			388949.99381592555,
			0.0031660668875217067,
			15355.465563349815,
			0.08336172694367527,
			404305.4593792754
		],
		[
			"Vanguard Target Retirement 2015 Trust II",
			"~",
			"~",
			"FOUSA04B97",
			2126841,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement Income Trust II",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			2050549,
			0.02420873589822837,
			49641.19918737628,
			0.016543257559609954,
			33922.760245600635,
			0.04075199345783832,
			83563.95943297692
		]
	],
	"state-farm": [
		[
			"Vanguard Employee Benefit Index Fund",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			10567736924,
			0.09174523974228109,
			969539557.6257361,
			0,
			0,
			0.09174523974228109,
			969539557.6257361
		],
		[
			"Vanguard Institutional Total Bond Market Index Trust",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			1667631002,
			0,
			0,
			0.04136148656372853,
			68975697.28248015,
			0.04136148656372853,
			68975697.28248015
		],
		[
			"Vanguard Short-Term Bond Index Fund",
			"VBIPX",
			"FSUSA001DN",
			"F00000MPYP",
			989372627,
			0,
			0,
			0.029389120548263967,
			29076791.402055603,
			0.029389120548263967,
			29076791.402055603
		],
		[
			"Vanguard Target Retirement 2030 Trust Select",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			647358412,
			0.05426274087980579,
			35127441.76671856,
			0.011496230679006621,
			7442181.636347408,
			0.06575897155881241,
			42569623.403065965
		],
		[
			"Vanguard Target Retirement 2025 Trust Select",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			632836979,
			0.04647789761877514,
			29412932.319336955,
			0.012926504408448546,
			8180369.99887276,
			0.059404402027223684,
			37593302.318209715
		],
		[
			"Vanguard Target Retirement 2035 Trust Select",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			515633871,
			0.06116514924323183,
			31538822.67458035,
			0.00930723295448306,
			4799124.556618867,
			0.0704723821977149,
			36337947.23119922
		],
		[
			"Vanguard Target Retirement 2040 Trust Select",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			401184471,
			0.06823506026662908,
			27374846.556720708,
			0.007062568740663622,
			2833392.9041242716,
			0.0752976290072927,
			30208239.46084498
		],
		[
			"Vanguard Target Retirement 2050 Trust Select",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			397285260,
			0.08024700579457168,
			31880952.561317917,
			0.003268008966211633,
			1298331.7918237199,
			0.08351501476078331,
			33179284.353141636
		],
		[
			"Vanguard Target Retirement 2020 Trust Select",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			349685686,
			0.035230489202590476,
			12319597.784923444,
			0.014566823354659747,
			5093809.617615015,
			0.04979731255725022,
			17413407.40253846
		],
		[
			"Vanguard Target Retirement 2045 Trust Select",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			326315091,
			0.0758893350582794,
			24763835.275471933,
			0.004623421317086152,
			1508692.1478163076,
			0.08051275637536555,
			26272527.42328824
		],
		[
			"Vanguard Retirement Savings Trust II",
			"~",
			"~",
			"~",
			296559422,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Target Retirement Income Trust Select",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			244926669,
			0.02420873589822837,
			5929365.044253797,
			0.016543257559609954,
			4051884.968484335,
			0.04075199345783832,
			9981250.012738133
		],
		[
			"Vanguard Institutional Extended Market Index Trust",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			194512493,
			0.06544225035826598,
			12729335.26471646,
			0,
			0,
			0.06544225035826598,
			12729335.26471646
		],
		[
			"Vanguard Target Retirement 2055 Trust Select",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			148803102,
			0.08032666379393759,
			11952856.745849002,
			0.00326181821755119,
			485368.6689317279,
			0.08358848201148877,
			12438225.41478073
		],
		[
			"Vanguard Target Retirement 2015 Trust Select",
			"~",
			"~",
			"FOUSA04B97",
			136864978,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional Total International Stock Market Index Trust",
			"VTIAX",
			"FSUSA004JJ",
			"F00000JTEF",
			74616069,
			0.09782558128881824,
			7299360.323411571,
			0,
			0,
			0.09782558128881824,
			7299360.323411571
		],
		[
			"Vanguard Target Retirement 2060 Trust Select",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			71563127,
			0.08036342163620322,
			5751057.748706159,
			0.0032255517799972596,
			230830.57167701994,
			0.08358897341620047,
			5981888.320383179
		],
		[
			"Vanguard Target Retirement 2065 Trust Select",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			13462850,
			0.08019566005615357,
			1079662.141986987,
			0.0031660668875217067,
			42624.28359667161,
			0.08336172694367527,
			1122286.4255836587
		]
	],
	"stryker": [
		[
			"Vanguard Inst 500 Index Trust",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			678515064,
			0.09174523974228109,
			62250527.215429194,
			0,
			0,
			0.09174523974228109,
			62250527.215429194
		],
		[
			"Vanguard Tgt Retire 2045 Tr Sel",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			642386163,
			0.0758893350582794,
			48750258.76070949,
			0.004623421317086152,
			2970021.8798153796,
			0.08051275637536555,
			51720280.640524864
		],
		[
			"Vanguard Tgt Retire 2035 Tr Sel",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			386900655,
			0.06116514924323183,
			23664836.30537915,
			0.00930723295448306,
			3600974.5263270815,
			0.0704723821977149,
			27265810.83170623
		],
		[
			"Fidelity Contrafund Commingled Pool",
			"FCNTX",
			"FSUSA000RQ",
			"FOUSA00CEO",
			361064422,
			0.1466416548994518,
			52947084.36739403,
			0,
			0,
			0.1466416548994518,
			52947084.36739403
		],
		[
			"Vanguard Tgt Retire 2050 Tr Sel",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			342150892,
			0.08024700579457168,
			27456584.61294187,
			0.003268008966211633,
			1118152.182853308,
			0.08351501476078331,
			28574736.795795176
		],
		[
			"Vanguard Small-Cap Index InstP",
			"VSCPX",
			"FSUSA001PZ",
			"F00000JXW4",
			299699645,
			0.07578909461851184,
			22713964.75203941,
			0,
			0,
			0.07578909461851184,
			22713964.75203941
		],
		[
			"Vanguard Tgt Retire 2055 Tr Sel",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			267110825,
			0.08032666379393759,
			21456121.4354963,
			0.00326181821755119,
			871266.9550901278,
			0.08358848201148877,
			22327388.39058643
		],
		[
			"Vanguard Tgt Retire 2040 Tr Sel",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			248564036,
			0.06823506026662908,
			16960781.97657656,
			0.007062568740663622,
			1755500.5907067873,
			0.0752976290072927,
			18716282.567283347
		],
		[
			"Vanguard Total Bond Mkt InstP",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			209830555,
			0,
			0,
			0.04136148656372853,
			8678903.6812922,
			0.04136148656372853,
			8678903.6812922
		],
		[
			"Vanguard Tgt Retire 2030 Tr Sel",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			202303707,
			0.05426274087980579,
			10977553.631965153,
			0.011496230679006621,
			2325730.0828901664,
			0.06575897155881241,
			13303283.714855319
		],
		[
			"Vanguard Tgt Retire 2025 Tr Sel",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			198014367,
			0.04647789761877514,
			9203291.476472566,
			0.012926504408448546,
			2559633.587961648,
			0.059404402027223684,
			11762925.064434214
		],
		[
			"Vanguard Cash Reserves Federal MM Fund Admiral Shares",
			"~",
			"~",
			"~",
			181729289,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Inst Total Int’l Stk Mkt Index",
			"VGTSX",
			"FSUSA004JJ",
			"FOUSA00KIR",
			165954264,
			0.09782558128881824,
			16234572.343158003,
			0,
			0,
			0.09782558128881824,
			16234572.343158003
		],
		[
			"American Funds EuroPacific Growth Fund; Class R-6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			153758492,
			0.10771126450519944,
			16561521.601732591,
			0,
			0,
			0.10771126450519944,
			16561521.601732591
		],
		[
			"Vanguard Mid-Cap Index Fund Ins",
			"VMCIX",
			"FSUSA003Q9",
			"FOUSA00J83",
			152540855,
			0.10952080365600442,
			16706397.02997404,
			0,
			0,
			0.10952080365600442,
			16706397.02997404
		],
		[
			"Vanguard Balanced Index Fund Inst",
			"VBAIX",
			"FSUSA002PK",
			"FOUSA00L7S",
			138689036,
			0.05284206680123672,
			7328615.3049111245,
			0.01660871007843185,
			2303445.9899811978,
			0.06945077687966858,
			9632061.294892322
		],
		[
			"Vanguard Tgt Retire 2060 Tr Sel",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			94684097,
			0.08036342163620322,
			7609138.009454165,
			0.0032255517799972596,
			305408.4576157832,
			0.08358897341620047,
			7914546.467069948
		],
		[
			"Vanguard Tgt Retire 2020 Tr Sel",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			65539270,
			0.035230489202590476,
			2308980.544080662,
			0.014566823354659747,
			954698.968883351,
			0.04979731255725022,
			3263679.512964013
		],
		[
			"Vanguard Short-Term Invest-Gr Inst",
			"VFSIX",
			"FSUSA002QD",
			"FOUSA00H6E",
			57531195,
			0,
			0,
			0.10923757822208838,
			6284568.4140227195,
			0.10923757822208838,
			6284568.4140227195
		],
		[
			"Pimco Real Return Fund – Inst",
			"PRRIX",
			"FSUSA0041O",
			"FOUSA00G06",
			37185034,
			0,
			0,
			0.000012479734059770732,
			464.0593353235327,
			0.000012479734059770732,
			464.0593353235327
		],
		[
			"Vanguard Tgt Retire 2015 Tr Sel",
			"~",
			"~",
			"FOUSA04B97",
			26049674,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Tgt Retire Income Tr Sel",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			20204629,
			0.02420873589822837,
			489128.5273826859,
			0.016543257559609954,
			334250.3814433645,
			0.04075199345783832,
			823378.9088260503
		],
		[
			"Vanguard Tgt Retire 2065 Tr Sel",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			11103004,
			0.08019566005615357,
			890412.7343861134,
			0.0031660668875217067,
			35152.85331642106,
			0.08336172694367527,
			925565.5877025344
		],
		[
			"Vanguard FTSE Social Index Ins",
			"VFTNX",
			"FSUSA003PD",
			"FOUSA02SNF",
			8617367,
			0.003717931470108064,
			32038.779958770716,
			0,
			0,
			0.003717931470108064,
			32038.779958770716
		],
		[
			"Columbia Trust Stable Value Income I",
			"~",
			"~",
			"~",
			2725681,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"sutter-health": [
		[
			"Fidelity Freedom Blend 2035 K6",
			"FHJDX",
			"FS0000DV8W",
			"F000010OKH",
			701808673,
			0.07249433727538379,
			50877154.64325153,
			0.007568283429980724,
			5311486.95088266,
			0.08006262070536452,
			56188641.59413419
		],
		[
			"Fidelity Freedom Blend 2030 K6",
			"FHKDX",
			"FS0000DV8V",
			"F000010OK8",
			655692191,
			0.059252544045159575,
			38851430.42729469,
			0.011189234441461101,
			7336693.646534291,
			0.07044177848662067,
			46188124.07382898
		],
		[
			"Fidelity Freedom Blend 2040 K6",
			"FHHDX",
			"FS0000DV8X",
			"F000010OKQ",
			632286352,
			0.08603716705820114,
			54400126.49564457,
			0.002744183779413093,
			1735109.9511026773,
			0.08878135083761422,
			56135236.44674724
		],
		[
			"Fidelity Freedom Blend 2025 K6",
			"FHLDX",
			"FS0000DV8U",
			"F000010OJZ",
			600128873,
			0.05274411901981259,
			31653268.704737995,
			0.012380532333339609,
			7429914.91634716,
			0.0651246513531522,
			39083183.62108515
		],
		[
			"Fidelity Freedom Blend 2045 K6",
			"FHFDX",
			"FS0000DV7E",
			"F000010OF4",
			566257255,
			0.08888901660892752,
			50334050.54462071,
			0.001747469166078257,
			989517.0931806129,
			0.09063648577500578,
			51323567.63780132
		],
		[
			"Fidelity 500 Index",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			505279085,
			0.09162563971314869,
			46296519.39679943,
			0,
			0,
			0.09162563971314869,
			46296519.39679943
		],
		[
			"Fidelity Freedom Blend 2050 K6",
			"FHEDX",
			"FS0000DV7F",
			"F000010OFJ",
			439297911,
			0.08888381689762928,
			39046475.084835045,
			0.0017419882114271545,
			765251.7822665753,
			0.09062580510905643,
			39811726.86710162
		],
		[
			"Fidelity Freedom Blend 2020 K6",
			"FHNDX",
			"FS0000DV8T",
			"F000010OJQ",
			357659976,
			0.04565966439650298,
			16330634.47222131,
			0.014078982174377998,
			5035488.426592463,
			0.059738646570880974,
			21366122.898813773
		],
		[
			"T. Rowe Price Institutional Large Cap Core Growth",
			"TPLGX",
			"FSUSA04C0R",
			"FOUSA04BCR",
			309856130,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity Freedom Blend 2055 K6",
			"FHDDX",
			"FS0000DV7G",
			"F000010OFS",
			204779692,
			0.08887399910481011,
			18199590.16349129,
			0.0017478337527625394,
			357920.85755791696,
			0.09062183285757265,
			18557511.021049205
		],
		[
			"Fidelity Investments Money Market Funds Government Portfolio Inst",
			"~",
			"~",
			"~",
			190830375,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity Balanced K",
			"FBAKX",
			"FSUSA000RN",
			"FOUSA06TXQ",
			178501503,
			0.052318992987575336,
			9339018.883728657,
			0.01613312917688602,
			2879787.8061673073,
			0.06845212216446135,
			12218806.689895965
		],
		[
			"Fidelity Extended Market Index",
			"FSMAX",
			"FSUSA003EG",
			"F00000MJRH",
			157217956,
			0.06751712557082101,
			10614904.477239814,
			0,
			0,
			0.06751712557082101,
			10614904.477239814
		],
		[
			"Fidelity Freedom Blend 2015 K6",
			"FHODX",
			"FS0000DV8S",
			"F000010OJH",
			106311698,
			0.03667601618560371,
			3899089.5565670137,
			0.016007513259696425,
			1701785.915395842,
			0.05268352944530014,
			5600875.471962856
		],
		[
			"Dodge & Cox Stock",
			"DODGX",
			"FSUSA000KR",
			"FOUSA00C3O",
			84469349,
			0.07557975836793555,
			6384172.986916819,
			0,
			0,
			0.07557975836793555,
			6384172.986916819
		],
		[
			"Fidelity Small Cap Growth K6",
			"FOCSX",
			"FS0000D2Y4",
			"F00000YI8K",
			82830600,
			0.05535856413350323,
			4585383.082316552,
			0,
			0,
			0.05535856413350323,
			4585383.082316552
		],
		[
			"Parnassus Core Equity Inst",
			"PRILX",
			"FSUSA001WD",
			"FOUSA05HGA",
			59242667,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Dodge & Cox Income",
			"DODIX",
			"FSUSA000KQ",
			"FOUSA00C3M",
			58997379,
			0,
			0,
			0.08371664487003887,
			4939062.626006089,
			0.08371664487003887,
			4939062.626006089
		],
		[
			"Fidelity Freedom Blend 2060 K6",
			"FHCDX",
			"FS0000DV7H",
			"F000010OFU",
			54065840,
			0.08884727385005128,
			4803602.492413057,
			0.0017646940514301143,
			95409.66623357234,
			0.0906119679014814,
			4899012.158646629
		],
		[
			"Fidelity U.S. Bond Index",
			"FXNAX",
			"FSUSA000VD",
			"F00000LZX3",
			52341352,
			0,
			0,
			0.03886106613218048,
			2034040.741519737,
			0.03886106613218048,
			2034040.741519737
		],
		[
			"American Funds Europacific Growth R6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			49227934,
			0.10771126450519944,
			5302403.020118501,
			0,
			0,
			0.10771126450519944,
			5302403.020118501
		],
		[
			"Fidelity Global ex US Index",
			"FSGGX",
			"FSUSA0BGZ9",
			"F00000MJRI",
			42970317,
			0.10172962118461953,
			4371354.070593017,
			7.388638841580746e-7,
			31.749215322123742,
			0.10173036004850369,
			4371385.81980834
		],
		[
			"Fidelity Freedom Blend 2010 K6",
			"FHPDX",
			"FS0000DV7K",
			"F000010OGD",
			31440767,
			0.027753363021350536,
			872587.0202206982,
			0.018010506740289138,
			566264.1459733603,
			0.045763869761639674,
			1438851.1661940585
		],
		[
			"Northern Small Cap Value",
			"NOSGX",
			"FSUSA000W2",
			"FOUSA00CLE",
			26492601,
			0.1010029406602315,
			2675830.6067381897,
			0,
			0,
			0.1010029406602315,
			2675830.6067381897
		],
		[
			"Lazard Emerging Markets Equity Inst",
			"LZEMX",
			"FSUSA0013U",
			"FOUSA00CXH",
			24353430,
			0.12841933752384757,
			3127451.347033395,
			0,
			0,
			0.12841933752384757,
			3127451.347033395
		],
		[
			"Fidelity Freedom Blend Income K6",
			"FHRDX",
			"FS0000DV7D",
			"F000010OET",
			24157960,
			0.018272813520404687,
			441433.8981133956,
			0.020187812865364342,
			487696.37568895717,
			0.038460626385769026,
			929130.2738023528
		],
		[
			"Cohen & Steers Real Estate Securities Inst",
			"CSDIX",
			"FSUSA003CQ",
			"FOUSA00IMT",
			23419998,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"PIMCO Low Duration Inst",
			"PTLDX",
			"FSUSA001ZF",
			"FOUSA00EH3",
			20633445,
			0,
			0,
			0.00955876466999953,
			197230.24508637848,
			0.00955876466999953,
			197230.24508637848
		],
		[
			"Fidelity Inflation-Protected Bond Index",
			"FIPDX",
			"FS00009EH4",
			"F00000NZ8Q",
			19553236,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity Freedom Blend 2005 K6",
			"FHQDX",
			"FS0000DV7J",
			"F000010OG4",
			9493763,
			0.018341182707600424,
			174126.84176565672,
			0.021410169743888333,
			203263.07733824654,
			0.03975135245148875,
			377389.91910390323
		],
		[
			"Fidelity Freedom Blend 2065 K6",
			"FFBQX",
			"FS0000F7H8",
			"F000013DJA",
			4614593,
			0.09152145142416998,
			422334.2490918148,
			0.001363032595198796,
			6289.840672576198,
			0.09288448401936877,
			428624.089764391
		],
		[
			"Fidelity Institutional Money Market",
			"~",
			"~",
			"~",
			1,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"take-two-interactive-software": [
		[
			"Fidelity Freedom Index 2045 Fund Institutional Premium Class",
			"FFOLX",
			"FSUSA0A7LD",
			"F00000VQAF",
			55938278,
			0.08415997195869995,
			4707763.907897962,
			0.001467166960861474,
			82070.79332908425,
			0.08562713891956143,
			4789834.701227047
		],
		[
			"Vanguard Institutional Index Fund",
			"VINIX",
			"FSUSA002Q0",
			"FOUSA00FR3",
			52137999,
			0.09156609528167008,
			4774072.98422962,
			0,
			0,
			0.09156609528167008,
			4774072.98422962
		],
		[
			"Fidelity Freedom Index 2040 Fund Institutional Premium Class",
			"FFIZX",
			"FSUSA0A7LC",
			"F00000VQAE",
			45771674,
			0.08118178627059154,
			3715826.255915192,
			0.002284358349720326,
			104558.90568257675,
			0.08346614462031186,
			3820385.161597769
		],
		[
			"Fidelity Freedom Index 2050 Fund Institutional Premium Class",
			"FFOPX",
			"FSUSA0A7L8",
			"F00000VQAG",
			39748491,
			0.08416020310030271,
			3345241.0754905543,
			0.0014671437717586916,
			58316.751007456405,
			0.0856273468720614,
			3403557.8264980107
		],
		[
			"Fidelity Freedom Index 2035 Fund Institutional Premium Class",
			"FFEZX",
			"FSUSA0A7L9",
			"F00000VQAD",
			31861413,
			0.06752411712457172,
			2151413.783166352,
			0.006141119326629516,
			195664.7391480249,
			0.07366523645120124,
			2347078.522314377
		],
		[
			"Fidelity Select Technology",
			"FSPTX",
			"FSUSA000V5",
			"FOUSA00CJE",
			29413227,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity Freedom Index 2055 Fund Institutional Premium Class",
			"FFLDX",
			"FSUSA0BGOA",
			"F00000VQ8F",
			23740579,
			0.08416069641640063,
			1998023.661968576,
			0.0014670903155122703,
			34829.57353555398,
			0.0856277867319129,
			2032853.23550413
		],
		[
			"Vanguard Small Cap Index Inst",
			"VSCIX",
			"FSUSA001PZ",
			"FOUSA00GQ5",
			18753514,
			0.07578909461851184,
			1421311.8469755864,
			0,
			0,
			0.07578909461851184,
			1421311.8469755864
		],
		[
			"T. Rowe Price Blue Chip Growth Fund",
			"TRBCX",
			"FSUSA0020C",
			"FOUSA00EI7",
			16609961,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity Freedom Index 2030 Fund Institutional Premium Class",
			"FFEGX",
			"FSUSA0A7LB",
			"F00000VQAC",
			13650979,
			0.0548683033138469,
			749006.0563029544,
			0.009010601150611443,
			123003.52708437265,
			0.06387890446445835,
			872009.5833873271
		],
		[
			"Fidelity Freedom Index 2060 Fund Institutional Premium Class",
			"FFLEX",
			"FS0000ASQV",
			"F00000VQ8G",
			8811084,
			0.08416118487454465,
			741551.2694691423,
			0.0014670353720073772,
			12926.17189372825,
			0.08562822024655202,
			754477.4413628705
		],
		[
			"Fidelity Managed Income II - CL 2",
			"~",
			"~",
			"~",
			8471446,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"MFS International Diversification Fund R6",
			"~",
			"~",
			"~",
			7595903,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Total Intl Stock Index",
			"VGTSX",
			"FSUSA004JJ",
			"FOUSA00KIR",
			7474928,
			0.09782558128881824,
			731239.1766920636,
			0,
			0,
			0.09782558128881824,
			731239.1766920636
		],
		[
			"PIMCO Total Return Fund Inst",
			"PTTRX",
			"FSUSA001ZG",
			"FOUSA00EH4",
			7249363,
			0,
			0,
			0.012424118201873642,
			90066.94280028931,
			0.012424118201873642,
			90066.94280028931
		],
		[
			"Vanguard Total Bond Market Index Fund Institutional Shares",
			"VBTIX",
			"FSUSA002PJ",
			"FOUSA00DIL",
			6863281,
			0,
			0,
			0.04136148656372853,
			283875.5048645933,
			0.04136148656372853,
			283875.5048645933
		],
		[
			"JP Morgan Mid Cap Value L",
			"FLMVX",
			"FSUSA003PY",
			"FOUSA00ID5",
			6508957,
			0.11246280211910323,
			732015.5430927518,
			0,
			0,
			0.11246280211910323,
			732015.5430927518
		],
		[
			"Vanguard REIT Index Fund Admiral",
			"VGSLX",
			"FSUSA004JF",
			"FOUSA02TYE",
			6351642,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Delaware Value Inst",
			"DDVIX",
			"FSUSA002ZR",
			"FOUSA00FZF",
			5999954,
			0.062178439265926026,
			373067.77538734995,
			0,
			0,
			0.062178439265926026,
			373067.77538734995
		],
		[
			"Invesco Developing Markets R6",
			"ODVIX",
			"FSUSA003HS",
			"F00000NB29",
			5871945,
			0.032453357367792326,
			190564.3295290213,
			0,
			0,
			0.032453357367792326,
			190564.3295290213
		],
		[
			"T. Rowe Price Small Cap Stock I",
			"OTIIX",
			"FSUSA001WI",
			"F00000VWN0",
			5683065,
			0.06213585059566003,
			353122.0777654247,
			0,
			0,
			0.06213585059566003,
			353122.0777654247
		],
		[
			"Fidelity Freedom Index 2025 Fund Institutional Premium Class",
			"FFEDX",
			"FSUSA0A7LN",
			"F00000VQAB",
			5109649,
			0.04892073119255335,
			249967.76521729902,
			0.009985511700430653,
			51022.45987459379,
			0.058906242892984004,
			300990.2250918928
		],
		[
			"Fidelity Freedom Index 2020 Fund Institutional Premium Class",
			"FIWTX",
			"FSUSA0A7LQ",
			"F00000VQAA",
			1619816,
			0.04243163690805418,
			68731.44436985669,
			0.01123720740113092,
			18202.20834367028,
			0.0536688443091851,
			86933.65271352697
		],
		[
			"Fidelity Freedom Index 2065 Fund Institutional Premium Class",
			"FFIKX",
			"FS0000F7H9",
			"F000013DKQ",
			873223,
			0.08416341198467871,
			73493.42710349709,
			0.0014670286980907187,
			1281.0432008328717,
			0.08563044068276943,
			74774.47030432997
		],
		[
			"Fidelity Government Money Market Fund - Premium Class",
			"~",
			"~",
			"~",
			610884,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity Freedom Index Income Fund Institutional Premium Class",
			"FFGZX",
			"FSUSA0A7LO",
			"F00000VQAH",
			383333,
			0.01712014682728843,
			6562.717243744956,
			0.015207669649817466,
			5829.6016298734785,
			0.0323278164771059,
			12392.318873618435
		],
		[
			"Fidelity Freedom Index 2005 Fund Institutional Premium Class",
			"FFGFX",
			"FSUSA0A7LA",
			"F00000VQA7",
			357018,
			0.017982948710821373,
			6420.236382840025,
			0.015060225287975338,
			5376.771511862379,
			0.03304317399879671,
			11797.007894702405
		],
		[
			"Fidelity Freedom Index 2015 Fund Institutional Premium Class",
			"FIWFX",
			"FSUSA0A7LJ",
			"F00000VQA9",
			69680,
			0.0341865563797354,
			2382.119248539963,
			0.01249996034774296,
			870.9972370307295,
			0.04668651672747837,
			3253.1164855706925
		],
		[
			"Fidelity Freedom Index 2010 Fund Institutional Premium Class",
			"FFWTX",
			"FSUSA0A7LE",
			"F00000VQA8",
			28772,
			0.02596099510680179,
			746.9497512129011,
			0.01377741968750792,
			396.40391924897784,
			0.03973841479430971,
			1143.353670461879
		]
	],
	"target": [
		[
			"State Street Bank & Trust Company SSGA TARGET CORPORATION COMMON STOCK FUND",
			"~",
			"~",
			"~",
			3058452059,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"State Street Bank & Trust Company SSGA S+P 500 INDEX SER A S+P 500 FLAGSHIP NON LENDING",
			"VFIAX",
			"FSUSA002QH",
			"FOUSA00L8W",
			2413033634,
			0.09174523974228109,
			221384349.25751776,
			0,
			0,
			0.09174523974228109,
			221384349.25751776
		],
		[
			"State Street Bank & Trust Company SSGA RUSS SM/MD CAP INDX SER A RUSSELL SMALL CAP COMPLETENESS",
			"SSMHX",
			"FS0000BWAK",
			"F00000VV1D",
			1064358052,
			0.06754252933228752,
			71889434.9472664,
			0,
			0,
			0.06754252933228752,
			71889434.9472664
		],
		[
			"BlackRock Institutional Trust Company, N.A. EAFE INDEX NON LENDABLE F MUTUAL FUND",
			"EFA",
			"FSUSA00B7C",
			"FEUSA0002W",
			928030876,
			0.09773802437661318,
			90703904.38073768,
			0,
			0,
			0.09773802437661318,
			90703904.38073768
		],
		[
			"BlackRock Institutional Trust Company, N.A. LIFEPATH INDEX 2050 NL FUND F MUTUAL FUND",
			"LIPKX",
			"FSUSA0BDPU",
			"F00000MAPG",
			804404105,
			0.08471012883200901,
			68141175.3675469,
			0.004415330955539908,
			3551710.3455698746,
			0.08912545978754892,
			71692885.71311678
		],
		[
			"BlackRock Institutional Trust Company, N.A. LIFEPATH INDEX 2045 NL FUND F MUTUAL FUND",
			"LIHKX",
			"FSUSA0BDPV",
			"F00000MAPH",
			658284145,
			0.07866477829716315,
			51783776.3229626,
			0.008302856189532203,
			5465638.587784165,
			0.08696763448669535,
			57249414.91074676
		],
		[
			"BlackRock Institutional Trust Company, N.A. LIFEPATH INDEX RETIREMENT NL MUTUAL FUND",
			"LIRKX",
			"FSUSA0BDPS",
			"F00000MAOX",
			553665616,
			0.032011560110599045,
			17723700.14775585,
			0.014213872858253112,
			7869732.6718103895,
			0.046225432968852155,
			25593432.81956624
		],
		[
			"BlackRock Institutional Trust Company, N.A. LIFEPATH INDEX 2055 NL FUND F MUTUAL FUND",
			"LIVKX",
			"FSUSA0BDPT",
			"F00000MAP0",
			553454771,
			0.08675189738403444,
			48013251.500496276,
			0.0015049406496713052,
			832916.5826324235,
			0.08825683803370574,
			48846168.0831287
		],
		[
			"State Street Bank & Trust Company STATE STR BK + TR CO INVT FDS MUTUAL FUND",
			"GVI",
			"FSUSA07XBW",
			"FOUSA069X0",
			505788486,
			0,
			0,
			0.039468439065205856,
			19962682.039573725,
			0.039468439065205856,
			19962682.039573725
		],
		[
			"BlackRock Institutional Trust Company, N.A. LIFEPATH INDEX 2040 NL FUND F MUTUAL FUND",
			"LIKKX",
			"FSUSA0BDPW",
			"F00000MAPI",
			502080486,
			0.06965019365638501,
			34970003.08099191,
			0.010014212303853631,
			5027940.580426011,
			0.07966440596023865,
			39997943.66141792
		],
		[
			"State Street Bank & Trust Company STATE STR BK + TR CO INVT FDS TREASURY INFLATION PROTECTED S",
			"SPIP",
			"FSUSA07YZA",
			"FOUSA06B89",
			456184266,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"BlackRock Institutional Trust Company, N.A. LIFEPATH INDEX 2035 NL FUND F MUTUAL FUND",
			"LIJKX",
			"FSUSA0BDPX",
			"F00000MAPJ",
			453434526,
			0.05940459449733448,
			26936094.148121066,
			0.012372868585268242,
			5610285.802221396,
			0.07177746308260272,
			32546379.95034246
		],
		[
			"BlackRock Institutional Trust Company, N.A. LIFEPATH INDEX 2030 NL FUND F MUTUAL FUND",
			"LINKX",
			"FSUSA0BDPY",
			"F00000MAPK",
			425958036,
			0.04871285292100014,
			20749631.15818608,
			0.014160420067164935,
			6031744.720744564,
			0.06287327298816507,
			26781375.878930647
		],
		[
			"BlackRock Institutional Trust Company, N.A. EM NON LENDABLE FUND F MUTUAL FUND",
			"MADCX",
			"FSUSA001KS",
			"FOUSA00DQS",
			386786119,
			0.06684846790969587,
			25856059.463887308,
			0,
			0,
			0.06684846790969587,
			25856059.463887308
		],
		[
			"BlackRock Institutional Trust Company, N.A. LIFEPATH INDEX 2025 NL FUND F MUTUAL FUND",
			"LIBKX",
			"FSUSA0BDPZ",
			"F00000MAPL",
			353813244,
			0.03700173818270401,
			13091705.02006117,
			0.014567211240572073,
			5154072.265060069,
			0.051568949423276084,
			18245777.28512124
		],
		[
			"State Street Bank & Trust Company STATE STR BK TR CO INVT MUTUAL FUND",
			"~",
			"~",
			"~",
			272098874,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"BlackRock Institutional Trust Company, N.A. LIFEPATH INDEX 2060 NL FUND F MUTUAL FUND",
			"LIZKX",
			"FS0000C8VF",
			"F00000WM8M",
			254381824,
			0.08670656047888761,
			22056573.007385746,
			0.0016559941738530904,
			421254.81847812224,
			0.0883625546527407,
			22477827.825863868
		],
		[
			"BlackRock Institutional Trust Company, N.A. LIFEPATH INDEX 2065 NL FUND F MUTUAL FUND",
			"LIWKX",
			"FS0000FCWA",
			"F000013OYO",
			65437344,
			0.08654592535593908,
			5663335.489314908,
			0.0019195903309161824,
			125612.89282323606,
			0.08846551568685526,
			5788948.382138144
		],
		[
			"State Street Bank & Trust Company SSGA SHORT TERM INVESTMENT FUND",
			"~",
			"~",
			"~",
			38738910,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"US DOLLAR",
			"~",
			"~",
			"~",
			2019379,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"tesla": [
		[
			"T. Rowe Price Retirement 2055 Fund",
			"TRRNX",
			"FSUSA07VNU",
			"FOUSA068A1",
			175846518,
			0.0777479202277828,
			13671701.053797374,
			0.0002564644226942413,
			45098.37572166251,
			0.07800438465047704,
			13716799.429519037
		],
		[
			"T. Rowe Price Retirement 2050 Fund",
			"TRRMX",
			"FSUSA07VNR",
			"FOUSA068A0",
			165205888,
			0.07706701077861977,
			12731923.95118745,
			0.0002542667347442549,
			42006.36170228509,
			0.07732127751336403,
			12773930.312889736
		],
		[
			"T. Rowe Price Retirement 2045 Fund",
			"TRRKX",
			"FSUSA06ALQ",
			"FOUSA05C00",
			122157027,
			0.0758805333888774,
			9269340.365959499,
			0.000610380574419743,
			74562.27630966806,
			0.07649091396329714,
			9343902.642269166
		],
		[
			"Fidelity 500 Index Fund",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			105880420,
			0.09162563971314869,
			9701361.215596862,
			0,
			0,
			0.09162563971314869,
			9701361.215596862
		],
		[
			"T. Rowe Price Retirement 2060 Fund",
			"TRRLX",
			"FS0000AOEU",
			"F00000SZHW",
			103681342,
			0.07767173056805268,
			8053109.260758124,
			0.0002557631270544299,
			26517.8642471198,
			0.07792749369510711,
			8079627.125005244
		],
		[
			"T. Rowe Price Retirement 2040 Fund",
			"TRRDX",
			"FSUSA00IKV",
			"FOUSA02VND",
			81485475,
			0.07108511849095803,
			5792404.645666998,
			0.0025870968840735814,
			210810.8184697557,
			0.0736722153750316,
			6003215.464136753
		],
		[
			"T. Rowe Price Retirement 2035 Fund",
			"TRRJX",
			"FSUSA04WWU",
			"FOUSA0565C",
			68252790,
			0.06280618735226419,
			4286697.516054744,
			0.006230772697966531,
			425267.62049204303,
			0.06903696005023072,
			4711965.136546787
		],
		[
			"Fidelity Contrafund Fund",
			"FCNTX",
			"FSUSA000RQ",
			"FOUSA00CEO",
			59781832,
			0.1466416548994518,
			8766506.777401004,
			0,
			0,
			0.1466416548994518,
			8766506.777401004
		],
		[
			"T. Rowe Price Retirement 2030 Fund",
			"TRRCX",
			"FSUSA00IKU",
			"FOUSA02VNC",
			56799894,
			0.05346417298331525,
			3036759.3582499702,
			0.010217225750691004,
			580337.3396133195,
			0.06368139873400626,
			3617096.6978632896
		],
		[
			"T. Rowe Price Retirement 2025 Fund",
			"TRRHX",
			"FSUSA04WWT",
			"FOUSA0565B",
			40530962,
			0.04454610900182352,
			1805496.6512007671,
			0.013662544600876634,
			553756.076041436,
			0.05820865360270015,
			2359252.7272422034
		],
		[
			"Brown Capital Management Small Company Fund",
			"BCSSX",
			"FSUSA001FD",
			"F00000MQJ0",
			25437713,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity Extended Market Index Fund",
			"FSMAX",
			"FSUSA003EG",
			"F00000MJRH",
			21765114,
			0.06751712557082101,
			1469517.9350012345,
			0,
			0,
			0.06751712557082101,
			1469517.9350012345
		],
		[
			"Vanguard Value Index Fund",
			"VVIAX",
			"FSUSA002PV",
			"FOUSA00LA4",
			14701057,
			0.1742718492197937,
			2561980.3888755925,
			0,
			0,
			0.1742718492197937,
			2561980.3888755925
		],
		[
			"T. Rowe Price Retirement 2020 Fund",
			"TRRBX",
			"FSUSA00IKT",
			"FOUSA02VNB",
			14117076,
			0.03896737715584961,
			550105.4248297928,
			0.01601524401261812,
			226088.41688467495,
			0.05498262116846773,
			776193.8417144677
		],
		[
			"Fidelity International Index Fund",
			"FSPSX",
			"FSUSA004DM",
			"F00000MJRM",
			13258127,
			0.09446078993825728,
			1252373.1495217371,
			0,
			0,
			0.09446078993825728,
			1252373.1495217371
		],
		[
			"Fidelity U.S. Bond Index Fund",
			"FXNAX",
			"FSUSA000VD",
			"F00000LZX3",
			12775548,
			0,
			0,
			0.03886106613218048,
			496471.4157028461,
			0.03886106613218048,
			496471.4157028461
		],
		[
			"Vanguard Small-Cap Value Index Fund",
			"VSIAX",
			"FSUSA0032Z",
			"F00000MPYG",
			12728581,
			0.09622694253095959,
			1224832.4323876642,
			0,
			0,
			0.09622694253095959,
			1224832.4323876642
		],
		[
			"Vanguard FTSE Social Index Fund",
			"VFTAX",
			"FSUSA003PD",
			"F000011IZ5",
			11299147,
			0.003717931470108064,
			42009.45421667712,
			0,
			0,
			0.003717931470108064,
			42009.45421667712
		],
		[
			"Fidelity Low-Priced Stock Fund",
			"FLPSX",
			"FSUSA000S6",
			"FOUSA00CFE",
			10582750,
			0.12840389562333845,
			1358866.326407885,
			0,
			0,
			0.12840389562333845,
			1358866.326407885
		],
		[
			"Fidelity Government Money Market Fund",
			"~",
			"~",
			"~",
			8980461,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Carillon Eagle Mid Cap Growth Fund",
			"HRAUX",
			"FSUSA00439",
			"F00000MMWN",
			8062300,
			0.03976601381031713,
			320605.53314291977,
			0,
			0,
			0.03976601381031713,
			320605.53314291977
		],
		[
			"American Funds New World Fund",
			"RNWGX",
			"FSUSA0049G",
			"F000002PJ9",
			7038683,
			0.07277824226772978,
			512262.976619751,
			0.0012350597570430675,
			8693.194115883169,
			0.07401330202477284,
			520956.17073563416
		],
		[
			"Fidelity International Capital Appreciation Fund",
			"FIVFX",
			"FSUSA00031",
			"FOUSA00B74",
			6253799,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity Government Income Fund",
			"FGOVX",
			"FSUSA000SQ",
			"FOUSA00CG4",
			4875357,
			0,
			0,
			0.001400258357656835,
			6826.759385810755,
			0.001400258357656835,
			6826.759385810755
		],
		[
			"Fidelity Inflation-Protected Bond Fund",
			"FIPDX",
			"FS00009EH4",
			"F00000NZ8Q",
			4128114,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"T. Rowe Price Retirement 2015 Fund",
			"TRRGX",
			"FSUSA04WWS",
			"FOUSA0565A",
			2958300,
			0.036351302616986436,
			107538.05853183097,
			0.01669395071816623,
			49385.71440955116,
			0.05304525333515267,
			156923.77294138214
		],
		[
			"T. Rowe Price Retirement 2005 Fund",
			"TRRFX",
			"FSUSA04WWR",
			"FOUSA05659",
			1307421,
			0.03113399984904949,
			40705.24521664413,
			0.0180240645308849,
			23565.040473034067,
			0.04915806437993439,
			64270.285689678196
		],
		[
			"T. Rowe Price Retirement 2010 Fund",
			"TRRAX",
			"FSUSA00IKS",
			"FOUSA02VNA",
			413355,
			0.03398477448010643,
			14047.776455224393,
			0.01723055890743696,
			7122.337677183604,
			0.05121533338754339,
			21170.114132407998
		]
	],
	"tjx-companies": [
		[
			"Vanguard Institutional Target Retirement 2025",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			240960000,
			0.04647789761877514,
			11199314.210220058,
			0.012926504408448546,
			3114770.5022597616,
			0.059404402027223684,
			14314084.712479819
		],
		[
			"Vanguard Institutional Target Retirement 2030",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			233359000,
			0.05426274087980579,
			12662698.9489706,
			0.011496230679006621,
			2682748.895022306,
			0.06575897155881241,
			15345447.843992906
		],
		[
			"JPMorgan U.S. Equity Fund-R6",
			"JUEMX",
			"FSUSA001YZ",
			"F00000JSDA",
			225392000,
			0.10027372356924442,
			22600895.10271914,
			0,
			0,
			0.10027372356924442,
			22600895.10271914
		],
		[
			"Vanguard Institutional Target Retirement 2035",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			197693000,
			0.06116514924323183,
			12091921.84934223,
			0.00930723295448306,
			1839974.8044706197,
			0.0704723821977149,
			13931896.65381285
		],
		[
			"Vanguard Institutional Index Fund",
			"VINIX",
			"FSUSA002Q0",
			"FOUSA00FR3",
			186750000,
			0.09156609528167008,
			17099968.293851886,
			0,
			0,
			0.09156609528167008,
			17099968.293851886
		],
		[
			"Security Backed Guaranteed Investment Contracts and Underlying Investments",
			"~",
			"~",
			"~",
			170653000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Putnam Large Cap Value- R6",
			"PEQSX",
			"FSUSA00251",
			"F00000OLLC",
			162131000,
			0.1302030141068176,
			21109944.88015244,
			0,
			0,
			0.1302030141068176,
			21109944.88015244
		],
		[
			"Vanguard U.S. Growth Fund Admiral Shares",
			"VWUAX",
			"FSUSA002RC",
			"FOUSA02TIF",
			150551000,
			0.011239168347091618,
			1692068.0338229903,
			0,
			0,
			0.011239168347091618,
			1692068.0338229903
		],
		[
			"Vanguard Institutional Target Retirement 2040",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			150065000,
			0.06823506026662908,
			10239694.318911692,
			0.007062568740663622,
			1059844.3780676865,
			0.0752976290072927,
			11299538.69697938
		],
		[
			"Vanguard Institutional Target Retirement 2045",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			144087000,
			0.0758893350582794,
			10934666.620542303,
			0.004623421317086152,
			666174.9073149924,
			0.08051275637536555,
			11600841.527857294
		],
		[
			"Vanguard Institutional Target Retirement 2050",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			125335000,
			0.08024700579457168,
			10057758.471262641,
			0.003268008966211633,
			409595.90378013504,
			0.08351501476078331,
			10467354.375042776
		],
		[
			"Vanguard Institutional Target Retirement 2020",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			125218000,
			0.035230489202590476,
			4411491.396969974,
			0.014566823354659747,
			1824028.4868237842,
			0.04979731255725022,
			6235519.883793758
		],
		[
			"Vanguard Total Bond Market Index Fund: Inst'l Shr",
			"VBTIX",
			"FSUSA002PJ",
			"FOUSA00DIL",
			112893000,
			0,
			0,
			0.04136148656372853,
			4669422.302639005,
			0.04136148656372853,
			4669422.302639005
		],
		[
			"Vanguard Mid-Cap Index Fund Institutional Shares",
			"VMCIX",
			"FSUSA003Q9",
			"FOUSA00J83",
			108781000,
			0.10952080365600442,
			11913782.542503817,
			0,
			0,
			0.10952080365600442,
			11913782.542503817
		],
		[
			"Vanguard Institutional Target Retirement 2055",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			99452000,
			0.08032666379393759,
			7988647.367634681,
			0.00326181821755119,
			324394.34537190094,
			0.08358848201148877,
			8313041.713006582
		],
		[
			"American Funds EuroPacific Growth Fund-R6",
			"RERGX",
			"FSUSA000PI",
			"F000002P1T",
			83050000,
			0.10771126450519944,
			8945420.517156813,
			0,
			0,
			0.10771126450519944,
			8945420.517156813
		],
		[
			"Vanguard Total International Stock Inst",
			"VTSNX",
			"FSUSA004JJ",
			"F00000JTBU",
			80948000,
			0.09782558128881824,
			7918785.154167259,
			0,
			0,
			0.09782558128881824,
			7918785.154167259
		],
		[
			"Vanguard Small-Cap Index Fund Institutional Shares",
			"VSCIX",
			"FSUSA001PZ",
			"FOUSA00GQ5",
			79686000,
			0.07578909461851184,
			6039329.793770734,
			0,
			0,
			0.07578909461851184,
			6039329.793770734
		],
		[
			"Vanguard Total Stock Market Index Fund",
			"VITSX",
			"FSUSA002PT",
			"FOUSA00GQ7",
			74543000,
			0.08735255494739627,
			6511521.50344376,
			0,
			0,
			0.08735255494739627,
			6511521.50344376
		],
		[
			"PIMCO Total Return Institutional Fund",
			"PTTRX",
			"FSUSA001ZG",
			"FOUSA00EH4",
			66114000,
			0,
			0,
			0.012424118201873642,
			821408.150798674,
			0.012424118201873642,
			821408.150798674
		],
		[
			"Separate Account Guaranteed Investment Contracts and Underlying Investments",
			"~",
			"~",
			"~",
			58634000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional Target Retirement 2060",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			51107000,
			0.08036342163620322,
			4107133.389561438,
			0.0032255517799972596,
			164848.27482031996,
			0.08358897341620047,
			4271981.664381758
		],
		[
			"Vanguard Institutional Target Retirement 2015",
			"~",
			"~",
			"FOUSA04B97",
			44807000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional Target Retirement Income Fund",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			31070000,
			0.02420873589822837,
			752165.4243579555,
			0.016543257559609954,
			513999.01237708126,
			0.04075199345783832,
			1266164.4367350368
		],
		[
			"Wells Fargo/Black Rock Short Term Investment Fund S",
			"~",
			"~",
			"~",
			17000000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional Target Retirement 2065",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			7317000,
			0.08019566005615357,
			586791.6446308757,
			0.0031660668875217067,
			23166.11141599633,
			0.08336172694367527,
			609957.756046872
		]
	],
	"x-corp": [
		[
			"Vanguard Institutional Index Fund Institutional Plus Shares",
			"VIIIX",
			"FSUSA002Q0",
			"FOUSA00GPG",
			129073763,
			0.09156609528167008,
			11818780.481221702,
			0,
			0,
			0.09156609528167008,
			11818780.481221702
		],
		[
			"T. Rowe Price Retirement 2050 Trust; Class F",
			"RRTFX",
			"FSUSA07VNR",
			"FOUSA068A3",
			73904911,
			0.07706701077861977,
			5695630.572629935,
			0.0002542667347442549,
			18791.560401534767,
			0.07732127751336403,
			5714422.13303147
		],
		[
			"T. Rowe Price Retirement 2055 Trust; Class F",
			"RRTVX",
			"FSUSA07VNU",
			"FOUSA06BXM",
			64889701,
			0.0777479202277828,
			5045039.296952678,
			0.0002564644226942413,
			16641.899705766933,
			0.07800438465047704,
			5061681.196658445
		],
		[
			"T. Rowe Price Retirement 2045 Trust; Class F",
			"RRTRX",
			"FSUSA06ALQ",
			"FOUSA06BXK",
			58747788,
			0.0758805333888774,
			4457813.488856691,
			0.000610380574419743,
			35858.508585329284,
			0.07649091396329714,
			4493671.99744202
		],
		[
			"Vanguard Extended Market Index Fund Institutional Shares",
			"VIEIX",
			"FSUSA002PR",
			"FOUSA00GPW",
			48420777,
			0.06544225035826598,
			3168764.610975767,
			0,
			0,
			0.06544225035826598,
			3168764.610975767
		],
		[
			"Vanguard Total International Stock Index Fund: Institutional Shares",
			"VTSNX",
			"FSUSA004JJ",
			"F00000JTBU",
			36398019,
			0.09782558128881824,
			3560657.3664364507,
			0,
			0,
			0.09782558128881824,
			3560657.3664364507
		],
		[
			"T. Rowe Price Retirement 2040 Trust; Class F",
			"RRTDX",
			"FSUSA00IKV",
			"FOUSA04BF0",
			34724467,
			0.07108511849095803,
			2468392.851230362,
			0.0025870968840735814,
			89835.5603768159,
			0.0736722153750316,
			2558228.411607178
		],
		[
			"T. Rowe Price Retirement 2060 Trust; Class F",
			"TRRZX",
			"FS0000AOEU",
			"F00000SZHY",
			22733402,
			0.07767173056805268,
			1765742.67503923,
			0.0002557631270544299,
			5814.365984105431,
			0.07792749369510711,
			1771557.0410233354
		],
		[
			"Vanguard Total Bond Market Index Fund: Institutional Shares",
			"VBTIX",
			"FSUSA002PJ",
			"FOUSA00DIL",
			19802285,
			0,
			0,
			0.04136148656372853,
			819051.944958623,
			0.04136148656372853,
			819051.944958623
		],
		[
			"Fidelity Contrafund; K6",
			"FLCNX",
			"FS0000D2Y7",
			"F00000YI8R",
			18003658,
			0.13439961963992988,
			2419684.787327381,
			0,
			0,
			0.13439961963992988,
			2419684.787327381
		],
		[
			"T. Rowe Price Retirement 2035 Trust; Class F",
			"RRTPX",
			"FSUSA04WWU",
			"FOUSA06BXI",
			15926363,
			0.06280618735226419,
			1000274.1384181684,
			0.006230772697966531,
			99233.54775830432,
			0.06903696005023072,
			1099507.6861764728
		],
		[
			"Vanguard Equity Income Fund Admiral Shares",
			"VEIRX",
			"FSUSA002PL",
			"FOUSA02TIM",
			12021551,
			0.17590873034694984,
			2114695.7732111053,
			0,
			0,
			0.17590873034694984,
			2114695.7732111053
		],
		[
			"MFS International Diversification Fund; Class R6",
			"~",
			"~",
			"~",
			9114736,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Retirement Savings Trust III",
			"~",
			"~",
			"~",
			8406707,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"T. Rowe Price Retirement 2030 Trust; Class F",
			"RRTCX",
			"FSUSA00IKU",
			"FOUSA04BEZ",
			7701712,
			0.05346417298331525,
			411765.6626356749,
			0.010217225750691004,
			78690.13017080592,
			0.06368139873400626,
			490455.7928064808
		],
		[
			"JPMorgan U.S. Small Company Fund; Class R6",
			"JUSMX",
			"FSUSA001YY",
			"F00000MSXN",
			6648671,
			0.08215171794452157,
			546199.7446979202,
			0,
			0,
			0.08215171794452157,
			546199.7446979202
		],
		[
			"T. Rowe Price Retirement 2025 Trust; Class F",
			"RRTNX",
			"FSUSA04WWT",
			"FOUSA06BXG",
			5568543,
			0.04454610900182352,
			248056.92345934134,
			0.013662544600876634,
			76080.46709939938,
			0.05820865360270015,
			324137.3905587407
		],
		[
			"PIMCO Income Fund; Institutional Class",
			"PIMIX",
			"FSUSA07XD8",
			"FOUSA069X9",
			4812504,
			0.0002500573069478645,
			1203.4017899158257,
			0.009435029807897632,
			45406.11869062659,
			0.009685087114845496,
			46609.520480542415
		],
		[
			"PIMCO Total Return Fund; Institutional Class",
			"PTTRX",
			"FSUSA001ZG",
			"FOUSA00EH4",
			4473549,
			0,
			0,
			0.012424118201873642,
			55579.90155787363,
			0.012424118201873642,
			55579.90155787363
		],
		[
			"MFS Mid Cap Value Fund; Class R6",
			"MVCKX",
			"FSUSA00DUD",
			"F00000PGEH",
			4376685,
			0.14896223205199224,
			651960.7665884737,
			0,
			0,
			0.14896223205199224,
			651960.7665884737
		],
		[
			"T. Rowe Price Retirement 2020 Trust; Class F",
			"RRTBX",
			"FSUSA00IKT",
			"FOUSA04BEY",
			2405511,
			0.03896737715584961,
			93736.45438954495,
			0.01601524401261812,
			38524.84564003703,
			0.05498262116846773,
			132261.30002958197
		],
		[
			"Vanguard FTSE Social Index Fund Admiral Shares",
			"VFTAX",
			"FSUSA003PD",
			"F000011IZ5",
			1392365,
			0.003717931470108064,
			5176.717651377015,
			0,
			0,
			0.003717931470108064,
			5176.717651377015
		],
		[
			"T. Rowe Price Retirement 2005 Trust; Class F",
			"RRTLX",
			"FSUSA04WWR",
			"FOUSA06BXC",
			990111,
			0.03113399984904949,
			30826.11572454224,
			0.0180240645308849,
			17845.824556738982,
			0.04915806437993439,
			48671.94028128122
		],
		[
			"T. Rowe Price Retirement 2015 Trust; Class F",
			"RRTMX",
			"FSUSA04WWS",
			"FOUSA06BXE",
			884081,
			0.036351302616986436,
			32137.495968927986,
			0.01669395071816623,
			14758.80464486712,
			0.05304525333515267,
			46896.3006137951
		],
		[
			"T. Rowe Price Retirement 2010 Trust; Class F",
			"RRTAX",
			"FSUSA00IKS",
			"FOUSA04BEX",
			883148,
			0.03398477448010643,
			30013.58561255703,
			0.01723055890743696,
			15217.133637985135,
			0.05121533338754339,
			45230.71925054217
		],
		[
			"T. Rowe Price Retirement 2065 Trust; Class F",
			"RRSUX",
			"FS0000G0EV",
			"F0000155P3",
			686062,
			0.07806994425862915,
			53560.82209796363,
			0.0002592726907538679,
			177.87714076398012,
			0.07832921694938301,
			53738.69923872761
		],
		[
			"Vanguard Federal Money Market Fund",
			"~",
			"~",
			"~",
			206858,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"vertex-pharmaceuticals": [
		[
			"Fidelity 500 Index Fund",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			145133162,
			0.09162563971314869,
			13297918.811842043,
			0,
			0,
			0.09162563971314869,
			13297918.811842043
		],
		[
			"Vertex Pharmaceuticals Incorporated real-time traded stock fund",
			"~",
			"~",
			"~",
			88608079,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Harbor Capital Appreciation Fund; Institutional Class",
			"HACAX",
			"FSUSA0016N",
			"FOUSA00D2I",
			75266792,
			0.02704260563196072,
			2035410.1732388162,
			0,
			0,
			0.02704260563196072,
			2035410.1732388162
		],
		[
			"Fidelity Freedom 2040 Fund",
			"FSNVX",
			"FSUSA0040I",
			"F00000YBPZ",
			61165429,
			0.08743047942872753,
			5347722.781933795,
			0.0029806994807069077,
			182315.76245751523,
			0.09041117890943444,
			5530038.54439131
		],
		[
			"Baron Asset Fund",
			"BARUX",
			"FSUSA00069",
			"F00000WJF7",
			41880452,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity Freedom 2035 Fund",
			"FSNUX",
			"FSUSA04C0Q",
			"F00000YBPY",
			41233063,
			0.07384831334725006,
			3044992.1566909025,
			0.008887888786927698,
			366474.87828838336,
			0.08273620213417776,
			3411467.0349792857
		],
		[
			"Fidelity International Discovery Fund",
			"FIDKX",
			"FSUSA065WW",
			"FOUSA06TXE",
			35087443,
			0.03665554506774967,
			1286149.3481985978,
			0,
			0,
			0.03665554506774967,
			1286149.3481985978
		],
		[
			"Fidelity Freedom 2030 Fund",
			"FSNQX",
			"FSUSA00487",
			"F00000YBPX",
			34624837,
			0.06042595128150008,
			2092238.7136918814,
			0.013370682904067293,
			462957.7161320167,
			0.07379663418556737,
			2555196.4298238982
		],
		[
			"Fidelity Freedom 2045 Fund",
			"FSNZX",
			"FSUSA0720L",
			"F00000YBQ1",
			33405631,
			0.09027320914506011,
			3015633.5138857034,
			0.0017517019015951115,
			58516.707346684605,
			0.09202491104665522,
			3074150.221232388
		],
		[
			"Fidelity Balanced Fund",
			"FBAKX",
			"FSUSA000RN",
			"FOUSA06TXQ",
			31875202,
			0.052318992987575336,
			1667678.4699155474,
			0.01613312917688602,
			514246.7514053356,
			0.06845212216446135,
			2181925.221320883
		],
		[
			"Fidelity Freedom 2050 Fund",
			"FNSBX",
			"FSUSA0720M",
			"F00000YBQ2",
			31531659,
			0.09027333137704308,
			2846467.901774923,
			0.001752032175112888,
			55244.481102687874,
			0.09202536355215596,
			2901712.3828776106
		],
		[
			"Fidelity US Bond Index Fund",
			"FXNAX",
			"FSUSA000VD",
			"F00000LZX3",
			28855811,
			0,
			0,
			0.03886106613218048,
			1121367.579568701,
			0.03886106613218048,
			1121367.579568701
		],
		[
			"Fidelity Mid Cap Index Fund",
			"FSMDX",
			"FSUSA0BGZB",
			"F00000MJRP",
			27631972,
			0.10367535191096297,
			2864754.421093875,
			0,
			0,
			0.10367535191096297,
			2864754.421093875
		],
		[
			"Fidelity Small Cap Index Fund",
			"FSSNX",
			"FSUSA0BGZD",
			"F00000MJRV",
			27070884,
			0.086306010873582,
			2336380.008861477,
			0,
			0,
			0.086306010873582,
			2336380.008861477
		],
		[
			"Fidelity Managed Income Portfolio Class 2 Fund",
			"~",
			"~",
			"~",
			22718396,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Charleston Equity Small Cap Growth Fund",
			"~",
			"~",
			"~",
			22312086,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Fidelity Freedom 2055 Fund",
			"FNSDX",
			"FSUSA0BGO9",
			"F00000YBQ3",
			21997237,
			0.0902785809542053,
			1985879.34127334,
			0.0017463961533051246,
			38415.89008014116,
			0.09202497710751043,
			2024295.231353481
		],
		[
			"Fidelity Capital & Income Fund",
			"FAGIX",
			"FSUSA000SV",
			"FOUSA00CGB",
			20506643,
			0.016653687047167024,
			341511.2149099783,
			0.12982560385681266,
			2662287.3105510804,
			0.14647929090397968,
			3003798.5254610586
		],
		[
			"Fidelity Freedom 2025 Fund",
			"FSNPX",
			"FSUSA04C0P",
			"F00000YBPW",
			20219558,
			0.05377736070655643,
			1087354.4638931386,
			0.014846945003625852,
			300198.6656236231,
			0.06862430571018228,
			1387553.1295167617
		],
		[
			"American Beacon Large Cap Value Fund",
			"AALRX",
			"FSUSA00016",
			"F00000YM9F",
			18561684,
			0.13480453410139442,
			2502199.1637573075,
			0,
			0,
			0.13480453410139442,
			2502199.1637573075
		],
		[
			"Fidelity Real Estate Investors Fund",
			"FRESX",
			"FSUSA000TV",
			"FOUSA00CHX",
			17359269,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"MFS Mid Cap Value Fund",
			"MVCKX",
			"FSUSA00DUD",
			"F00000PGEH",
			13931051,
			0.14896223205199224,
			2075200.4517901386,
			0,
			0,
			0.14896223205199224,
			2075200.4517901386
		],
		[
			"Vanguard FTSE All-World Index Fund",
			"VFWSX",
			"FSUSA07YWA",
			"FOUSA06B5B",
			13280535,
			0.1030830690230197,
			1368998.3060676288,
			0,
			0,
			0.1030830690230197,
			1368998.3060676288
		],
		[
			"Columbia Small Cap Value Fund",
			"CSVRX",
			"FSUSA000EH",
			"F00000JTO4",
			12245274,
			0.07926275881540192,
			970594.1996905119,
			0,
			0,
			0.07926275881540192,
			970594.1996905119
		],
		[
			"Delaware Emerging Markets Fund",
			"DEMRX",
			"FSUSA004R8",
			"FOUSA06BY5",
			9395081,
			0.13318397180851077,
			1251274.2030426753,
			0,
			0,
			0.13318397180851077,
			1251274.2030426753
		],
		[
			"Fidelity Freedom 2020 Fund",
			"FSNOX",
			"FSUSA003HE",
			"F00000YBPV",
			6788424,
			0.046587711936816135,
			316257.14181696915,
			0.016921738138046982,
			114871.93329803344,
			0.06350945007486311,
			431129.0751150026
		],
		[
			"T. Rowe Price International Bond Fund",
			"RPISX",
			"FSUSA0021F",
			"F00000VWQD",
			5812606,
			0,
			0,
			0.010500968130259351,
			61037.99035975429,
			0.010500968130259351,
			61037.99035975429
		],
		[
			"Fidelity Freedom 2060 Fund",
			"FNSFX",
			"FS0000ASQS",
			"F00000YBQ4",
			4030928,
			0.090280029847377,
			363912.3001526277,
			0.0017486774199631824,
			7048.792775097351,
			0.09202870726734018,
			370961.09292772505
		],
		[
			"Fidelity Freedom Income Fund",
			"FNSHX",
			"FSUSA0031V",
			"F00000YBQ0",
			1370178,
			0.018561497166139203,
			25432.55506410628,
			0.02418167092037405,
			33133.19349833627,
			0.04274316808651325,
			58565.74856244255
		],
		[
			"Fidelity Freedom 2010 Fund",
			"FSNKX",
			"FSUSA00418",
			"F00000YBPT",
			1252608,
			0.028312939052573323,
			35465.01396076576,
			0.021579685931714387,
			27030.887235552895,
			0.04989262498428771,
			62495.90119631866
		],
		[
			"Fidelity Freedom 2015 Fund",
			"FSNLX",
			"FSUSA04C0N",
			"F00000YBPU",
			1118286,
			0.03741076317273422,
			41835.932705384264,
			0.0192321802435352,
			21507.077915822007,
			0.05664294341626942,
			63343.01062120627
		],
		[
			"Fidelity Freedom 2065 Fund",
			"FFSDX",
			"FS0000F7H7",
			"F000013DKJ",
			704637,
			0.09028395009102358,
			63617.41174028858,
			0.0017878247485627666,
			1259.767467353022,
			0.09207177483958634,
			64877.1792076416
		],
		[
			"Fidelity Freedom 2005 Fund",
			"FSNJX",
			"FSUSA04C0M",
			"F00000YBPS",
			293866,
			0.01954981898575447,
			5745.027106067723,
			0.023876308827535976,
			7016.435369912687,
			0.043426127813290444,
			12761.46247598041
		]
	],
	"visa": [
		[
			"Fidelity 500 Index Fund",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			634586943,
			0.09162563971314869,
			58144434.605986424,
			0,
			0,
			0.09162563971314869,
			58144434.605986424
		],
		[
			"Fidelity Balanced Fund Class K",
			"FBALX",
			"FSUSA000RN",
			"FOUSA00CEL",
			412631740,
			0.052318992987575336,
			21588477.11151101,
			0.01613312917688602,
			6657041.163903246,
			0.06845212216446135,
			28245518.27541426
		],
		[
			"TRP Institutional Large Cap Growth",
			"TRLGX",
			"FSUSA00HBD",
			"FOUSA02VIY",
			284044799,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Vanguard Institutional Target Retirement 2045 Fund Institutional",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			200611078,
			0.0758893350582794,
			15224241.314744623,
			0.004623421317086152,
			927509.5344688329,
			0.08051275637536555,
			16151750.849213457
		],
		[
			"Vanguard External Market Index Fund Institutional Plus",
			"VEXAX",
			"FSUSA002PR",
			"FOUSA00LB6",
			184295383,
			0.06544225035826598,
			12060704.594158515,
			0,
			0,
			0.06544225035826598,
			12060704.594158515
		],
		[
			"Vanguard Institutional Target Retirement 2035 Fund Institutional",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			179546461,
			0.06116514924323183,
			10981986.083159104,
			0.00930723295448306,
			1671080.7386800076,
			0.0704723821977149,
			12653066.82183911
		],
		[
			"Vanguard Institutional Target Retirement 2040 Fund Institutional",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			179073349,
			0.06823506026662908,
			12219080.761162102,
			0.007062568740663622,
			1264717.8369333474,
			0.0752976290072927,
			13483798.59809545
		],
		[
			"Vanguard Institutional Target Retirement 2050 Fund Institutional",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			171706600,
			0.08024700579457168,
			13778940.525166202,
			0.003268008966211633,
			561138.7083577143,
			0.08351501476078331,
			14340079.233523916
		],
		[
			"DFA US Small Cap 1",
			"DFSTX",
			"FSUSA000JV",
			"FOUSA00C29",
			161333201,
			0.07573702220972035,
			12218896.227302277,
			0,
			0,
			0.07573702220972035,
			12218896.227302277
		],
		[
			"Fidelity Short-Term Investment Fund",
			"~",
			"~",
			"~",
			146943840,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional Target Retirement 2055 Fund Institutional",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			121751655,
			0.08032666379393759,
			9779904.257540481,
			0.00326181821755119,
			397131.76629600744,
			0.08358848201148877,
			10177036.023836488
		],
		[
			"Vanguard Institutional Target Retirement 2030 Fund Institutional",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			116224219,
			0.05426274087980579,
			6306644.6795548005,
			0.011496230679006621,
			1336140.4321113843,
			0.06575897155881241,
			7642785.111666185
		],
		[
			"Vanguard Value Index Fund Institutional",
			"VVIAX",
			"FSUSA002PV",
			"FOUSA00LA4",
			107362854,
			0.1742718492197937,
			18710323.104094725,
			0,
			0,
			0.1742718492197937,
			18710323.104094725
		],
		[
			"Vanguard Total International Stock Fund Institutional Plus",
			"VGTSX",
			"FSUSA004JJ",
			"FOUSA00KIR",
			101561990,
			0.09782558128881824,
			9935360.708599145,
			0,
			0,
			0.09782558128881824,
			9935360.708599145
		],
		[
			"Vanguard Total Stock Market Fund Institutional",
			"VTSAX",
			"FSUSA002PT",
			"FOUSA00L83",
			99418633,
			0.08735255494739627,
			8684471.601927524,
			0,
			0,
			0.08735255494739627,
			8684471.601927524
		],
		[
			"Vanguard Institutional Target Retirement 2025 Fund Institutional",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			88991822,
			0.04647789761877514,
			4136152.791824261,
			0.012926504408448546,
			1150353.1793988682,
			0.059404402027223684,
			5286505.971223129
		],
		[
			"Dodge & Cox Income Fund",
			"DODIX",
			"FSUSA000KQ",
			"FOUSA00C3M",
			83448092,
			0,
			0,
			0.08371664487003887,
			6985994.283046331,
			0.08371664487003887,
			6985994.283046331
		],
		[
			"Dodge & Cox International Stock Fund",
			"DODFX",
			"FSUSA0096D",
			"FOUSA02TGA",
			61607035,
			0.10073749418465221,
			6206138.330046165,
			0,
			0,
			0.10073749418465221,
			6206138.330046165
		],
		[
			"Vanguard Institutional Target Retirement 2060 Fund Institutional",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			55608969,
			0.08036342163620322,
			4468927.022501554,
			0.0032255517799972596,
			179369.60894176242,
			0.08358897341620047,
			4648296.631443317
		],
		[
			"Vanguard Total Bond Market Fund Institutional",
			"VBMPX",
			"FSUSA002PJ",
			"F000004494",
			40975698,
			0,
			0,
			0.04136148656372853,
			1694815.7822663982,
			0.04136148656372853,
			1694815.7822663982
		],
		[
			"Vanguard Institutional Target Retirement 2020 Fund Institutional",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			40891576,
			0.035230489202590476,
			1440630.226744908,
			0.014566823354659747,
			595660.364285644,
			0.04979731255725022,
			2036290.591030552
		],
		[
			"Vanguard Institutional Target Retirement 2015 Fund Institutional",
			"~",
			"~",
			"FOUSA04B97",
			11816121,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"Vanguard Institutional Target Retirement Income Fund Institutional",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			11271665,
			0.02420873589822837,
			272872.7611183043,
			0.016543257559609954,
			186470.05722064094,
			0.04075199345783832,
			459342.8183389452
		],
		[
			"Vanguard Institutional Target Retirement 2065 Fund Institutional",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			5627355,
			0.08019566005615357,
			451289.44859529607,
			0.0031660668875217067,
			17816.582329829715,
			0.08336172694367527,
			469106.03092512576
		],
		[
			"Vanguard Federal Money Market Fund",
			"~",
			"~",
			"~",
			162273,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	],
	"whole-foods": [
		[
			"Vanguard Target Retirement 2045 Fund",
			"VTIVX",
			"FSUSA04C61",
			"FOUSA04B9A",
			205112000,
			0.0758893350582794,
			15565813.292473804,
			0.004623421317086152,
			948319.1931901749,
			0.08051275637536555,
			16514132.485663978
		],
		[
			"Vanguard Target Retirement 2050 Fund",
			"VFIFX",
			"FSUSA072BK",
			"FOUSA05HZH",
			202944000,
			0.08024700579457168,
			16285648.343973555,
			0.003268008966211633,
			663222.8116388536,
			0.08351501476078331,
			16948871.15561241
		],
		[
			"Vanguard Target Retirement 2040 Fund",
			"VFORX",
			"FSUSA072BI",
			"FOUSA05HZF",
			161630000,
			0.06823506026662908,
			11028832.790895259,
			0.007062568740663622,
			1141522.9855534614,
			0.0752976290072927,
			12170355.776448721
		],
		[
			"Fidelity Contrafund Commingled Pool",
			"FLCNX",
			"FS0000D2Y7",
			"F00000YI8R",
			137499000,
			0.13439961963992988,
			18479813.30087072,
			0,
			0,
			0.13439961963992988,
			18479813.30087072
		],
		[
			"Vanguard Target Retirement 2030 Fund",
			"VTHRX",
			"FSUSA072BH",
			"FOUSA05HZE",
			134771000,
			0.05426274087980579,
			7313043.851112306,
			0.011496230679006621,
			1549358.5048404015,
			0.06575897155881241,
			8862402.355952708
		],
		[
			"Vanguard Target Retirement 2035 Fund",
			"VTTHX",
			"FSUSA04C62",
			"FOUSA04B99",
			134086000,
			0.06116514924323183,
			8201390.201427983,
			0.00930723295448306,
			1247969.6379348156,
			0.0704723821977149,
			9449359.839362798
		],
		[
			"Vanguard Target Retirement 2055 Fund",
			"VFFVX",
			"FSUSA0AWPD",
			"F00000ISUB",
			132618000,
			0.08032666379393759,
			10652761.499024415,
			0.00326181821755119,
			432575.8083752037,
			0.08358848201148877,
			11085337.30739962
		],
		[
			"Fidelity 500 Index Fund",
			"FXAIX",
			"FSUSA000VE",
			"F00000LZSI",
			124681000,
			0.09162563971314869,
			11423976.385075092,
			0,
			0,
			0.09162563971314869,
			11423976.385075092
		],
		[
			"Vanguard Target Retirement 2025 Fund",
			"VTTVX",
			"FSUSA04C63",
			"FOUSA04B98",
			102975000,
			0.04647789761877514,
			4786061.50729337,
			0.012926504408448546,
			1331106.791459989,
			0.059404402027223684,
			6117168.298753358
		],
		[
			"Vanguard Target Retirement 2060 Fund",
			"VTTSX",
			"FS00008YI2",
			"F00000N8OD",
			69003000,
			0.08036342163620322,
			5545317.18316293,
			0.0032255517799972596,
			222572.7494751509,
			0.08358897341620047,
			5767889.932638082
		],
		[
			"Vanguard Target Retirement 2020 Fund",
			"VTWNX",
			"FSUSA072BG",
			"FOUSA05HZD",
			54839000,
			0.035230489202590476,
			1932004.797380859,
			0.014566823354659747,
			798830.0259461859,
			0.04979731255725022,
			2730834.823327045
		],
		[
			"Vanguard Explorer Fund Admiral Shares Fund",
			"VEXRX",
			"FSUSA000PQ",
			"FOUSA02TY5",
			50061000,
			0.04493826310961819,
			2249654.3895305963,
			0,
			0,
			0.04493826310961819,
			2249654.3895305963
		],
		[
			"Fidelity Total International Index Fund",
			"FTIHX",
			"FS0000CFDT",
			"F00000WZVM",
			46525000,
			0.0968680146355377,
			4506784.380918391,
			0,
			0,
			0.0968680146355377,
			4506784.380918391
		],
		[
			"Fidelity DFA US Sustainability Core 1",
			"DFSIX",
			"FSUSA08HSM",
			"FOUSA06M6P",
			42511000,
			0.031201932515479876,
			1326425.353165565,
			0,
			0,
			0.031201932515479876,
			1326425.353165565
		],
		[
			"Fidelity Managed Income Portfolio II Class 1 Fund",
			"~",
			"~",
			"~",
			39361000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"MetWest Total Return Bond Fund CIT - Class D",
			"MWTSX",
			"FSUSA003M1",
			"F00000MN7G",
			39171000,
			0,
			0,
			0.01732500428117021,
			678637.7426977183,
			0.01732500428117021,
			678637.7426977183
		],
		[
			"Fidelity Extended Market Index Fund",
			"FSMAX",
			"FSUSA003EG",
			"F00000MJRH",
			28697000,
			0.06751712557082101,
			1937538.9525058507,
			0,
			0,
			0.06751712557082101,
			1937538.9525058507
		],
		[
			"American Funds New Perspective Fund Class R6",
			"RNPGX",
			"FSUSA001SL",
			"F000002PIY",
			28386000,
			0.05955341430550321,
			1690483.2184760142,
			0,
			0,
			0.05955341430550321,
			1690483.2184760142
		],
		[
			"Fidelity Capital and Income Fund",
			"FAGIX",
			"FSUSA000SV",
			"FOUSA00CGB",
			21099000,
			0.016653687047167024,
			351376.14300817705,
			0.12982560385681266,
			2739190.41577489,
			0.14647929090397968,
			3090566.5587830674
		],
		[
			"Invesco Diversified Dividend Fund R5 Class",
			"DDFIX",
			"FSUSA00E33",
			"FOUSA05CM2",
			21013000,
			0.14534615298407816,
			3054158.712654434,
			0,
			0,
			0.14534615298407816,
			3054158.712654434
		],
		[
			"Vanguard Target Retirement 2065 Fund",
			"VLXVX",
			"FS0000D17J",
			"F00000YE51",
			19680000,
			0.08019566005615357,
			1578250.5899051023,
			0.0031660668875217067,
			62308.19634642719,
			0.08336172694367527,
			1640558.7862515294
		],
		[
			"Vanguard Target Retirement Income",
			"VTINX",
			"FSUSA04BYK",
			"FOUSA04B9B",
			16070000,
			0.02420873589822837,
			389034.3858845299,
			0.016543257559609954,
			265850.148982932,
			0.04075199345783832,
			654884.5348674619
		],
		[
			"Vanguard Target Retirement 2015 Fund",
			"~",
			"~",
			"FOUSA04B97",
			15852000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		],
		[
			"American Beacon Small Cap Value Fund",
			"AVFIX",
			"FSUSA004F4",
			"FOUSA009MW",
			11228000,
			0.09657446583105811,
			1084338.1023511204,
			0,
			0,
			0.09657446583105811,
			1084338.1023511204
		],
		[
			"Vanguard Inflation-Protected Securities Fund Institutional Shares",
			"VIPIX",
			"FSUSA004EW",
			"FOUSA04BL6",
			8259000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		[
			"Fidelity U.S. Bond Index Fund",
			"FXNAX",
			"FSUSA000VD",
			"F00000LZX3",
			7310000,
			0,
			0,
			0.03886106613218048,
			284074.3934262393,
			0.03886106613218048,
			284074.3934262393
		],
		[
			"Vanguard Total International Bond Index Fund",
			"VTABX",
			"FS0000901Z",
			"F00000NBIL",
			1416000,
			0,
			0,
			0.011645588703408939,
			16490.15360402706,
			0.011645588703408939,
			16490.15360402706
		],
		[
			"Fidelity Government Money Market Fund",
			"~",
			"~",
			"~",
			309000,
			"~",
			"~",
			"~",
			"~",
			"~",
			"~"
		]
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/PlanOptionsBonds.json
// module id = 1009
// module chunks = 0